import React, { useState, useEffect, useRef } from 'react';
import api, { auth as authApi, users as usersApiCore, demandes as demandesApi, tourManager as tourManagerApi, parking as parkingApi, receptionVip as receptionVipApi } from '../services/api';
import usersApi from '../services/users';
import referentielsApi from '../services/referentiels';
import concessionsApi from '../services/concessions';
import sujetsApi from '../services/sujets';
import './Dashboard.css';
import Litiges from './Litiges';
import PlanningAtelier from './PlanningAtelier';
import permissionsApi from '../services/permissions';
import statutsLitigesApi from '../services/statuts-litiges';
import statutsParkingApi from '../services/statuts-parking';
import statutsGarantieApi from '../services/statuts-garantie';
import motifsGarantieApi from '../services/motifs-garantie';
import Permissions from './Permissions';
import RolesPlanning from './RolesPlanning';
import EntitesJuridiques from './EntitesJuridiques';
import Plaques from './Plaques';
import WebappAccess from './WebappAccess';
import LeadsView from './LeadsView';
import CampagnesMediasAdmin from './CampagnesMediasAdmin';
import VehiculesCourtoisie from './VehiculesCourtoisie';
import DashboardHome from './DashboardHome';
import LeadsServices from './LeadsServices';
import AtelierView from './AtelierView';
import GestionParking from './GestionParking';
import ReceptionVip from './ReceptionVip';
import FileVirtuelleMagasin from './FileVirtuelleMagasin';
import ReceptionClient from './ReceptionClient';
import Recouvrement from './Recouvrement';
import Encaissements from './Encaissements';
import CommandesVN from './CommandesVN';
import TourManager from './TourManager';
import Satisfaction from './Satisfaction';
import TourVehicule from './TourVehicule';
import ORENCours from './ORENCours';
import StockVO from './StockVO';
import DynamicDB from './DynamicDB';
import VentesDB from './VentesDB';
import MecaplanningImportPanel from './MecaplanningImportPanel';
import JDMAAvis from './JDMAAvis';
import JDMAPage from './JDMAPage';
import GoogleAvis from './GoogleAvis';
import GoogleAnalytics from './GoogleAnalytics';
import GoogleAds from './GoogleAds';
import SearchConsole from './SearchConsole';
import MarketingHub from './MarketingHub';
import RelancesAtelier from './RelancesAtelier';
import VehiculeModal from './VehiculeModal';
import Takata from './Takata';
import Garantie from './Garantie';
import Workflows from './Workflows';
import WorkflowsPanel from './WorkflowsPanel';
import GestionCommerciale from './GestionCommerciale';
import FacturesServices from './FacturesServices';
import SuiviPiecesAtelier from './SuiviPiecesAtelier';
import ConfigSFTP from './ConfigSFTP';
import SyncConfig from './SyncConfig';
import ConfigSMS from './ConfigSMS';
import ConfigEmail from './ConfigEmail';
import ChatPanel from './ChatPanel';
import StampytVO from './StampytVO';
import StockVoSuivi from './StockVoSuivi';
import SupportInnovation from './SupportInnovation';
import Fil from './fil/Fil';
import filApi from '../services/fil';
import RecherchePdf from './RecherchePdf';
import LiassesFiscales from './LiassesFiscales';
import SecurityIP from './SecurityIP';
import KPIs from './KPIs';
import Forfaits from './Forfaits';
import ReportingAPV from './ReportingAPV';
import RingoverReporting from './RingoverReporting';
import ReportingFinancier from './ReportingFinancier';
import kpisApi from '../services/kpis';
import AILab from './AILab';
import AISearch from './AISearch';
import ESignature from './ESignature';
import ProspectionB2B from './ProspectionB2B';
import ProspectionPR from './ProspectionPR';
import LaboTools from './LaboTools';
import RGPDDashboard from './RGPDDashboard';
import VoiceAgent from './VoiceAgent';
import PortailComptesAdmin from './PortailComptesAdmin';
import NextlaneSearch from './NextlaneSearch';
import NextlaneOR from './NextlaneOR';
import NextlaneReportingAtelier from './NextlaneReportingAtelier';

/* ── Titres de pages : icône + libellé séparés ───────────────────────────── */
const PAGE_TITLES = {
  'home':                 { icon: '🏠', label: 'Tableau de bord' },
  'fil':                  { icon: '📰', label: 'Le Fil' },
  'workflows':            { icon: '🔀', label: 'Workflows' },
  'support-innovation':   { icon: '🛟', label: 'Support & Innovation' },
  'documents-pdf':        { icon: '📄', label: 'RAG' },
  'liasses-fiscales':     { icon: '🧾', label: 'Liasses fiscales' },
  'leads-services':       { icon: '💬', label: 'Demandes clients' },
  'planning':             { icon: '📅', label: 'Planning Atelier' },
  'leads':                { icon: '🌐', label: 'Leads Web' },
  'atelier':              { icon: '🔧', label: 'Suivi Atelier VN/VO' },
  'vehicules-courtoisie': { icon: '🚗', label: 'Véhicules Courtoisie' },
  'litiges':              { icon: '⚖️', label: 'Litiges' },
  'parking':              { icon: '🅿️', label: 'Gestion Parking' },
  'reception-vip':        { icon: '🏁', label: 'Réception VIP' },
  'file-virtuelle-magasin': { icon: '🛎️', label: 'File Virtuelle Magasin' },
  'reception-client':     { icon: '📥', label: 'Réception Client' },
  'recouvrement':         { icon: '💳', label: 'Recouvrement' },
  'encaissements':        { icon: '💶', label: 'Encaissements' },
  'commandes-vn':         { icon: '🚢', label: 'Commandes VN' },
  'tour-manager':         { icon: '👁️', label: 'Tour du Manager' },
  'tour-vehicule':        { icon: '🚗', label: 'Tour du véhicule' },
  'or-en-cours':          { icon: '🔩', label: 'OR en cours' },
  'stock-vo':             { icon: '🛢️', label: 'Stock VO' },
  'mecaplanning':         { icon: '🛢️', label: 'Données Mécaplanning' },
  'dtc-atelier':          { icon: '🛢️', label: 'DTC - Entrées Atelier' },
  'users':                { icon: '👥', label: 'Utilisateurs' },
  'referentiels':         { icon: '📋', label: 'Référentiels' },
  'concessions':          { icon: '🏢', label: 'Concessions' },
  'permissions':          { icon: '🔐', label: 'Permissions' },
  'garantie':             { icon: '📋', label: 'Garantie' },
  'administration':       { icon: '⚙️', label: 'Administration' },
  'bases-donnees':        { icon: '🛢️', label: 'Bases de données' },
  'rgpd':                 { icon: '🔒', label: 'Tableau de bord RGPD' },
  'jdma':                 { icon: '⭐', label: 'JDMA — Avis clients' },
  'gmb-reviews':          { icon: '🌟', label: 'Google My Business (Avis)' },
  'google-analytics':     { icon: '📊', label: 'Google Analytics' },
  'google-ads':           { icon: '📈', label: 'Google Ads' },
  'search-console':       { icon: '🔎', label: 'Google Search Console' },
  'marketing-hub':        { icon: '🛰️', label: 'Supervision M&D' },
  'relances-atelier':     { icon: '🔔', label: 'Relances Atelier' },
  'retours-prospects':    { icon: '😊', label: 'Satisfaction clients' },
  'stampyt':              { icon: '📸', label: 'Photos VO' },
  'stock-vo':             { icon: '📦', label: 'Stock VO' },
  'takata':               { icon: <svg viewBox="0 0 64 64" width="20" height="20" fill="none" stroke="#8B6914" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="16" cy="11" r="7"/><path d="M9 23c-3 6-5 13-5 21h10l2-15"/><path d="M23 23c0 4 1 9 1 13"/><circle cx="48" cy="30" r="13" fill="#D4A84B" fillOpacity=".25" stroke="#8B6914" strokeWidth="3"/></svg>, label: 'Takata' },
  'pieces-atelier':       { icon: '🔧', label: 'Suivi Pièces Atelier' },
  'securite-ip':          { icon: '🛡️', label: 'Sécurité IP' },
  'kpis':                 { icon: '📊', label: 'KPIs' },
  'ai-lab':               { icon: '🧪', label: 'Labo IA' },
  'ai-search':            { icon: '✨', label: 'Assistant IA' },
  'e-signature':          { icon: '✍️', label: 'E-Signature' },
  'prospection-b2b':      { icon: '🏢', label: 'Prospection B2B' },
  'prospection-pr':       { icon: '🔧', label: 'Prospection PR' },
  'forfaits':             { icon: '📋', label: 'Forfaits APV' },
  'reporting-apv':        { icon: '📊', label: 'Reporting APV' },
  'reporting-financier':  { icon: '💰', label: 'Reporting Financier' },
  'ringover-reporting':   { icon: '📞', label: 'Reporting Ringover' },
  'labo-tools':           { icon: '🧰', label: 'Labo Tools' },
  'webapp':               { icon: '📱', label: 'Webapp Inventaire' },
  'gestion-commerciale':  { icon: '📂', label: 'Gestion Commerciale' },
  'campagnes-medias':     { icon: '📢', label: 'Campagnes médias' },
  'nextlane-or':          { icon: '🔧', label: 'OR Atelier (Nextlane)' },
  'nextlane-reporting':   { icon: '📊', label: 'Reporting Atelier (Nextlane)' },
  'voice-agent':          { icon: '🎙️', label: 'Agent vocal IA' },
};

function Dashboard({ user, onLogout }) {
  const [users, setUsers] = useState([]);
  const [responsables, setResponsables] = useState([]);
  const [marques, setMarques] = useState([]);
  const [modeles, setModeles] = useState([]);
  const [concessions, setConcessions] = useState([]);
  // Plaques (périmètres régionaux) : servent aux fiches concession et utilisateur.
  const [plaques, setPlaques] = useState([]);
  const [fonctionsRef, setFonctionsRef] = useState([]);
  const [sujets, setSujets] = useState([]);
  // Lien direct vers un ticket : ?page=support-innovation&ticket=<id>. Lu une seule
  // fois au montage (lazy initializer) — l'URL est ensuite gérée via history.replaceState
  // pour ne pas dépendre d'un routeur (le projet n'en utilise pas).
  const [view, setView] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const page = params.get('page');
    return (page && PAGE_TITLES[page]) ? page : 'home';
  });
  const [initialTicketId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('ticket');
    return t && /^\d+$/.test(t) ? Number(t) : null;
  });
  const [initialDossierId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const d = params.get('dossier');
    return d && /^\d+$/.test(d) ? Number(d) : null;
  });
  // Garde l'URL synchronisée avec la page affichée. Les paramètres `ticket` et
  // `dossier` ne sont conservés que si on reste sur leur page respective.
  useEffect(() => {
    if (view === 'home') {
      window.history.replaceState({}, '', window.location.pathname);
      return;
    }
    const current = new URLSearchParams(window.location.search);
    const ticket = view === 'support-innovation' ? current.get('ticket') : null;
    const dossier = view === 'takata' ? current.get('dossier') : null;
    const next = new URLSearchParams();
    next.set('page', view);
    if (ticket) next.set('ticket', ticket);
    if (dossier) next.set('dossier', dossier);
    window.history.replaceState({}, '', `${window.location.pathname}?${next.toString()}`);
  }, [view]);
  const [adminTab, setAdminTab] = useState('users');
  const [loading, setLoading] = useState(true);
  const [showUserModal, setShowUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [showImportUsers, setShowImportUsers] = useState(false);
  const [importUsersRows, setImportUsersRows] = useState([]);
  const [importUsersLoading, setImportUsersLoading] = useState(false);
  const [importUsersResult, setImportUsersResult] = useState(null);
  const importUsersFileRef = useRef(null);
  const [showConcessionModal, setShowConcessionModal] = useState(false);
  const [editingConcession, setEditingConcession] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(
    () => localStorage.getItem('sidebarOpen') === 'true'
  );
  const [sectionsOpen, setSectionsOpen] = useState(() => {
    const defaults = { gestion: true, bases: false, administration: false, marketing: true, atelier: true, reporting: true, relationClients: true, commerceVnVo: true, utilitaires: true, pieces: true };
    try { return { ...defaults, ...(JSON.parse(localStorage.getItem('sectionsOpen')) || {}) }; }
    catch { return defaults; }
  });
  const toggleSection = (key) => {
    setSectionsOpen(prev => {
      const next = { ...prev, [key]: !prev[key] };
      localStorage.setItem('sectionsOpen', JSON.stringify(next));
      return next;
    });
  };
  const [canAccessLitiges, setCanAccessLitiges] = useState(false);
  const [statutsLitiges, setStatutsLitiges] = useState([]);
  const [favoritePage, setFavoritePage] = useState(null);
  const [canAccessHome, setCanAccessHome] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [vehiculeSearch, setVehiculeSearch] = useState('');
  const [vehiculeModalImmat, setVehiculeModalImmat] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchPopoverPos, setSearchPopoverPos] = useState({ top: 0, left: 0 });
  const searchBtnRef = useRef(null);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(null);

  const sidebarRef = useRef(null);
  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (!sidebar) return;
    const ro = new ResizeObserver(() => {
      document.documentElement.style.setProperty(
        '--sidebar-open-width',
        `${sidebar.offsetWidth}px`
      );
    });
    ro.observe(sidebar);
    return () => ro.disconnect();
  }, []);

  // ── Chat IA ──
  const [chatOpen, setChatOpen] = useState(false);
  const [chatIAEnabled, setChatIAEnabled] = useState(false);

  // ── Header action — boutons affichés dans le header, renseignés par chaque page ──
  // Format : { primary: { label, onClick }, secondary: [{ label, onClick }, ...] }
  const [headerAction, setHeaderAction] = useState(null);
  // Reset synchrone au changement de vue (avant le rendu du nouveau composant)
  const prevView = useRef(view);
  if (view !== prevView.current) {
    prevView.current = view;
    if (headerAction !== null) setHeaderAction(null);
  }

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('crm-dark') === '1');
  useEffect(() => {
    localStorage.setItem('crm-dark', darkMode ? '1' : '0');
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  // ── Voir comme ──
  const [viewAs, setViewAs] = useState(null); // { role, concession_id, concession_nom, user_id?, nom?, prenom? }
  const [showViewAsPanel, setShowViewAsPanel] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [viewAsForm, setViewAsForm] = useState({ user_id: '', nom: '', prenom: '', role: 'operateur', concession_id: '', concession_nom: '' });

  // ── Sélecteur global de concession (super-admin / téléopérateur) ──
  const [globalConcessionId, setGlobalConcessionId] = useState(
    () => localStorage.getItem('crm-global-concession') || ''
  );
  const handleGlobalConcessionChange = (val) => {
    setGlobalConcessionId(val);
    if (val) localStorage.setItem('crm-global-concession', val);
    else localStorage.removeItem('crm-global-concession');
  };
  // Une concession mémorisée qui n'est plus dans la liste (désactivée, ou hors
  // plaque du téléopérateur) partirait quand même en X-Concession-Id sur chaque
  // appel, et l'API la refuserait : on l'oublie dès que la liste est connue.
  useEffect(() => {
    if (!globalConcessionId || concessions.length === 0) return;
    if (!concessions.some(c => c.id === parseInt(globalConcessionId, 10))) handleGlobalConcessionChange('');
  }, [concessions, globalConcessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Utilisateur effectif (simulé quand "Voir comme" ou concession globale active)
  const globalConcession = globalConcessionId ? concessions.find(c => c.id === parseInt(globalConcessionId)) : null;
  const effectiveUser = viewAs
    ? {
        ...user,
        role:          viewAs.role,
        concession_id: viewAs.concession_id || null,
        concession_nom:viewAs.concession_nom || null,
        nom:           viewAs.nom   || user.nom,
        prenom:        viewAs.prenom || user.prenom,
      }
    : globalConcession
      ? { ...user, concession_id: globalConcession.id, concession_nom: globalConcession.nom }
      : user;

  // Fonction helper pour vérifier accès à une page
  // ⚠️ Plus de court-circuit super-admin ici : c'est le serveur qui tranche,
  // pour qu'une page masquée sur son compte (Administration ▸ Permissions)
  // disparaisse vraiment de son menu.
  const checkPageAccess = async (pageId) => {
    try {
      const response = await permissionsApi.checkAccess(pageId);
      return response.data.hasAccess;
    } catch (error) {
      return false;
    }
  };

  // Fonction helper pour trouver la première page accessible
  const findFirstAccessiblePage = async () => {
    if (user.role === 'super-admin') return 'home';

    const pages = ['home', 'leads-services', 'litiges', 'atelier', 'leads', 'parking'];
    for (const page of pages) {
      const hasAccess = await checkPageAccess(page);
      if (hasAccess) return page;
    }
    return 'no-access';
  };

  // Toggle favori
  const toggleFavorite = (pageId) => {
    if (favoritePage === pageId) {
      localStorage.removeItem(`favorite_page_${user.id}`);
      setFavoritePage(null);
    } else {
      localStorage.setItem(`favorite_page_${user.id}`, pageId);
      setFavoritePage(pageId);
    }
  };

  // Persister l'état ouvert/fermé du menu
  useEffect(() => {
    localStorage.setItem('sidebarOpen', sidebarOpen);
  }, [sidebarOpen]);

  // Mobile : fermer le drawer dès qu'on navigue vers une autre page.
  // Gardé par matchMedia pour ne JAMAIS fermer la sidebar épinglée sur desktop.
  useEffect(() => {
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches) {
      setSidebarOpen(false);
    }
  }, [view]);

  // Mobile : verrouiller le scroll du body quand le drawer est ouvert.
  useEffect(() => {
    const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
    document.body.style.overflow = '';
  }, [sidebarOpen]);

  // ========== useEffect PRINCIPAL - Au démarrage ==========
  useEffect(() => {
    const init = async () => {
      // 1. Charger les données de base
      loadReferentiels();
      loadSujets();
      checkHomeAccess();
      checkLitigesAccess();
      checkAtelierAccess();
      checkLeadsAccess();
      checkCampagnesMediasAccess();
      checkParkingAccess();
      checkReceptionVipAccess();
      checkFileMagasinAccess();
      checkReceptionClientAccess();
      checkRecouvrementAccess();
      checkTourManagerAccess();
      checkTourVehiculeAccess();
      checkOrEnCoursAccess();
      checkLeadsServicesAccess();
      checkWorkflowsAccess();
      checkTakataAccess();
      checkForfaitsAccess();
      checkGarantieAccess();
      checkGestionCommercialeAccess();
      checkEncaissementsAccess();
      checkCommandesVnAccess();
      checkPiecesAtelierAccess();
      checkCourtoisieAccess();
      checkPlanningAccess();
      checkStampytAccess();
      checkStockVoAccess();
  checkKpisAccess();
      checkRingoverReportingAccess();
      checkReportingFinancierAccess();
      checkAISearchAccess();
      checkESignatureAccess();
      checkProspectionB2BAccess();
      checkProspectionPRAccess();
      checkJdmaAccess();
      checkGmbAccess();
      checkGoogleAnalyticsAccess();
      checkGoogleAdsAccess();
      checkSearchConsoleAccess();
      checkMarketingHubAccess();
      checkSuiviRevisionsAccess();
      checkRetoursProspectsAccess();
      loadMyDemandesCount();
      loadMyTourCount();
      loadMyParkingCount();
      loadVipCount();
      loadFilEtat();

      // Vérifier si le Chat IA est activé (super-admin uniquement)
      if (user.role === 'super-admin') {
        try {
          const token = localStorage.getItem('token');
          const API_URL = process.env.REACT_APP_API_URL || '';
          const r = await fetch(`${API_URL}/api/ai/chat/status`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (r.ok) {
            const d = await r.json();
            setChatIAEnabled(d.enabled !== false);
          }
        } catch { /* ignore */ }
      }

      if (user.role === 'super-admin' || user.role === 'admin') {
        loadUsers();
      }

      if (user.role === 'teleoperateur' || user.role === 'super-admin' || user.role === 'admin') {
        await loadConcessions();
      }
      loadFonctionsRef();

      // 2. Gérer la page favorite et redirection intelligente
      // Si l'URL contient ?page=, c'est un lien direct partagé — on ne redirige pas.
      const urlPage = new URLSearchParams(window.location.search).get('page');
      const savedFavorite = urlPage ? null : localStorage.getItem(`favorite_page_${user.id}`);

      if (savedFavorite) {
        // Vérifier si l'utilisateur a encore accès à cette page
        if (savedFavorite === 'home') {
          const hasAccess = await checkPageAccess('home');
          if (hasAccess || user.role === 'super-admin') {
            setView(savedFavorite);
            setFavoritePage(savedFavorite);
          } else {
            // Favori inaccessible -> redirection
            const firstAccessiblePage = await findFirstAccessiblePage();
            setView(firstAccessiblePage);
          }
        } else {
          // Pour les autres pages, on fait confiance au favori
          setView(savedFavorite);
          setFavoritePage(savedFavorite);
        }
      } else if (!urlPage) {
        // Pas de favori et pas de lien direct -> Trouver première page accessible
        const firstAccessiblePage = await findFirstAccessiblePage();
        setView(firstAccessiblePage);
      }

      // 3. Fin du chargement
      setLoading(false);
    };

    init();
  }, [user.id]);

  // Navigation programmatique cross-composants : un composant peut demander
  // l'ouverture d'une autre page (ex. LeadsView → leads-services après
  // transformation d'un lead en demande client).
  useEffect(() => {
    const handler = (e) => {
      const targetPage = e?.detail?.page;
      if (targetPage) setView(targetPage);
    };
    window.addEventListener('crm-navigate', handler);
    return () => window.removeEventListener('crm-navigate', handler);
  }, []);

  const checkHomeAccess = async () => {
    try {
      const response = await permissionsApi.checkAccess('home');
      setCanAccessHome(response.data.hasAccess);
    } catch (error) {
      setCanAccessHome(false);
    }
  };

  const checkLitigesAccess = async () => {
    try {
      const response = await permissionsApi.checkAccess('litiges');
      setCanAccessLitiges(response.data.hasAccess);
    } catch (error) {
      setCanAccessLitiges(false);
    }
  };

  const [canAccessAtelier, setCanAccessAtelier] = useState(false);

const checkAtelierAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('atelier');
    setCanAccessAtelier(response.data.hasAccess);
  } catch (error) {
    setCanAccessAtelier(false);
  }
};

const [canAccessLeads, setCanAccessLeads] = useState(false);
// peut_supprimer / peut_modifier effectifs sur la page Leads Web (super-admin → true ; sinon flags de permissions_pages)
const [canDeleteLeads, setCanDeleteLeads]   = useState(false);
const [canModifyLeads, setCanModifyLeads]   = useState(false);

const checkLeadsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('leads');
    setCanAccessLeads(response.data.hasAccess);
    setCanDeleteLeads(!!response.data.permissions?.peut_supprimer);
    setCanModifyLeads(!!response.data.permissions?.peut_modifier);
  } catch (error) {
    setCanAccessLeads(false);
    setCanDeleteLeads(false);
    setCanModifyLeads(false);
  }
};

const [canAccessCampagnesMedias, setCanAccessCampagnesMedias] = useState(false);
const checkCampagnesMediasAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('campagnes-medias');
    setCanAccessCampagnesMedias(response.data.hasAccess);
  } catch (error) {
    setCanAccessCampagnesMedias(false);
  }
};

const [canAccessParking, setCanAccessParking] = useState(false);
// peut_supprimer effectif sur la page Parking (super-admin → true ; sinon flag
// permissions_pages). Sert à ouvrir le bloc d'actions groupées (suppression /
// archivage / statut) à un opérateur explicitement habilité (ex. GUEPIN).
const [canDeleteParking, setCanDeleteParking] = useState(false);

const checkParkingAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('parking');
    setCanAccessParking(response.data.hasAccess);
    setCanDeleteParking(!!response.data.permissions?.peut_supprimer);
  } catch (error) {
    setCanAccessParking(false);
    setCanDeleteParking(false);
  }
};

const [canAccessReceptionVip,    setCanAccessReceptionVip]    = useState(false);
const [canAccessReceptionClient, setCanAccessReceptionClient] = useState(false);
const [canAccessRecouvrement, setCanAccessRecouvrement] = useState(false);
const [canAccessFileMagasin, setCanAccessFileMagasin] = useState(false);

const checkReceptionVipAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('reception-vip');
    setCanAccessReceptionVip(response.data.hasAccess);
  } catch (error) {
    setCanAccessReceptionVip(false);
  }
};

const checkFileMagasinAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('file-virtuelle-magasin');
    setCanAccessFileMagasin(response.data.hasAccess);
  } catch (error) {
    setCanAccessFileMagasin(false);
  }
};

const checkReceptionClientAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('reception-client');
    setCanAccessReceptionClient(response.data.hasAccess);
  } catch (error) {
    setCanAccessReceptionClient(false);
  }
};

const checkRecouvrementAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('recouvrement');
    setCanAccessRecouvrement(response.data.hasAccess);
  } catch (error) {
    setCanAccessRecouvrement(false);
  }
};

const [canAccessTourManager, setCanAccessTourManager] = useState(false);
const [canAccessOrEnCours,   setCanAccessOrEnCours]   = useState(false);
const [canAccessTourVehicule, setCanAccessTourVehicule] = useState(false);

const checkTourManagerAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('tour-manager');
    setCanAccessTourManager(response.data.hasAccess);
  } catch (error) {
    setCanAccessTourManager(false);
  }
};

const checkTourVehiculeAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('tour-vehicule');
    setCanAccessTourVehicule(response.data.hasAccess);
  } catch (error) {
    setCanAccessTourVehicule(false);
  }
};

const checkOrEnCoursAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('or-en-cours');
    setCanAccessOrEnCours(response.data.hasAccess);
  } catch (error) {
    setCanAccessOrEnCours(false);
  }
};

const [canAccessLeadsServices, setCanAccessLeadsServices] = useState(false);
const [canAccessWorkflows, setCanAccessWorkflows] = useState(false);
const [wfPanelOpen, setWfPanelOpen] = useState(false);
const [canAccessTakata, setCanAccessTakata] = useState(false);
const [canAccessForfaits, setCanAccessForfaits] = useState(false);
const [canAccessGarantie, setCanAccessGarantie] = useState(false);
const [canAccessGestionCommerciale, setCanAccessGestionCommerciale] = useState(false);
const [canAccessPiecesAtelier, setCanAccessPiecesAtelier] = useState(false);
const [canAccessCourtoisie, setCanAccessCourtoisie] = useState(false);
const [canAccessPlanning, setCanAccessPlanning] = useState(false);
const [canAccessStampyt, setCanAccessStampyt] = useState(false);
const [canAccessStockVo, setCanAccessStockVo] = useState(false);
const [canAccessKpis, setCanAccessKpis] = useState(false);
const [canAccessRingoverReporting, setCanAccessRingoverReporting] = useState(false);
const [canAccessReportingFinancier, setCanAccessReportingFinancier] = useState(false);
const [canAccessAISearch, setCanAccessAISearch] = useState(false);
const [canAccessESignature, setCanAccessESignature] = useState(false);
const [canAccessProspectionB2B, setCanAccessProspectionB2B] = useState(false);
const [canAccessProspectionPR, setCanAccessProspectionPR] = useState(false);
const [canAccessJdma, setCanAccessJdma] = useState(false);
const [canAccessGmb, setCanAccessGmb] = useState(false);
const [canAccessGoogleAnalytics, setCanAccessGoogleAnalytics] = useState(false);
const [canAccessGoogleAds, setCanAccessGoogleAds] = useState(false);
const [canAccessSearchConsole, setCanAccessSearchConsole] = useState(false);
const [canAccessMarketingHub, setCanAccessMarketingHub] = useState(false);
const [canAccessSuiviRevisions, setCanAccessSuiviRevisions] = useState(false);
const [canAccessRetoursProspects, setCanAccessRetoursProspects] = useState(false);
const [myDemandesCount, setMyDemandesCount] = useState(0);
const [myTourCount, setMyTourCount]         = useState(0);
const [myParkingCount, setMyParkingCount]   = useState(0);
const [vipCount, setVipCount]               = useState(0);
// Le Fil : onglet visible si le drapeau est actif (toujours pour les
// super-admins, qui voient un bandeau « désactivé ») ; pastille = publications
// visibles depuis la dernière visite.
const [filEtat, setFilEtat] = useState({ enabled: false, nonLus: 0 });

// Pages masquées sur MON compte (super-admin uniquement, cf. Administration ▸
// Permissions). La quasi-totalité du menu se règle déjà par les drapeaux
// canAccessXxx, qui interrogent le serveur et tiennent donc compte du masquage.
// Cet état ne sert qu'aux rares entrées conditionnées au SEUL rôle — Le Fil, qui
// s'affiche pour un super-admin même quand le drapeau global est éteint.
const [pagesMasquees, setPagesMasquees] = useState(() => new Set());
useEffect(() => {
  if (user.role !== 'super-admin') return;
  permissionsApi.getMyPages()
    .then(r => setPagesMasquees(new Set(r.data?.masquees || [])))
    .catch(() => setPagesMasquees(new Set()));
}, [user.role]);
const estMasquee = (pageId) => pagesMasquees.has(pageId);

const loadMyDemandesCount = async (targetUserId) => {
  if (effectiveUser.role !== 'operateur') return;
  try {
    const res = await demandesApi.getMyCount(targetUserId);
    setMyDemandesCount(res.data.count);
  } catch {
    // silencieux
  }
};

const loadMyTourCount = async (targetUserId) => {
  try {
    const res = await tourManagerApi.getMyCount(targetUserId);
    setMyTourCount(res.data.count || 0);
  } catch {
    // silencieux
  }
};

const loadMyParkingCount = async (targetUserId) => {
  try {
    const res = await parkingApi.getMyCount(targetUserId);
    setMyParkingCount(res.data.count || 0);
  } catch (e) {
    console.error('[parking count] erreur', e);
  }
};

const loadFilEtat = async () => {
  try {
    const res = await filApi.getNonLus();
    setFilEtat({ enabled: !!res.data.enabled, nonLus: res.data.nonLus || 0 });
  } catch {
    // silencieux
  }
};

const loadVipCount = async () => {
  if (!canAccessReceptionVip) return;
  try {
    const res = await receptionVipApi.getCount();
    setVipCount(res.data.count || 0);
  } catch {
    // silencieux
  }
};

// peut_supprimer effectif sur la page Demandes Clients
const [canDeleteDemandes, setCanDeleteDemandes] = useState(false);

const checkLeadsServicesAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('leads-services');
    setCanAccessLeadsServices(response.data.hasAccess);
    setCanDeleteDemandes(!!response.data.permissions?.peut_supprimer);
  } catch (error) {
    setCanAccessLeadsServices(false);
    setCanDeleteDemandes(false);
  }
};

const checkWorkflowsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('workflows');
    setCanAccessWorkflows(response.data.hasAccess);
  } catch (error) {
    setCanAccessWorkflows(false);
  }
};

const checkTakataAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('takata');
    setCanAccessTakata(response.data.hasAccess);
  } catch (error) {
    setCanAccessTakata(false);
  }
};

const checkForfaitsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('forfaits');
    setCanAccessForfaits(response.data.hasAccess);
  } catch (error) {
    setCanAccessForfaits(false);
  }
};

const checkGarantieAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('garantie');
    setCanAccessGarantie(response.data.hasAccess);
  } catch (error) {
    setCanAccessGarantie(false);
  }
};

const [canAccessCommandesVn, setCanAccessCommandesVn] = useState(false);
const checkCommandesVnAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('commandes-vn');
    setCanAccessCommandesVn(response.data.hasAccess);
  } catch (error) {
    setCanAccessCommandesVn(false);
  }
};

const [canAccessEncaissements, setCanAccessEncaissements] = useState(false);
const checkEncaissementsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('encaissements');
    setCanAccessEncaissements(response.data.hasAccess);
  } catch (error) {
    setCanAccessEncaissements(false);
  }
};

const checkGestionCommercialeAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('gestion-commerciale');
    setCanAccessGestionCommerciale(response.data.hasAccess);
  } catch (error) {
    setCanAccessGestionCommerciale(false);
  }
};

const checkPiecesAtelierAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('pieces-atelier');
    setCanAccessPiecesAtelier(response.data.hasAccess);
  } catch (error) {
    setCanAccessPiecesAtelier(false);
  }
};

const checkCourtoisieAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('vehicules-courtoisie');
    setCanAccessCourtoisie(response.data.hasAccess);
  } catch (error) {
    setCanAccessCourtoisie(false);
  }
};

const checkPlanningAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('planning');
    setCanAccessPlanning(response.data.hasAccess);
  } catch (error) {
    setCanAccessPlanning(false);
  }
};

const checkStampytAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('stampyt');
    setCanAccessStampyt(response.data.hasAccess);
  } catch (error) {
    setCanAccessStampyt(false);
  }
};

const checkStockVoAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('stock-vo');
    setCanAccessStockVo(response.data.hasAccess);
  } catch (error) {
    setCanAccessStockVo(false);
  }
};

const checkKpisAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('kpis');
    setCanAccessKpis(response.data.hasAccess);
  } catch (error) {
    setCanAccessKpis(false);
  }
};

const checkRingoverReportingAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('ringover-reporting');
    setCanAccessRingoverReporting(response.data.hasAccess);
  } catch (error) {
    setCanAccessRingoverReporting(false);
  }
};

const checkReportingFinancierAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('reporting-financier');
    setCanAccessReportingFinancier(response.data.hasAccess);
  } catch (error) {
    setCanAccessReportingFinancier(false);
  }
};

const checkAISearchAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('ai-search');
    setCanAccessAISearch(response.data.hasAccess);
  } catch (error) {
    setCanAccessAISearch(false);
  }
};


const checkESignatureAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('e-signature');
    setCanAccessESignature(response.data.hasAccess);
  } catch (error) {
    setCanAccessESignature(false);
  }
};

const checkProspectionB2BAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('prospection-b2b');
    setCanAccessProspectionB2B(response.data.hasAccess);
  } catch (error) {
    setCanAccessProspectionB2B(false);
  }
};

const checkProspectionPRAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('prospection-pr');
    setCanAccessProspectionPR(response.data.hasAccess);
  } catch (error) {
    setCanAccessProspectionPR(false);
  }
};

const checkJdmaAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('jdma');
    setCanAccessJdma(response.data.hasAccess);
  } catch (error) {
    setCanAccessJdma(false);
  }
};

const checkGmbAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('gmb_reviews');
    setCanAccessGmb(response.data.hasAccess);
  } catch (error) {
    setCanAccessGmb(false);
  }
};

const checkGoogleAnalyticsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('google_analytics');
    setCanAccessGoogleAnalytics(response.data.hasAccess);
  } catch (error) {
    setCanAccessGoogleAnalytics(false);
  }
};

const checkSearchConsoleAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('search_console');
    setCanAccessSearchConsole(response.data.hasAccess);
  } catch (error) {
    setCanAccessSearchConsole(false);
  }
};

const checkGoogleAdsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('google_ads');
    setCanAccessGoogleAds(response.data.hasAccess);
  } catch (error) {
    setCanAccessGoogleAds(false);
  }
};

const checkMarketingHubAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('mkt_sites');
    setCanAccessMarketingHub(response.data.hasAccess);
  } catch (error) {
    setCanAccessMarketingHub(false);
  }
};

const checkSuiviRevisionsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('suivi_revisions');
    setCanAccessSuiviRevisions(response.data.hasAccess);
  } catch (error) {
    setCanAccessSuiviRevisions(false);
  }
};

const checkRetoursProspectsAccess = async () => {
  try {
    const response = await permissionsApi.checkAccess('retours_prospects');
    setCanAccessRetoursProspects(response.data.hasAccess);
  } catch (error) {
    setCanAccessRetoursProspects(false);
  }
};

// Recalcul des accès quand le mode "Voir comme" change
useEffect(() => {
  if (viewAs) {
    // En mode aperçu : on accorde tous les accès pour montrer le maximum visible
    setCanAccessHome(true);
    setCanAccessLitiges(true);
    setCanAccessAtelier(true);
    setCanAccessLeads(true);
    setCanAccessParking(true);
    setCanAccessReceptionVip(true);
    setCanAccessFileMagasin(true);
    setCanAccessReceptionClient(true);
    setCanAccessRecouvrement(true);
    setCanAccessTourManager(true);
    setCanAccessTourVehicule(true);
    setCanAccessOrEnCours(true);
    setCanAccessLeadsServices(true);
    setCanAccessWorkflows(true);
    setCanAccessTakata(true);
    setCanAccessForfaits(true);
    setCanAccessGarantie(true);
    setCanAccessPiecesAtelier(true);
    setCanAccessCourtoisie(true);
    setCanAccessPlanning(true);
    setCanAccessStampyt(true);
    setCanAccessStockVo(true);
    setCanAccessKpis(true);
    setCanAccessRingoverReporting(true);
    setCanAccessAISearch(true);
    setCanAccessESignature(true);
    setCanAccessProspectionB2B(true);
    setCanAccessProspectionPR(true);
    setCanAccessJdma(true);
    setCanAccessGmb(true);
    setCanAccessGoogleAnalytics(true);
    setCanAccessGoogleAds(true);
    setCanAccessSearchConsole(true);
    setCanAccessSuiviRevisions(true);
    setCanAccessRetoursProspects(true);
  } else {
    // Retour au mode normal : on recharge les vrais droits
    checkLitigesAccess();
    checkAtelierAccess();
    checkLeadsAccess();
    checkParkingAccess();
    checkReceptionVipAccess();
    checkFileMagasinAccess();
    checkReceptionClientAccess();
    checkRecouvrementAccess();
    checkTourManagerAccess();
    checkTourVehiculeAccess();
    checkOrEnCoursAccess();
    checkLeadsServicesAccess();
    checkWorkflowsAccess();
    checkTakataAccess();
    checkForfaitsAccess();
    checkGarantieAccess();
    checkGestionCommercialeAccess();
    checkEncaissementsAccess();
    checkCommandesVnAccess();
    checkPiecesAtelierAccess();
    checkCourtoisieAccess();
    checkPlanningAccess();
    checkStampytAccess();
    checkStockVoAccess();
    checkKpisAccess();
    checkRingoverReportingAccess();
    checkReportingFinancierAccess();
    checkAISearchAccess();
    checkESignatureAccess();
    checkProspectionB2BAccess();
    checkProspectionPRAccess();
    checkJdmaAccess();
    checkGmbAccess();
    checkGoogleAnalyticsAccess();
    checkGoogleAdsAccess();
    checkSearchConsoleAccess();
    checkMarketingHubAccess();
    checkSuiviRevisionsAccess();
    checkRetoursProspectsAccess();
  }
}, [viewAs]); // eslint-disable-line


  const loadReferentiels = async () => {
    try {
      const [respRes, marqRes, modRes] = await Promise.all([
        referentielsApi.getResponsables(),
        referentielsApi.getMarques(),
        referentielsApi.getModeles()
      ]);
      setResponsables(respRes.data.responsables);
      setMarques(marqRes.data.marques);
      setModeles(modRes.data.modeles);
    } catch (error) {
      console.error('Erreur chargement référentiels:', error);
    }
  };

  const loadSujets = async () => {
    try {
      const response = await sujetsApi.getAll();
      setSujets(response.data.sujets);
    } catch (error) {
      console.error('Erreur chargement sujets:', error);
    }
  };

  const loadUsers = async () => {
    if (user.role !== 'admin' && user.role !== 'super-admin') return;
    try {
      const response = await usersApi.getAll();
      setUsers(response.data.users);
    } catch (error) {
      console.error('Erreur chargement utilisateurs:', error);
    }
  };

  const loadConcessions = async () => {
    if (user.role !== 'super-admin' && user.role !== 'teleoperateur' && user.role !== 'admin') return;
    try {
      const response = await concessionsApi.getAll();
      setConcessions(response.data.concessions);
      try {
        const rp = await api.get('/plaques');
        setPlaques((rp.data?.plaques || []).filter(p => p.actif));
      } catch (e) { /* plaques indisponibles : les sélecteurs resteront vides */ }
    } catch (error) {
      console.error('Erreur chargement concessions:', error);
      alert('Erreur lors du chargement des concessions');
    }
  };

  const loadFonctionsRef = async () => {
    try {
      const res = await kpisApi.getFonctions();
      setFonctionsRef(res.data);
    } catch (error) {
      console.error('Erreur chargement fonctions:', error);
    }
  };

  useEffect(() => {
    if (view === 'administration') {
      if (adminTab === 'users') loadUsers();
      if (adminTab === 'concessions') loadConcessions();
    } else if (view === 'users') {
      loadUsers();
    } else if (view === 'concessions') {
      loadConcessions();
    } else if (view === 'home' && (user.role === 'super-admin') && concessions.length === 0) {
      loadConcessions();
    } else if (view === 'leads-services') {
      loadMyDemandesCount();
    } else if (view === 'parking') {
      loadMyParkingCount();
    } else if (view === 'reception-vip') {
      loadVipCount();
    }
  }, [view]);

  useEffect(() => {
    if (view === 'administration') {
      if (adminTab === 'users') loadUsers();
      if (adminTab === 'concessions') loadConcessions();
    }
  }, [adminTab]);

  // Recharge les compteurs quand le mode "Voir comme" change
  useEffect(() => {
    const uid = viewAs?.user_id ? parseInt(viewAs.user_id) : undefined;
    loadMyDemandesCount(uid);
    loadMyTourCount(uid);
    loadMyParkingCount(uid);
    loadVipCount();
  }, [viewAs]);

  // Le Fil : pastille remise à zéro quand la page marque « vu » (événement
  // émis par Fil.js), rafraîchie toutes les 60 s.
  useEffect(() => {
    const onVu = () => setFilEtat(e => ({ ...e, nonLus: 0 }));
    window.addEventListener('fil:vu', onVu);
    const t = setInterval(loadFilEtat, 60000);
    return () => { window.removeEventListener('fil:vu', onVu); clearInterval(t); };
  }, []); // eslint-disable-line

  // Polling vip count toutes les 30s
  useEffect(() => {
    if (!canAccessReceptionVip) return;
    const interval = setInterval(loadVipCount, 30000);
    return () => clearInterval(interval);
  }, [canAccessReceptionVip]);

  const handleSaveUser = async (userData) => {
    try {
      // Extraire la liste des concessions prestataire (non envoyée au PUT/POST users)
      const prestataireConcessionIds = userData.prestataire_concession_ids;
      delete userData.prestataire_concession_ids;

      // Responsable : géré par un endpoint dédié (table responsables), pas par
      // le PUT users — on l'extrait et on ne l'applique que s'il a changé.
      const isResponsable = userData.is_responsable;
      delete userData.is_responsable;

      let userId;
      if (editingUser) {
        await usersApi.update(editingUser.id, userData);
        userId = editingUser.id;
      } else {
        const res = await usersApi.create(userData);
        userId = res.data?.user?.id;
      }

      // Synchroniser les concessions associées si rôle prestataire
      if (userId && userData.role === 'prestataire' && Array.isArray(prestataireConcessionIds)) {
        await usersApi.setConcessions(userId, prestataireConcessionIds);
      }

      if (userId && typeof isResponsable === 'boolean' && isResponsable !== !!(editingUser?.is_responsable)) {
        await usersApi.toggleResponsable(userId, isResponsable);
        loadReferentiels();
      }

      loadUsers();
      setShowUserModal(false);
      setEditingUser(null);
    } catch (error) {
      console.error('Erreur sauvegarde utilisateur:', error);
      alert(error.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteUser = async (id) => {
    if (!window.confirm('Désactiver cet utilisateur ?')) return;
    try {
      await usersApi.delete(id);
      loadUsers();
    } catch (error) {
      console.error('Erreur suppression utilisateur:', error);
      alert(error.response?.data?.error || 'Erreur lors de la désactivation');
    }
  };

  const handleUpdateUserConcession = async (userId, concessionId) => {
    try {
      await usersApi.update(userId, { concession_id: concessionId || null });
      loadUsers();
    } catch (error) {
      console.error('Erreur mise à jour concession:', error);
      alert('Erreur lors de la mise à jour de la concession');
    }
  };

  const handleImportUsersFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const XLSX = await import('xlsx');
    const data = await file.arrayBuffer();
    const wb   = XLSX.read(data, { type: 'array' });
    const ws   = wb.Sheets[wb.SheetNames[0]];
    const raw  = XLSX.utils.sheet_to_json(ws, { header: 1 });

    const COL_MAP = {
      'nom': 'nom', 'NOM': 'nom',
      'prenom': 'prenom', 'prénom': 'prenom', 'PRENOM': 'prenom', 'PRÉNOM': 'prenom',
      'société': 'societe', 'societe': 'societe', 'SOCIÉTÉ': 'societe', 'SOCIETE': 'societe',
      'fonction': 'fonction', 'FONCTION': 'fonction',
    };

    if (raw.length < 2) return;
    const headers = raw[0].map(h => String(h || '').trim());
    const rows = raw.slice(1).map(row => {
      const obj = {};
      headers.forEach((h, i) => {
        const key = COL_MAP[h];
        if (key) obj[key] = String(row[i] || '').trim();
      });
      return obj;
    }).filter(r => r.nom || r.prenom);

    setImportUsersRows(rows);
    setImportUsersResult(null);
  };

  const handleImportUsers = async () => {
    setImportUsersLoading(true);
    try {
      const res = await usersApi.importUsers(importUsersRows);
      setImportUsersResult(res.data);
      loadUsers();
    } catch (err) {
      alert('Erreur lors de l\'import');
    } finally {
      setImportUsersLoading(false);
    }
  };

  const handleSaveConcession = async (concessionData) => {
    try {
      if (editingConcession) {
        await concessionsApi.update(editingConcession.id, concessionData);
      } else {
        await concessionsApi.create(concessionData);
      }
      loadConcessions();
      setShowConcessionModal(false);
      setEditingConcession(null);
    } catch (error) {
      console.error('Erreur sauvegarde concession:', error);
      alert(error.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteConcession = async (id) => {
    if (!window.confirm('Désactiver cette concession ?')) return;
    try {
      await concessionsApi.delete(id);
      loadConcessions();
    } catch (error) {
      console.error('Erreur suppression concession:', error);
      alert('Erreur lors de la suppression');
    }
  };

  const isAdminView = view === 'users' 
    || view === 'referentiels' 
    || view === 'concessions' 
    || view === 'litiges' 
    || view === 'permissions' 
    || view === 'planning' 
    || view === 'leads' 
    || view === 'vehicules-courtoisie'
    || view === 'atelier'
    || view === 'home'
    || view === 'leads-services';

    return (
      <div className={`dashboard ${sidebarOpen ? 'sidebar-pinned' : ''}`}>
        {sidebarOpen && (
          <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} aria-hidden="true" />
        )}
        <div ref={sidebarRef} className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="sidebar-header">
            <h3 className="sidebar-brand" title="AUTODOM97"><span className="sb-a">A</span><span className="sb-num">97</span></h3>
            <button
              className="sidebar-toggle-btn"
              onClick={() => setSidebarOpen(v => !v)}
              title={sidebarOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              aria-label="Toggle menu"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1.5" y="1.5" width="15" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M6.5 1.5V16.5" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M9.5 6.5L7 9l2.5 2.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div className="sidebar-scroll">
            {/* RECHERCHE */}
            <button
              ref={searchBtnRef}
              className={`sidebar-item${searchOpen ? ' active' : ''}`}
              onClick={() => {
                if (searchBtnRef.current) {
                  const rect = searchBtnRef.current.getBoundingClientRect();
                  setSearchPopoverPos({ top: rect.top, left: rect.right + 8 });
                }
                setSearchOpen(v => !v);
              }}
              title="Rechercher Immat / VIN"
            >
              <span className="si-icon">🔍</span>
              <span className="si-label">Rechercher</span>
            </button>

            {/* TABLEAU DE BORD */}
            <a href={`?page=home`} className={`sidebar-item ${view === 'home' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('home'); } }} title="Tableau de bord">
              <span className="si-icon">🏠</span><span className="si-label">Tableau de bord</span>
            </a>

            {/* LE FIL — réseau social d'entreprise (drapeau fil_enabled ; super-admins toujours) */}
            {(filEtat.enabled || user.role === 'super-admin') && !estMasquee('fil') && (
              <a href={`?page=fil`} className={`sidebar-item ${view === 'fil' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('fil'); } }} title="Le Fil">
                <span className="si-icon">📰</span><span className="si-label">Le Fil</span>
                {filEtat.nonLus > 0 && view !== 'fil' && (
                  <span className="si-badge" style={{ background: 'var(--color-info)', color: '#fff', borderRadius: '10px', fontSize: '11px', fontWeight: '700', padding: '1px 7px', marginLeft: 'auto', lineHeight: '18px' }}>
                    {filEtat.nonLus > 99 ? '99+' : filEtat.nonLus}
                  </span>
                )}
              </a>
            )}

            {/* SUPPORT & INNOVATION — accessible à tous (chacun ne voit que ses demandes) */}
            <a href={`?page=support-innovation`} className={`sidebar-item ${view === 'support-innovation' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('support-innovation'); } }} title="Support & Innovation">
              <span className="si-icon">🛟</span><span className="si-label">Support & Innovation</span>
            </a>

            {/* === GROUPE REPORTING === */}
            {(canAccessKpis || canAccessRingoverReporting || canAccessReportingFinancier || canAccessTourManager) && (
              <div className="sidebar-group">
                {sidebarOpen && (
                  <button
                    className="sidebar-group-header"
                    onClick={() => toggleSection('reporting')}
                    title={sectionsOpen.reporting ? 'Réduire Reporting' : 'Déplier Reporting'}
                  >
                    <span className="sgh-label">Reporting</span>
                    <span className={`sgh-chevron ${sectionsOpen.reporting ? 'open' : ''}`}>▾</span>
                  </button>
                )}
                {(sectionsOpen.reporting || !sidebarOpen) && (<>
                  {canAccessKpis && (
                    <a href={`?page=kpis`} className={`sidebar-item ${view === 'kpis' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('kpis'); } }} title="KPIs">
                      <span className="si-icon">📊</span><span className="si-label">KPIs</span>
                    </a>
                  )}
                  {canAccessRingoverReporting && (
                    <a href={`?page=ringover-reporting`} className={`sidebar-item ${view === 'ringover-reporting' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('ringover-reporting'); } }} title="Reporting Ringover">
                      <span className="si-icon">📞</span><span className="si-label">Reporting Ringover</span>
                    </a>
                  )}
                  {canAccessReportingFinancier && (
                    <a href={`?page=reporting-financier`} className={`sidebar-item ${view === 'reporting-financier' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('reporting-financier'); } }} title="Reporting Financier">
                      <span className="si-icon">💰</span><span className="si-label">Reporting Financier</span>
                    </a>
                  )}
                  {canAccessTourManager && (
                    <a href={`?page=tour-manager`} className={`sidebar-item ${view === 'tour-manager' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('tour-manager'); } }} title="Tour du Manager">
                      <span className="si-icon">👁️</span><span className="si-label">Tour du Manager</span>
                      {myTourCount > 0 && (
                        <span className="si-badge" style={{ background: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', borderRadius: '10px', fontSize: '11px', fontWeight: '600', padding: '1px 7px', marginLeft: 'auto', lineHeight: '18px' }}>
                          {myTourCount}
                        </span>
                      )}
                    </a>
                  )}
                </>)}
              </div>
            )}

            {/* === GROUPE RELATION CLIENTS === */}
            {(canAccessLeadsServices || canAccessJdma || canAccessLeads || canAccessGmb || canAccessSuiviRevisions || canAccessRetoursProspects) && (
              <div className="sidebar-group">
                {sidebarOpen && (
                  <button
                    className="sidebar-group-header"
                    onClick={() => toggleSection('relationClients')}
                    title={sectionsOpen.relationClients ? 'Réduire Relation clients' : 'Déplier Relation clients'}
                  >
                    <span className="sgh-label">Relation clients</span>
                    <span className={`sgh-chevron ${sectionsOpen.relationClients ? 'open' : ''}`}>▾</span>
                  </button>
                )}
                {(sectionsOpen.relationClients || !sidebarOpen) && (<>
                  {canAccessLeadsServices && (
                    <a href={`?page=leads-services`} className={`sidebar-item ${view === 'leads-services' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('leads-services'); } }} title="Demandes clients">
                      <span className="si-icon">💬</span>
                      <span className="si-label">Demandes clients</span>
                      {effectiveUser.role === 'operateur' && myDemandesCount > 0 && (
                        <span className="si-badge" style={{ background: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', borderRadius: '10px', fontSize: '11px', fontWeight: '600', padding: '1px 7px', marginLeft: 'auto', lineHeight: '18px' }}>
                          {myDemandesCount}
                        </span>
                      )}
                    </a>
                  )}
                  {canAccessJdma && (
                    <a href={`?page=jdma`} className={`sidebar-item ${view === 'jdma' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('jdma'); } }} title="JDMA — Avis clients">
                      <span className="si-icon">⭐</span><span className="si-label">JDMA</span>
                    </a>
                  )}
                  {canAccessLeads && (
                    <a href={`?page=leads`} className={`sidebar-item ${view === 'leads' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('leads'); } }} title="Leads Web">
                      <span className="si-icon">🌐</span><span className="si-label">Leads Web</span>
                    </a>
                  )}
                  {canAccessGmb && (
                    <a href={`?page=gmb-reviews`} className={`sidebar-item ${view === 'gmb-reviews' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('gmb-reviews'); } }} title="Google My Business (Avis)">
                      <span className="si-icon">🌟</span><span className="si-label">Google My Business (Avis)</span>
                    </a>
                  )}
                  {canAccessSuiviRevisions && (
                    <a href={`?page=relances-atelier`} className={`sidebar-item ${view === 'relances-atelier' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('relances-atelier'); } }} title="Relances Atelier">
                      <span className="si-icon">🔔</span><span className="si-label">Relances Atelier</span>
                    </a>
                  )}
                  {canAccessRetoursProspects && (
                    <a href={`?page=retours-prospects`} className={`sidebar-item ${view === 'retours-prospects' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('retours-prospects'); } }} title="Satisfaction clients">
                      <span className="si-icon">😊</span><span className="si-label">Satisfaction clients</span>
                    </a>
                  )}
                </>)}
              </div>
            )}

            {/* === GROUPE COMMERCE VN/VO === */}
            {(canAccessProspectionB2B || canAccessGestionCommerciale || canAccessEncaissements || canAccessCommandesVn || canAccessStampyt || canAccessStockVo) && (
              <div className="sidebar-group">
                {sidebarOpen && (
                  <button
                    className="sidebar-group-header"
                    onClick={() => toggleSection('commerceVnVo')}
                    title={sectionsOpen.commerceVnVo ? 'Réduire Commerce VN/VO' : 'Déplier Commerce VN/VO'}
                  >
                    <span className="sgh-label">Commerce VN/VO</span>
                    <span className={`sgh-chevron ${sectionsOpen.commerceVnVo ? 'open' : ''}`}>▾</span>
                  </button>
                )}
                {(sectionsOpen.commerceVnVo || !sidebarOpen) && (<>
                  {canAccessProspectionB2B && (
                    <a href={`?page=prospection-b2b`} className={`sidebar-item ${view === 'prospection-b2b' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('prospection-b2b'); } }} title="Prospection B2B">
                      <span className="si-icon">🏢</span><span className="si-label">Prospection B2B</span>
                    </a>
                  )}
                  {canAccessGestionCommerciale && (
                    <a href={`?page=gestion-commerciale`} className={`sidebar-item ${view === 'gestion-commerciale' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('gestion-commerciale'); } }} title="Gestion Commerciale">
                      <span className="si-icon">📂</span><span className="si-label">Gestion Commerciale</span>
                    </a>
                  )}
                  {canAccessCommandesVn && (
                    <a href={`?page=commandes-vn`} className={`sidebar-item ${view === 'commandes-vn' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('commandes-vn'); } }} title="Commandes VN">
                      <span className="si-icon">🚢</span><span className="si-label">Commandes VN</span>
                    </a>
                  )}
                  {canAccessEncaissements && (
                    <a href={`?page=encaissements`} className={`sidebar-item ${view === 'encaissements' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('encaissements'); } }} title="Encaissements">
                      <span className="si-icon">💶</span><span className="si-label">Encaissements</span>
                    </a>
                  )}
                  {canAccessStampyt && (
                    <a href={`?page=stampyt`} className={`sidebar-item ${view === 'stampyt' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('stampyt'); } }} title="Photos VO">
                      <span className="si-icon">📸</span><span className="si-label">Photos VO</span>
                    </a>
                  )}
                  {canAccessStockVo && (
                    <a href={`?page=stock-vo`} className={`sidebar-item ${view === 'stock-vo' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('stock-vo'); } }} title="Stock VO">
                      <span className="si-icon">📦</span><span className="si-label">Stock VO</span>
                    </a>
                  )}
                </>)}
              </div>
            )}

            {/* === GROUPE ATELIER === (regroupement labellisé du menu burger) */}
            {(canAccessPlanning || canAccessAtelier || canAccessCourtoisie || canAccessLitiges || canAccessParking || canAccessReceptionVip || canAccessFileMagasin || canAccessTourVehicule || canAccessOrEnCours || canAccessPiecesAtelier || canAccessGarantie || canAccessTakata || canAccessForfaits) && (
              <div className="sidebar-group">
                {sidebarOpen && (
                  <button
                    className="sidebar-group-header"
                    onClick={() => toggleSection('atelier')}
                    title={sectionsOpen.atelier ? 'Réduire Atelier' : 'Déplier Atelier'}
                  >
                    <span className="sgh-label">Atelier</span>
                    <span className={`sgh-chevron ${sectionsOpen.atelier ? 'open' : ''}`}>▾</span>
                  </button>
                )}
                {(sectionsOpen.atelier || !sidebarOpen) && (<>
                  {canAccessPlanning && (
                    <a href={`?page=planning`} className={`sidebar-item ${view === 'planning' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('planning'); } }} title="Planning Atelier">
                      <span className="si-icon">📅</span><span className="si-label">Planning Atelier</span>
                    </a>
                  )}
                  {canAccessAtelier && (
                    <a href={`?page=atelier`} className={`sidebar-item ${view === 'atelier' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('atelier'); } }} title="Suivi Atelier VN/VO">
                      <span className="si-icon">🔧</span><span className="si-label">Suivi Atelier VN/VO</span>
                    </a>
                  )}
                  {canAccessCourtoisie && (
                    <a href={`?page=vehicules-courtoisie`} className={`sidebar-item ${view === 'vehicules-courtoisie' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('vehicules-courtoisie'); } }} title="Véhicules Courtoisie">
                      <span className="si-icon">🚗</span><span className="si-label">Véhicules Courtoisie</span>
                    </a>
                  )}
                  {canAccessLitiges && (
                    <a href={`?page=litiges`} className={`sidebar-item ${view === 'litiges' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('litiges'); } }} title="Litiges">
                      <span className="si-icon">⚖️</span><span className="si-label">Litiges</span>
                    </a>
                  )}
                  {canAccessParking && (
                    <a href={`?page=parking`} className={`sidebar-item ${view === 'parking' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('parking'); } }} title="Gestion Parking">
                      <span className="si-icon">🅿️</span>
                      <span className="si-label">Gestion Parking</span>
                      {myParkingCount > 0 && (
                        <span className="si-badge" style={{ background: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', borderRadius: '10px', fontSize: '11px', fontWeight: '600', padding: '1px 7px', marginLeft: 'auto', lineHeight: '18px' }}>
                          {myParkingCount}
                        </span>
                      )}
                    </a>
                  )}
                  {canAccessReceptionVip && (
                    <a href={`?page=reception-vip`} className={`sidebar-item ${view === 'reception-vip' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('reception-vip'); } }} title="Réception VIP">
                      <span className="si-icon">🏁</span><span className="si-label">Réception VIP</span>
                      {vipCount > 0 && (
                        <span className="si-badge" style={{ background: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', borderRadius: '6px', fontSize: '9px', fontWeight: '600', padding: '0px 4px', marginLeft: 'auto', lineHeight: '14px' }}>
                          {vipCount}
                        </span>
                      )}
                    </a>
                  )}
                  {canAccessFileMagasin && (
                    <a href={`?page=file-virtuelle-magasin`} className={`sidebar-item ${view === 'file-virtuelle-magasin' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('file-virtuelle-magasin'); } }} title="File Virtuelle Magasin">
                      <span className="si-icon">🛎️</span><span className="si-label">File Virtuelle Magasin</span>
                    </a>
                  )}
                  {canAccessTourVehicule && (
                    <a href={`?page=tour-vehicule`} className={`sidebar-item ${view === 'tour-vehicule' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('tour-vehicule'); } }} title="Tour du véhicule">
                      <span className="si-icon">🚗</span><span className="si-label">Tour du véhicule</span>
                    </a>
                  )}
                  {canAccessOrEnCours && (
                    <a href={`?page=or-en-cours`} className={`sidebar-item ${view === 'or-en-cours' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('or-en-cours'); } }} title="OR en cours">
                      <span className="si-icon">🔩</span><span className="si-label">OR en cours</span>
                    </a>
                  )}
                  {canAccessPiecesAtelier && (
                    <a href={`?page=pieces-atelier`} className={`sidebar-item ${view === 'pieces-atelier' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('pieces-atelier'); } }} title="Suivi Pièces Atelier">
                      <span className="si-icon">📦</span><span className="si-label">Pièces Atelier</span>
                    </a>
                  )}
                  {canAccessGarantie && (
                    <a href={`?page=garantie`} className={`sidebar-item ${view === 'garantie' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('garantie'); } }} title="Garantie">
                      <span className="si-icon">📋</span><span className="si-label">Garantie</span>
                    </a>
                  )}
                  {canAccessTakata && (
                    <a href={`?page=takata`} className={`sidebar-item ${view === 'takata' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('takata'); } }} title="Takata — Rappel airbags">
                      <span className="si-icon"><svg viewBox="0 0 64 64" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="16" cy="11" r="7"/><path d="M9 23c-3 6-5 13-5 21h10l2-15"/><path d="M23 23c0 4 1 9 1 13"/><circle cx="48" cy="30" r="13" fill="currentColor" fillOpacity=".15" stroke="currentColor" strokeWidth="3"/></svg></span><span className="si-label">Takata</span>
                    </a>
                  )}
                  {canAccessForfaits && (
                    <a href={`?page=forfaits`} className={`sidebar-item ${view === 'forfaits' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('forfaits'); } }} title="Forfaits APV">
                      <span className="si-icon">📋</span><span className="si-label">Forfaits APV</span>
                    </a>
                  )}
                </>)}
              </div>
            )}

            {/* La rubrique « Pièces » du menu latéral a été retirée le 2026-09-04 :
                elle ne portait que « Prospection PR », désormais listée dans Labo
                Tools. Vérifié avant retrait qu'aucune autre entrée n'y était
                masquée par les droits — une rubrique paraît vide à qui n'a pas
                accès à ce qu'elle contient. La PAGE, elle, est inchangée et reste
                atteignable par `?page=prospection-pr`. */}

            {/* === GROUPE MARKETING === (regroupement labellisé du menu burger) */}
            {(canAccessMarketingHub || canAccessGoogleAds || canAccessGoogleAnalytics || canAccessSearchConsole || canAccessCampagnesMedias) && (
              <div className="sidebar-group">
                {sidebarOpen && (
                  <button
                    className="sidebar-group-header"
                    onClick={() => toggleSection('marketing')}
                    title={sectionsOpen.marketing ? 'Réduire Marketing' : 'Déplier Marketing'}
                  >
                    <span className="sgh-label">Marketing</span>
                    <span className={`sgh-chevron ${sectionsOpen.marketing ? 'open' : ''}`}>▾</span>
                  </button>
                )}
                {(sectionsOpen.marketing || !sidebarOpen) && (<>
                  {canAccessMarketingHub && (
                    <a href={`?page=marketing-hub`} className={`sidebar-item ${view === 'marketing-hub' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('marketing-hub'); } }} title="Supervision Marketing & Digital">
                      <span className="si-icon">🛰️</span><span className="si-label">Supervision M&D</span>
                    </a>
                  )}
                  {canAccessGoogleAds && (
                    <a href={`?page=google-ads`} className={`sidebar-item ${view === 'google-ads' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('google-ads'); } }} title="Google Ads">
                      <span className="si-icon">📈</span><span className="si-label">Google Ads</span>
                    </a>
                  )}
                  {canAccessGoogleAnalytics && (
                    <a href={`?page=google-analytics`} className={`sidebar-item ${view === 'google-analytics' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('google-analytics'); } }} title="Google Analytics">
                      <span className="si-icon">📊</span><span className="si-label">Google Analytics</span>
                    </a>
                  )}
                  {canAccessSearchConsole && (
                    <a href={`?page=search-console`} className={`sidebar-item ${view === 'search-console' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('search-console'); } }} title="Google Search Console">
                      <span className="si-icon">🔎</span><span className="si-label">Google Search Console</span>
                    </a>
                  )}
                  {canAccessCampagnesMedias && (
                    <a href={`?page=campagnes-medias`} className={`sidebar-item ${view === 'campagnes-medias' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('campagnes-medias'); } }} title="Campagnes médias">
                      <span className="si-icon">📢</span><span className="si-label">Campagnes médias</span>
                    </a>
                  )}
                </>)}
              </div>
            )}

            {/* === GROUPE UTILITAIRES === */}
            {(canAccessESignature || canAccessWorkflows || canAccessRecouvrement || user?.role === 'super-admin') && (
              <div className="sidebar-group">
                {sidebarOpen && (
                  <button
                    className="sidebar-group-header"
                    onClick={() => toggleSection('utilitaires')}
                    title={sectionsOpen.utilitaires ? 'Réduire Utilitaires' : 'Déplier Utilitaires'}
                  >
                    <span className="sgh-label">Utilitaires</span>
                    <span className={`sgh-chevron ${sectionsOpen.utilitaires ? 'open' : ''}`}>▾</span>
                  </button>
                )}
                {(sectionsOpen.utilitaires || !sidebarOpen) && (<>
                  {canAccessESignature && (
                    <a href={`?page=e-signature`} className={`sidebar-item ${view === 'e-signature' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('e-signature'); } }} title="E-Signature">
                      <span className="si-icon">✍️</span><span className="si-label">E-Signature</span>
                    </a>
                  )}
                  {user?.role === 'super-admin' && (
                    <a href={`?page=documents-pdf`} className={`sidebar-item ${view === 'documents-pdf' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('documents-pdf'); } }} title="RAG — recherche documentaire IA">
                      <span className="si-icon">📄</span><span className="si-label">RAG</span>
                    </a>
                  )}
                  {/* Recouvrement : sorti de Labo Tools le 2026-09-20. Il y
                      était enfermé depuis avril, donc réservé aux super-admins,
                      et personne n'y avait jamais eu accès — 1 action en cinq
                      mois. Il vit désormais derrière sa seule permission. */}
                  {canAccessRecouvrement && (
                    <a href={`?page=recouvrement`} className={`sidebar-item ${view === 'recouvrement' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('recouvrement'); } }} title="Recouvrement — suivi des créances clients">
                      <span className="si-icon">💳</span><span className="si-label">Recouvrement</span>
                    </a>
                  )}
                  {canAccessWorkflows && (
                    <a href={`?page=workflows`} className={`sidebar-item ${view === 'workflows' ? 'active' : ''}`} onClick={e => { if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) { e.preventDefault(); setView('workflows'); } }} title="Workflows">
                      <span className="si-icon">🔀</span>
                      <span className="si-label">Workflows</span>
                      <span
                        className="si-badge"
                        title="Suivi rapide des workflows en cours"
                        onClick={(e) => { e.stopPropagation(); setWfPanelOpen(true); }}
                        style={{ marginLeft: 'auto', cursor: 'pointer', background: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.8)', borderRadius: '8px', fontSize: '12px', padding: '1px 7px', lineHeight: '18px' }}
                      >⚡</span>
                    </a>
                  )}
                </>)}
              </div>
            )}

          </div>

          {/* Footer — Avatar menu */}
          <div className="sidebar-footer">
            {showUserMenu && (
              <div className="user-menu-overlay" onClick={() => setShowUserMenu(false)} />
            )}
            {showUserMenu && (
              <div className="user-menu" onClick={e => e.stopPropagation()}>
                <div className="user-menu-header">
                  <div className="user-menu-name">{user.prenom} {user.nom}</div>
                  {user.email && <div className="user-menu-email">{user.email}</div>}
                </div>
                <div className="user-menu-divider" />
                {(user.role === 'super-admin' || user.role === 'teleoperateur') && concessions.length > 1 && (
                  <div style={{ padding: '6px 12px' }}>
                    <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>🏢 Concession</label>
                    <select
                      value={globalConcessionId}
                      onChange={e => handleGlobalConcessionChange(e.target.value)}
                      style={{
                        width: '100%', padding: '6px 8px', borderRadius: 6, fontSize: 12,
                        border: `1.5px solid ${globalConcessionId ? 'var(--color-accent)' : 'var(--border-default)'}`,
                        background: globalConcessionId ? 'var(--color-info-light)' : 'var(--bg-input)',
                        fontWeight: globalConcessionId ? 600 : 400,
                        color: 'var(--text-primary)',
                      }}
                    >
                      <option value="">Toutes les concessions</option>
                      {concessions.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                    </select>
                  </div>
                )}
                {user.role === 'super-admin' && user.username === 'superadmin' && (
                  <button
                    className={`user-menu-item${view === 'ai-lab' ? ' active' : ''}`}
                    onClick={() => { setView('ai-lab'); setShowUserMenu(false); }}
                  >
                    <span className="user-menu-item-icon">🧪</span> Labo IA
                  </button>
                )}
                {user.role === 'super-admin' && (
                  <button
                    className={`user-menu-item${view === 'labo-tools' ? ' active' : ''}`}
                    onClick={() => { setView('labo-tools'); setShowUserMenu(false); }}
                  >
                    <span className="user-menu-item-icon">🧰</span> Labo Tools
                  </button>
                )}
                {user.role === 'super-admin' && (
                  <button
                    className={`user-menu-item${view === 'bases-donnees' ? ' active' : ''}`}
                    onClick={() => { setView('bases-donnees'); setShowUserMenu(false); }}
                  >
                    <span className="user-menu-item-icon">🛢️</span> Bases de données
                  </button>
                )}
                {(user.role === 'admin' || user.role === 'super-admin') && (
                  <button
                    className={`user-menu-item${view === 'administration' ? ' active' : ''}`}
                    onClick={() => { setView('administration'); setShowUserMenu(false); }}
                  >
                    <span className="user-menu-item-icon">⚙️</span> Administration
                  </button>
                )}
                <button
                  className="user-menu-item"
                  onClick={() => { setShowPasswordModal(true); setShowUserMenu(false); }}
                >
                  <span className="user-menu-item-icon">🔒</span> Modifier mon mot de passe
                </button>
                {user.role === 'super-admin' && (
                  <button
                    className="user-menu-item"
                    onClick={() => { if (users.length === 0) loadUsers(); setShowViewAsPanel(true); setShowUserMenu(false); }}
                  >
                    <span className="user-menu-item-icon">👁️</span> Simuler la vue d'un autre rôle
                  </button>
                )}
                <button
                  className="user-menu-item"
                  onClick={() => { setDarkMode(v => !v); setShowUserMenu(false); }}
                >
                  <span className="user-menu-item-icon">{darkMode ? '☀️' : '🌙'}</span>
                  {darkMode ? 'Mode Clair' : 'Mode Sombre'}
                </button>
                {(user.role === 'super-admin' || user.role === 'admin' || canDeleteLeads || canModifyLeads || canDeleteDemandes || canDeleteParking || user.username === 'lia.bonnemain' || user.username === 'jean-marc.guepin') && (
                  <button
                    className={`user-menu-item${editMode ? ' active' : ''}`}
                    onClick={() => { setEditMode(v => !v); setShowUserMenu(false); }}
                  >
                    <span className="user-menu-item-icon">✏️</span> Mode édition {editMode ? '(activé)' : ''}
                  </button>
                )}
                {user.role === 'super-admin' && (
                  <>
                    <div className="user-menu-divider" />
                    <div style={{ padding: '4px 12px 2px', fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', letterSpacing: '0.08em', textTransform: 'uppercase' }}>RGPD</div>
                    <button
                      className={`user-menu-item${view === 'rgpd' ? ' active' : ''}`}
                      onClick={() => { setView('rgpd'); setShowUserMenu(false); }}
                    >
                      <span className="user-menu-item-icon">🔒</span> Tableau de bord RGPD
                    </button>
                  </>
                )}
                <div className="user-menu-divider" />
                <button className="user-menu-item user-menu-item-danger" onClick={onLogout}>
                  <span className="user-menu-item-icon">🚪</span> Se déconnecter
                </button>
              </div>
            )}
            <button
              className="user-avatar-btn"
              onClick={() => setShowUserMenu(v => !v)}
              title={`${user.prenom} ${user.nom}`}
            >
              <span className="user-avatar-circle">
                {(user.prenom?.[0] || '').toUpperCase()}{(user.nom?.[0] || '').toUpperCase()}
              </span>
              <span className="user-avatar-name">{user.prenom} {user.nom}</span>
            </button>
          </div>
        </div>

        <div className="header">

          <button className="mobile-burger" onClick={() => setSidebarOpen(true)} aria-label="Ouvrir le menu">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1.5" y="1.5" width="15" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M6.5 1.5V16.5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M8.5 6.5L11 9l-2.5 2.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <h1
            onClick={() => setView('home')}
            style={{ cursor: 'pointer', userSelect: 'none' }}
          >
            {PAGE_TITLES[view] && (
              <span className="header-page-icon">{PAGE_TITLES[view].icon}</span>
            )}
            <span className="header-title-text">{PAGE_TITLES[view]?.label || 'CRM AUTODOM'}</span>
          </h1>
          {globalConcession && (
            <span style={{
              fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 12,
              background: 'var(--color-info-light)', color: 'light-dark(var(--color-accent), var(--color-accent-dark))',
              border: '1px solid var(--color-accent)', marginLeft: 8, whiteSpace: 'nowrap',
            }}>
              🏢 {globalConcession.nom}
            </span>
          )}
          {/* Indicateur de page : rendu ENTRE le titre et le sélecteur de vue.
              Emplacement demandé (2026-08-26) pour la note JDMA du Planning, qui
              saturait la barre de l'atelier. C'est un slot générique : la page
              fournit un élément React via setHeaderAction({ indicator }). Il ne
              doit porter que de l'INFORMATION — les actions vont dans
              `secondary`/`primary`, à droite. */}
          {headerAction?.indicator}
          {(headerAction?.segmented || headerAction?.dropdown) && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {headerAction?.segmented && (
                <div className="header-segmented">
                  {headerAction.segmented.options.map(opt => (
                    <button
                      key={opt.value}
                      className={`header-segmented-btn${headerAction.segmented.value === opt.value ? ' active' : ''}`}
                      onClick={opt.onClick}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              )}
              {headerAction?.dropdown && (
                <select
                  className="page-header-btn"
                  style={{ cursor: 'pointer', ...(headerAction.dropdown.value ? { background: 'var(--text-primary)', color: 'var(--bg-surface)', fontWeight: 600 } : {}) }}
                  value={headerAction.dropdown.value || ''}
                  onChange={e => {
                    const opt = headerAction.dropdown.options.find(o => o.value === e.target.value);
                    if (opt?.onClick) opt.onClick();
                  }}
                >
                  <option value="" disabled>{headerAction.dropdown.label || 'Plus…'}</option>
                  {headerAction.dropdown.options.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              )}
            </div>
          )}
          {headerAction?.pill && (
            <button
              className={`header-pill${headerAction.pill.active ? ' active' : ''}`}
              onClick={headerAction.pill.onClick}
            >
              {headerAction.pill.label}
              {headerAction.pill.badge > 0 && (
                <span className="header-pill-badge">{headerAction.pill.badge}</span>
              )}
            </button>
          )}
          <div className="header-right">
            {/* `title` et `disabled` étaient ignorés : les boutons de l'en-tête
                n'avaient donc aucune infobulle — un picto seul, sans libellé
                accessible — et une page ne pouvait pas neutraliser une action sans
                la faire disparaître, ce qui décalait toute la barre. */}
            {headerAction?.secondary?.map((btn, i) => (
              <button
                key={i}
                className="page-header-btn"
                onClick={btn.onClick}
                title={btn.title}
                aria-label={btn.title}
                disabled={btn.disabled}
              >
                {btn.label}
              </button>
            ))}
            {headerAction?.primary && (
              <button className="btn-primary page-action-btn" onClick={headerAction.primary.onClick}>
                {headerAction.primary.label}
              </button>
            )}
          </div>
        </div>

        {/* Panneau "Voir comme" */}
        {showViewAsPanel && (
          <div className="view-as-overlay" onClick={() => setShowViewAsPanel(false)}>
            <div className="view-as-panel" onClick={e => e.stopPropagation()}>
              <div className="view-as-panel-title">👁️ Voir comme…</div>

              {/* ── Utilisateur spécifique (optionnel) ── */}
              <div className="view-as-field">
                <label>Utilisateur</label>
                <select
                  value={viewAsForm.user_id}
                  onChange={e => {
                    const uid = e.target.value;
                    if (!uid) {
                      setViewAsForm(f => ({ ...f, user_id: '', nom: '', prenom: '' }));
                      return;
                    }
                    const u = users.find(u => String(u.id) === uid);
                    if (!u) return;
                    const c = concessions.find(c => String(c.id) === String(u.concession_id));
                    setViewAsForm(f => ({
                      ...f,
                      user_id:       uid,
                      nom:           u.nom    || '',
                      prenom:        u.prenom || '',
                      role:          u.role === 'super-admin' ? 'admin' : u.role,
                      concession_id: u.concession_id ? String(u.concession_id) : '',
                      concession_nom:c?.nom || '',
                    }));
                  }}
                >
                  <option value="">— Choisir un utilisateur (optionnel)</option>
                  {users.filter(u => u.role !== 'super-admin').map(u => (
                    <option key={u.id} value={u.id}>
                      {u.prenom ? `${u.prenom} ${u.nom}` : u.nom} — {
                        { admin: 'Admin', operateur: 'Opérateur', teleoperateur: 'Téléop.' }[u.role] || u.role
                      }
                    </option>
                  ))}
                </select>
              </div>

              <div className="view-as-separator">— ou définir manuellement —</div>

              <div className="view-as-field">
                <label>Rôle</label>
                <select
                  value={viewAsForm.role}
                  onChange={e => setViewAsForm(f => ({ ...f, role: e.target.value, user_id: '', nom: '', prenom: '' }))}
                >
                  <option value="admin">Administrateur</option>
                  <option value="operateur">Opérateur</option>
                  <option value="teleoperateur">Téléopérateur</option>
                </select>
              </div>
              <div className="view-as-field">
                <label>Concession</label>
                <select
                  value={viewAsForm.concession_id}
                  onChange={e => {
                    const c = concessions.find(c => String(c.id) === e.target.value);
                    setViewAsForm(f => ({ ...f, concession_id: e.target.value, concession_nom: c?.nom || '', user_id: '', nom: '', prenom: '' }));
                  }}
                >
                  <option value="">Toutes les concessions</option>
                  {concessions.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                </select>
              </div>
              <div className="view-as-actions">
                <button className="view-as-btn-cancel" onClick={() => setShowViewAsPanel(false)}>Annuler</button>
                <button className="view-as-btn-apply" onClick={() => { setViewAs({ ...viewAsForm }); setShowViewAsPanel(false); }}>
                  Appliquer
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Bannière mode aperçu */}
        {viewAs && (
          <div className="view-as-banner">
            <span>
              👁️ MODE APERÇU —&nbsp;
              {viewAs.nom
                ? <><strong>{viewAs.prenom ? `${viewAs.prenom} ${viewAs.nom}` : viewAs.nom}</strong> ({{ admin: 'Admin', operateur: 'Opérateur', teleoperateur: 'Téléop.' }[viewAs.role]})</>
                : <strong>{{ admin: 'Administrateur', operateur: 'Opérateur', teleoperateur: 'Téléopérateur' }[viewAs.role]}</strong>
              }
              {viewAs.concession_nom ? <> — <strong>{viewAs.concession_nom}</strong></> : ''}
            </span>
            <button className="view-as-banner-quit" onClick={() => setViewAs(null)}>✕ Quitter ce mode</button>
          </div>
        )}

        <div className="dashboard-content">
          {loading && <div className="loading">Chargement...</div>}

          {/* PAGE D'ACCUEIL - PROTÉGÉE */}
          {view === 'home' && (canAccessHome || effectiveUser.role === 'super-admin') && (
            <DashboardHome
              user={effectiveUser}
              onNavigate={setView}
              concessions={concessions}
            />
          )}

          {/* MESSAGE SI PAS D'ACCÈS */}
          {view === 'home' && !canAccessHome && effectiveUser.role !== 'super-admin' && (
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <h2>🔒 Accès refusé</h2>
              <p>Vous n'avez pas accès au Tableau de bord.</p>
              <p>Contactez un administrateur pour obtenir les permissions nécessaires.</p>
            </div>
          )}

  
          {!loading && view === 'leads-services' && canAccessLeadsServices && (
            <LeadsServices
              user={effectiveUser}
              onNavigate={setView}
              editMode={editMode}
              canDelete={canDeleteDemandes}
              setHeaderAction={setHeaderAction}
            />
          )}

          {!loading && view === 'workflows' && canAccessWorkflows && (
            <Workflows
              user={effectiveUser}
              editMode={editMode}
              setHeaderAction={setHeaderAction}
            />
          )}
  
  {!loading && view === 'administration' && (user.role === 'admin' || user.role === 'super-admin') && (
  <div className="admin-panel">
    <div className="page-tabs">
      <button className={adminTab === 'users' ? 'active' : ''} onClick={() => setAdminTab('users')}>👥 Utilisateurs</button>
      <button className={adminTab === 'referentiels' ? 'active' : ''} onClick={() => setAdminTab('referentiels')}>📋 Référentiels</button>
      {user.role === 'super-admin' && <>
        <button className={adminTab === 'concessions' ? 'active' : ''} onClick={() => setAdminTab('concessions')}>🏢 Concessions</button>
        <button className={adminTab === 'plaques' ? 'active' : ''} onClick={() => setAdminTab('plaques')}>🗺️ Plaques</button>
        <button className={adminTab === 'entites-juridiques' ? 'active' : ''} onClick={() => setAdminTab('entites-juridiques')}>🏛️ Entités juridiques</button>
        <button className={adminTab === 'permissions' ? 'active' : ''} onClick={() => setAdminTab('permissions')}>🔐 Permissions</button>
        <button className={adminTab === 'roles-planning' ? 'active' : ''} onClick={() => setAdminTab('roles-planning')}>🗝️ Rôles Planning</button>
        <button className={adminTab === 'securite-ip' ? 'active' : ''} onClick={() => setAdminTab('securite-ip')}>🛡️ Sécurité IP</button>
        <button className={adminTab === 'config-sms' ? 'active' : ''} onClick={() => setAdminTab('config-sms')}>📱 Config SMS</button>
        <button className={adminTab === 'config-email' ? 'active' : ''} onClick={() => setAdminTab('config-email')}>📧 Config Email</button>
        <button className={adminTab === 'webapp' ? 'active' : ''} onClick={() => setAdminTab('webapp')}>📱 Webapp</button>
        <button className={adminTab === 'portail-takata' ? 'active' : ''} onClick={() => setAdminTab('portail-takata')}>🔐 Portail Takata</button>
      </>}
    </div>
    <div className="admin-content">

    {adminTab === 'users' && <div>
    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
      <button
        className="btn-primary"
        onClick={() => {
          setEditingUser(null);
          setShowUserModal(true);
        }}
      >
        ➕ Nouvel utilisateur
      </button>
      <button
        className="btn-secondary"
        onClick={() => { setShowImportUsers(true); setImportUsersRows([]); setImportUsersResult(null); }}
      >
        📥 Importer Excel
      </button>
    </div>

    <UsersView
      users={users}
      concessions={concessions}
      currentUserId={user.id}
      onEdit={(user) => {
        setEditingUser(user);
        setShowUserModal(true);
      }}
      onDelete={handleDeleteUser}
      onResetPassword={(u) => setShowResetPasswordModal(u)}
      onUpdateConcession={handleUpdateUserConcession}
    />

    {/* Modale import Excel utilisateurs */}
    {showImportUsers && (
      <div className="modal-overlay">
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h2>📥 Import utilisateurs depuis Excel</h2>
            <button onClick={() => setShowImportUsers(false)} className="modal-close">✕</button>
          </div>
          <div className="modal-body">
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '14px' }}>
              Le fichier doit contenir les colonnes : <strong>NOM, PRENOM, Société, Fonction</strong>.<br />
              L'identifiant sera généré automatiquement (<em>prenom.nom</em>), le mot de passe sera <strong>123456!</strong>, le rôle sera <em>opérateur</em>.
            </p>
            <input
              ref={importUsersFileRef}
              type="file"
              accept=".xlsx,.xls,.csv"
              style={{ display: 'none' }}
              onChange={handleImportUsersFile}
            />
            <button className="btn-secondary" onClick={() => importUsersFileRef.current?.click()}>
              📂 Choisir un fichier Excel
            </button>

            {importUsersRows.length > 0 && !importUsersResult && (
              <>
                <p style={{ marginTop: '16px', fontWeight: '600', fontSize: '13px' }}>
                  {importUsersRows.length} utilisateur(s) détecté(s) :
                </p>
                <div style={{ maxHeight: '280px', overflowY: 'auto', marginTop: '8px', border: '1px solid var(--border-default)', borderRadius: '6px' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead style={{ background: 'var(--bg-muted)', position: 'sticky', top: 0 }}>
                      <tr>
                        {['Nom', 'Prénom', 'Identifiant généré', 'Concession', 'Fonction'].map(h => (
                          <th key={h} style={{ padding: '8px 10px', textAlign: 'left', borderBottom: '1px solid var(--border-default)', fontWeight: '600', color: 'var(--text-secondary)' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {importUsersRows.map((r, i) => {
                        const normalize = s => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '').replace(/[^a-z0-9]/g, '');
                        const username = `${normalize(r.prenom)}.${normalize(r.nom)}`;
                        return (
                          <tr key={i} style={{ borderBottom: '1px solid var(--border-default)' }}>
                            <td style={{ padding: '6px 10px' }}>{r.nom}</td>
                            <td style={{ padding: '6px 10px' }}>{r.prenom}</td>
                            <td style={{ padding: '6px 10px', fontFamily: 'monospace', color: 'light-dark(#2563eb, var(--color-info-dark))' }}>{username}</td>
                            <td style={{ padding: '6px 10px' }}>{r.societe || '—'}</td>
                            <td style={{ padding: '6px 10px' }}>{r.fonction || '—'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div style={{ marginTop: '16px', display: 'flex', gap: '10px' }}>
                  <button className="btn-primary" onClick={handleImportUsers} disabled={importUsersLoading}>
                    {importUsersLoading ? 'Import en cours…' : `✅ Importer ${importUsersRows.length} utilisateur(s)`}
                  </button>
                  <button className="btn-secondary" onClick={() => { setImportUsersRows([]); if (importUsersFileRef.current) importUsersFileRef.current.value = ''; }}>
                    Annuler
                  </button>
                </div>
              </>
            )}

            {importUsersResult && (
              <div style={{ marginTop: '16px', padding: '14px', background: 'var(--color-success-light)', border: '1px solid var(--color-success)', borderRadius: '8px' }}>
                <strong style={{ color: 'var(--color-success-dark)' }}>✅ Import terminé</strong><br />
                <span style={{ fontSize: '13px' }}>
                  {importUsersResult.created} créé(s), {importUsersResult.skipped} ignoré(s) (déjà existants ou invalides).
                </span>
                {importUsersResult.errors?.length > 0 && (
                  <ul style={{ marginTop: '8px', fontSize: '12px', color: 'light-dark(var(--color-error), var(--color-error-dark))' }}>
                    {importUsersResult.errors.map((e, i) => <li key={i}>{e}</li>)}
                  </ul>
                )}
                <button className="btn-secondary" style={{ marginTop: '10px' }} onClick={() => setShowImportUsers(false)}>
                  Fermer
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    )}
  </div>}

    {adminTab === 'referentiels' && (
      <ReferentielsView
        responsables={responsables}
        marques={marques}
        modeles={modeles}
        concessions={concessions}
        sujets={sujets}
        onUpdate={() => { loadReferentiels(); loadSujets(); }}
      />
    )}

    {adminTab === 'concessions' && user.role === 'super-admin' && (
      <div>
        <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
          <button
            className="btn-primary"
            onClick={() => {
              setEditingConcession(null);
              setShowConcessionModal(true);
            }}
          >
            ➕ Nouvelle concession
          </button>
        </div>
        <ConcessionsView
          concessions={concessions}
          plaques={plaques}
          onEdit={(concession) => { setEditingConcession(concession); setShowConcessionModal(true); }}
          onDelete={handleDeleteConcession}
        />
      </div>
    )}

    {adminTab === 'plaques' && user.role === 'super-admin' && (
      <Plaques />
    )}

    {adminTab === 'entites-juridiques' && user.role === 'super-admin' && (
      <EntitesJuridiques user={user} concessions={concessions} />
    )}

    {adminTab === 'permissions' && user.role === 'super-admin' && (
      <Permissions />
    )}

    {/* Matrice des rôles Planning : super-admin SEULEMENT. La placer dans
        Planning ▸ Configuration l'ouvrirait aux administrateurs du Planning,
        qui pourraient s'y attribuer des droits. */}
    {adminTab === 'roles-planning' && user.role === 'super-admin' && (
      <RolesPlanning />
    )}

    {adminTab === 'securite-ip' && user.role === 'super-admin' && (
      <SecurityIP editMode={editMode} />
    )}

    {adminTab === 'config-sms' && user.role === 'super-admin' && (
      <ConfigSMS />
    )}

    {adminTab === 'config-email' && user.role === 'super-admin' && (
      <ConfigEmail user={user} editMode={editMode} />
    )}

    {adminTab === 'webapp' && user.role === 'super-admin' && (
      <WebappAccess user={user} editMode={editMode} setHeaderAction={setHeaderAction} />
    )}

    {adminTab === 'portail-takata' && user.role === 'super-admin' && (
      <PortailComptesAdmin />
    )}

    </div>
  </div>
)}

          {!loading && view === 'litiges' && canAccessLitiges && (
            <Litiges user={effectiveUser} onOpenVehicule={setVehiculeModalImmat} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}
  
          {!loading && view === 'planning' && canAccessPlanning && (
            <PlanningAtelier user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}
  
          {!loading && view === 'leads' && canAccessLeads && (
          <LeadsView user={effectiveUser} editMode={editMode} canDelete={canDeleteLeads} canModify={canModifyLeads} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'campagnes-medias' && canAccessCampagnesMedias && (
            <CampagnesMediasAdmin user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'nextlane-or' && (
            <NextlaneOR user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'nextlane-reporting' && (
            <NextlaneReportingAtelier user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'vehicules-courtoisie' && canAccessCourtoisie && (
            <VehiculesCourtoisie editMode={editMode} user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'atelier' && canAccessAtelier && (
            <AtelierView user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'parking' && canAccessParking && (
            <GestionParking user={effectiveUser} onOpenVehicule={setVehiculeModalImmat} editMode={editMode} canDeleteParking={canDeleteParking} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'file-virtuelle-magasin' && canAccessFileMagasin && (
            <FileVirtuelleMagasin user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}
          {!loading && view === 'reception-vip' && canAccessReceptionVip && (
            <ReceptionVip user={effectiveUser} onOpenVehicule={setVehiculeModalImmat} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'reception-client' && canAccessReceptionClient && (
            <ReceptionClient user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'recouvrement' && canAccessRecouvrement && (
            <Recouvrement user={effectiveUser} concessions={concessions} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'tour-manager' && canAccessTourManager && (
            <TourManager user={effectiveUser} concessions={concessions} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'tour-vehicule' && canAccessTourVehicule && (
            <TourVehicule user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'or-en-cours' && canAccessOrEnCours && (
            <ORENCours user={effectiveUser} onOpenVehicule={setVehiculeModalImmat} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'takata' && (
            <Takata user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} initialDossierId={initialDossierId} />
          )}

          {!loading && view === 'pieces-atelier' && canAccessPiecesAtelier && (
            <SuiviPiecesAtelier user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'garantie' && canAccessGarantie && (
            <Garantie user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'gestion-commerciale' && canAccessGestionCommerciale && (
            <GestionCommerciale user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'commandes-vn' && canAccessCommandesVn && (
            <CommandesVN user={effectiveUser} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'encaissements' && canAccessEncaissements && (
            <Encaissements user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'stampyt' && canAccessStampyt && (
            <StampytVO user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'stock-vo' && canAccessStockVo && (
            <StockVoSuivi user={effectiveUser} concessions={concessions} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'fil' && (
            <Fil user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}
          {!loading && view === 'support-innovation' && (
            <SupportInnovation user={effectiveUser} setHeaderAction={setHeaderAction} editMode={editMode} initialTicketId={initialTicketId} />
          )}

          {!loading && view === 'kpis' && canAccessKpis && (
            <KPIs user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'forfaits' && canAccessForfaits && (
            <Forfaits user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'e-signature' && canAccessESignature && (
            <ESignature user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'prospection-b2b' && canAccessProspectionB2B && (
            <ProspectionB2B user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'prospection-pr' && canAccessProspectionPR && (
            <ProspectionPR user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'jdma' && canAccessJdma && (
            <JDMAPage user={effectiveUser} concessions={concessions} editMode={editMode} />
          )}

          {!loading && view === 'gmb-reviews' && canAccessGmb && (
            <GoogleAvis user={effectiveUser} concessions={concessions} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'google-analytics' && canAccessGoogleAnalytics && (
            <GoogleAnalytics user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'google-ads' && canAccessGoogleAds && (
            <GoogleAds user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'search-console' && canAccessSearchConsole && (
            <SearchConsole user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'marketing-hub' && canAccessMarketingHub && (
            <MarketingHub user={effectiveUser} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'relances-atelier' && canAccessSuiviRevisions && (
            <RelancesAtelier user={effectiveUser} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'retours-prospects' && canAccessRetoursProspects && (
            <Satisfaction key={globalConcessionId || "toutes"} user={effectiveUser} concessions={concessions} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'documents-pdf' && user.role === 'super-admin' && (
            <RecherchePdf user={effectiveUser} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'liasses-fiscales' && user.role === 'super-admin' && (
            <LiassesFiscales user={effectiveUser} setHeaderAction={setHeaderAction} editMode={editMode} />
          )}

          {!loading && view === 'bases-donnees' && user.role === 'super-admin' && (
            <BaseDonneesView user={effectiveUser} editMode={editMode} concessions={concessions} />
          )}

          {!loading && view === 'ai-lab' && user.role === 'super-admin' && user.username === 'superadmin' && (
            <AILab user={effectiveUser} concessions={concessions} />
          )}

          {!loading && view === 'labo-tools' && user.role === 'super-admin' && (
            <LaboTools setView={setView} />
          )}

          {!loading && view === 'rgpd' && user.role === 'super-admin' && (
            <RGPDDashboard />
          )}

          {!loading && view === 'voice-agent' && user.role === 'super-admin' && (
            <VoiceAgent user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'reporting-apv' && user.role === 'super-admin' && (
            <ReportingAPV user={effectiveUser} />
          )}

          {!loading && view === 'ringover-reporting' && canAccessRingoverReporting && (
            <RingoverReporting user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'reporting-financier' && canAccessReportingFinancier && (
            <ReportingFinancier user={effectiveUser} editMode={editMode} setHeaderAction={setHeaderAction} />
          )}

          {!loading && view === 'ai-search' && canAccessAISearch && (
            <AISearch user={effectiveUser} setHeaderAction={setHeaderAction} />
          )}


        </div>
  
        {showUserModal && (
          <UserModal
            user={editingUser}
            concessions={concessions}
            plaques={plaques}
            users={users}
            fonctionsRef={fonctionsRef}
            onSave={handleSaveUser}
            onClose={() => {
              setShowUserModal(false);
              setEditingUser(null);
            }}
          />
        )}
  
        {showConcessionModal && (
          <ConcessionModal
            concession={editingConcession}
            plaques={plaques}
            onSave={handleSaveConcession}
            onClose={() => {
              setShowConcessionModal(false);
              setEditingConcession(null);
            }}
          />
        )}

        {/* Modal changement de mot de passe personnel */}
        {showPasswordModal && (
          <PasswordModal
            strict={!!user.bypass_ip}
            onSave={async (currentPassword, newPassword) => {
              await authApi.changePassword(currentPassword, newPassword);
              setShowPasswordModal(false);
              alert('Mot de passe modifié avec succès');
            }}
            onClose={() => setShowPasswordModal(false)}
          />
        )}

        {/* Modal reset mot de passe admin */}
        {showResetPasswordModal && (
          <ResetPasswordModal
            targetUser={showResetPasswordModal}
            onSave={async (newPassword) => {
              await usersApiCore.resetPassword(showResetPasswordModal.id, newPassword);
              setShowResetPasswordModal(null);
              loadUsers();
              alert(`Mot de passe réinitialisé pour ${showResetPasswordModal.prenom} ${showResetPasswordModal.nom}. L'utilisateur devra le changer à sa prochaine connexion.`);
            }}
            onClose={() => setShowResetPasswordModal(null)}
          />
        )}

        {vehiculeModalImmat && (
          <VehiculeModal
            immat={vehiculeModalImmat}
            onClose={() => setVehiculeModalImmat(null)}
            onNavigate={(v) => setView(v)}
          />
        )}

        {searchOpen && (
          <>
            <div className="sidebar-search-overlay" onClick={() => { setSearchOpen(false); setVehiculeSearch(''); }} />
            <div className="sidebar-search-popover" style={{ top: searchPopoverPos.top, left: searchPopoverPos.left }}>
              <form onSubmit={e => {
                e.preventDefault();
                const v = vehiculeSearch.trim();
                if (v.length >= 4) { setVehiculeModalImmat(v); setVehiculeSearch(''); setSearchOpen(false); }
              }}>
                <span className="sidebar-search-icon">🔍</span>
                <input
                  autoFocus
                  type="text"
                  placeholder="Immat / VIN…"
                  value={vehiculeSearch}
                  onChange={e => setVehiculeSearch(e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase())}
                  maxLength={17}
                />
              </form>
            </div>
          </>
        )}

        {/* Chat IA — super-admin uniquement */}
        {user.role === 'super-admin' && chatIAEnabled && (
          <button
            className={`chat-fab ${chatOpen ? 'chat-fab-active' : ''}`}
            onClick={() => setChatOpen(v => !v)}
            title="Assistant IA CRM"
          >
            🤖
          </button>
        )}
        {user.role === 'super-admin' && (
          <ChatPanel
            isOpen={chatOpen}
            onClose={() => setChatOpen(false)}
            user={user}
          />
        )}

        {canAccessWorkflows && (
          <WorkflowsPanel
            isOpen={wfPanelOpen}
            onClose={() => setWfPanelOpen(false)}
            onOpenExecution={(execId) => {
              setView('workflows');
              setTimeout(() => window.dispatchEvent(new CustomEvent('open-workflow-execution', { detail: { executionId: execId } })), 0);
            }}
          />
        )}
      </div>
    );
  }

  // Composant UserModal
function UserModal({ user, concessions, plaques = [], users, fonctionsRef = [], onSave, onClose }) {
  const [formData, setFormData] = useState(user || {
    username: '',
    password: '',
    nom: '',
    prenom: '',
    role: 'operateur',
    concession_id: '',
    fonction: '',
    service: '',
    email: '',
    telephone: '',
    manager_id: '',
    dashboard_scope: 'own'
  });
  // En mode édition l'identifiant n'est jamais écrasé automatiquement
  const [usernameEdited, setUsernameEdited] = useState(!!user);

  // Concessions associées (rôle prestataire) — Set d'IDs
  const [prestataireConcIds, setPrestataireConcIds] = useState(new Set());

  useEffect(() => {
    if (user?.id && user.role === 'prestataire') {
      usersApi.getConcessions(user.id)
        .then(r => setPrestataireConcIds(new Set((r.data?.concessions || []).map(c => c.id))))
        .catch(() => setPrestataireConcIds(new Set()));
    } else {
      setPrestataireConcIds(new Set());
    }
  }, [user?.id, user?.role]);

  const togglePrestataireConc = (cid) => {
    setPrestataireConcIds(prev => {
      const next = new Set(prev);
      if (next.has(cid)) next.delete(cid); else next.add(cid);
      return next;
    });
  };

  // Capitalise chaque mot d'un prénom (séparateurs : espace et tiret)
  const capitalizePrenom = (str) => {
    if (!str) return str;
    return str
      .split(/(-|\s)/)
      .map(part => (/^[-\s]$/.test(part))
        ? part
        : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
      )
      .join('');
  };

  // Génère prenom.nom normalisé (sans accents, lowercase, espaces → tirets)
  const buildUsername = (prenom, nom) => {
    const normalize = (s) =>
      s.toLowerCase()
       .normalize('NFD')
       .replace(/[\u0300-\u036f]/g, '')
       .trim()
       .replace(/\s+/g, '-');
    const p = normalize(prenom);
    const n = normalize(nom);
    if (!p && !n) return '';
    if (!p) return n;
    if (!n) return p;
    return `${p}.${n}`;
  };

  const handleNomChange = (e) => {
    const nom = e.target.value.toUpperCase();
    setFormData(f => ({
      ...f,
      nom,
      ...(!usernameEdited && { username: buildUsername(f.prenom, nom) }),
    }));
  };

  const handlePrenomChange = (e) => {
    const prenom = capitalizePrenom(e.target.value);
    setFormData(f => ({
      ...f,
      prenom,
      ...(!usernameEdited && { username: buildUsername(prenom, f.nom) }),
    }));
  };

  const handleUsernameChange = (e) => {
    setUsernameEdited(true);
    setFormData(f => ({ ...f, username: e.target.value.toLowerCase() }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = { ...formData };
    if (user) delete dataToSend.password;
    // Plaque : uniquement pour un téléopérateur (un compte a une concession OU
    // une plaque). Tout autre rôle l'efface, et un téléopérateur n'a pas de concession.
    if (dataToSend.role === 'teleoperateur') {
      dataToSend.plaque_id = dataToSend.plaque_id ? parseInt(dataToSend.plaque_id, 10) : null;
      dataToSend.concession_id = null;
    } else {
      dataToSend.plaque_id = null;
    }
    if (dataToSend.role === 'prestataire') {
      dataToSend.prestataire_concession_ids = Array.from(prestataireConcIds);
      dataToSend.concession_id = null;
    }
    onSave(dataToSend);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{user ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-grid">
            <div className="form-group">
              <label>Nom</label>
              <input
                type="text"
                value={formData.nom}
                onChange={handleNomChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Prénom</label>
              <input
                type="text"
                value={formData.prenom}
                onChange={handlePrenomChange}
                required
              />
            </div>

            <div className="form-group full">
              <label>Identifiant</label>
              <input
                type="text"
                value={formData.username}
                onChange={handleUsernameChange}
                required
              />
            </div>

            {!user && (
              <div className="form-group full">
                <label>Mot de passe</label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required={!user}
                  minLength="6"
                />
              </div>
            )}

            <div className="form-group">
              <label>Rôle</label>
              <select
                value={formData.role}
                onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                required
              >
                <option value="operateur">Opérateur</option>
                <option value="admin">Administrateur</option>
                <option value="super-admin">Super-administrateur</option>
                <option value="teleoperateur">Téléopérateur</option>
                <option value="prestataire">Prestataire</option>
              </select>
            </div>

            {formData.role === 'prestataire' && (
              <div className="form-group full">
                <label>Concessions accessibles (lecture du tableau de bord Leads)</label>
                <div style={{
                  border: '1px solid var(--border-default)',
                  borderRadius: '8px',
                  padding: '10px 12px',
                  maxHeight: '180px',
                  overflowY: 'auto',
                  background: 'var(--bg-input)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px'
                }}>
                  {concessions.length === 0 && (
                    <div style={{ color: 'var(--text-muted)', fontStyle: 'italic', fontSize: '13px' }}>
                      Aucune concession disponible.
                    </div>
                  )}
                  {concessions.map(c => (
                    <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px' }}>
                      <input
                        type="checkbox"
                        checked={prestataireConcIds.has(c.id)}
                        onChange={() => togglePrestataireConc(c.id)}
                      />
                      <span>{c.nom}</span>
                    </label>
                  ))}
                </div>
                <small style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>
                  Le prestataire ne verra que les statistiques des concessions cochées.
                </small>
              </div>
            )}

            {formData.role === 'teleoperateur' && (
              <div className="form-group">
                <label>Plaque *</label>
                <select
                  value={formData.plaque_id ?? ''}
                  onChange={(e) => setFormData({ ...formData, plaque_id: e.target.value ? parseInt(e.target.value, 10) : '' })}
                  required
                >
                  <option value="">Sélectionner...</option>
                  {plaques.map(p => (
                    <option key={p.id} value={p.id}>{p.nom} ({p.code})</option>
                  ))}
                </select>
                <small style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>
                  Un téléopérateur voit <strong>toutes les concessions de sa plaque</strong>, et aucune autre. Il n'a pas de concession propre.
                </small>
              </div>
            )}

            {formData.role !== 'super-admin' && formData.role !== 'teleoperateur' && formData.role !== 'prestataire' && (
              <div className="form-group">
                <label>Concession</label>
                <select
                  value={formData.concession_id}
                  onChange={(e) => setFormData({ ...formData, concession_id: parseInt(e.target.value) })}
                  required={formData.role !== 'super-admin' && formData.role !== 'teleoperateur' && formData.role !== 'prestataire'}
                >
                  <option value="">Sélectionner...</option>
                  {concessions.map(c => (
                    <option key={c.id} value={c.id}>{c.nom}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>Fonction</label>
              <select
                value={formData.fonction || ''}
                onChange={(e) => setFormData({ ...formData, fonction: e.target.value })}
              >
                <option value="">— Aucune —</option>
                {fonctionsRef.map(f => (
                  <option key={f.code} value={f.code}>{f.label}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Service</label>
              <input
                type="text"
                value={formData.service || ''}
                onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                placeholder="Ex : Atelier, Vente..."
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={formData.email || ''}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Téléphone</label>
              <input
                type="text"
                value={formData.telephone || ''}
                onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
                placeholder="Ex : 06 12 34 56 78"
              />
            </div>

            <div className="form-group">
              <label>Manager direct</label>
              <select
                value={formData.manager_id || ''}
                onChange={(e) => setFormData({ ...formData, manager_id: e.target.value ? parseInt(e.target.value) : null })}
              >
                <option value="">— Aucun —</option>
                {(users || []).filter(u => u.id !== (user?.id)).map(u => (
                  <option key={u.id} value={u.id}>{u.nom} {u.prenom}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Portée tableau de bord</label>
              <select
                value={formData.dashboard_scope || 'own'}
                onChange={(e) => setFormData({ ...formData, dashboard_scope: e.target.value })}
              >
                <option value="own">Mes données uniquement</option>
                <option value="managed">Mes données + équipe</option>
                <option value="all">Toutes les données</option>
              </select>
            </div>

            {/* Service et Responsable : édités ici depuis la simplification du
                tableau Utilisateurs (colonnes masquées le 31/08/2026). */}
            <div className="form-group">
              <label>Service (concession)</label>
              <select
                value={formData.service_concession || ''}
                onChange={(e) => setFormData({ ...formData, service_concession: e.target.value || null })}
              >
                <option value="">— Aucun —</option>
                {SERVICES_CONCESSION.map(s => (
                  <option key={s.code} value={s.code}>{s.label}</option>
                ))}
              </select>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.is_responsable}
                  onChange={(e) => setFormData({ ...formData, is_responsable: e.target.checked })}
                  style={{ width: '16px', height: '16px' }}
                />
                ⭐ Responsable
              </label>
              <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' }}>
                Si coché, figure dans la liste des responsables (affectation des demandes clients).
              </div>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.bypass_ip}
                  onChange={(e) => setFormData({ ...formData, bypass_ip: e.target.checked })}
                  style={{ width: '16px', height: '16px' }}
                />
                📱 Accès mobile (bypass IP)
              </label>
              <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' }}>
                Si coché, cet utilisateur ne sera pas soumis aux restrictions IP (accès depuis n'importe quelle adresse).
              </div>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.is_manager}
                  onChange={(e) => setFormData({ ...formData, is_manager: e.target.checked })}
                  style={{ width: '16px', height: '16px' }}
                />
                👥 Est manager
              </label>
              <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' }}>
                Si coché, ouvre les onglets « Suivi collaborateurs » (Leads Web et Demandes clients) et « Suivi équipe » (KPIs). L'utilisateur ne voit que ses subordonnés directs (définis par <code>manager_id</code> sur les fiches collaborateurs).
              </div>
            </div>

            {(formData.role === 'operateur' || formData.role === 'teleoperateur') && (
              <div className="form-group full">
                <label style={{ fontWeight: 600 }}>Traitement leads web</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 4 }}>
                  {['VN', 'VO'].map(t => {
                    const arr = Array.isArray(formData.types_leads_web) ? formData.types_leads_web : [];
                    const checked = arr.includes(t);
                    return (
                      <label key={t} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => {
                            const next = new Set(arr);
                            if (e.target.checked) next.add(t); else next.delete(t);
                            setFormData({ ...formData, types_leads_web: Array.from(next) });
                          }}
                          style={{ width: '16px', height: '16px' }}
                        />
                        Leads web {t}
                      </label>
                    );
                  })}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: 4 }}>
                  Détermine les leads web entrants (VN / VO) que cet utilisateur peut recevoir en affectation automatique. Sans effet si la concession n'a pas activé l'affectation auto.
                </div>
              </div>
            )}
          </div>
        </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {user ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const ROLE_LABELS = {
  'operateur':     'Opérateur',
  'admin':         'Administrateur',
  'super-admin':   'Super-admin',
  'teleoperateur': 'Téléopérateur',
  'prestataire':   'Prestataire',
};

// Composant UsersView
const SERVICES_CONCESSION = [
  { code: 'VN',      label: 'VN' },
  { code: 'VO',      label: 'VO' },
  { code: 'ATELIER', label: 'Atelier' },
  { code: 'PIECES',  label: 'Pièces' },
  { code: 'AUTRE',   label: 'Autres' },
];

function UsersView({ users, concessions, currentUserId, onEdit, onDelete, onResetPassword, onUpdateConcession }) {
  const [search, setSearch]               = useState('');
  const [filterRole, setFilterRole]       = useState('');
  const [filterConcession, setFilterConcession] = useState('');
  const [filterService, setFilterService] = useState('');
  const [filterFonction, setFilterFonction] = useState('');

  const getConcessionName = (concessionId) => {
    const c = concessions.find(con => con.id === concessionId);
    return c ? c.nom : '-';
  };

  const distinctServices = [...new Set(users.map(u => u.service).filter(Boolean))].sort();
  const distinctFonctions = [...new Set(users.map(u => u.fonction).filter(Boolean))].sort();

  const filtered = users.filter(u => {
    if (filterRole && u.role !== filterRole) return false;
    if (filterConcession && String(u.concession_id) !== filterConcession) return false;
    if (filterService && u.service !== filterService) return false;
    if (filterFonction && u.fonction !== filterFonction) return false;
    if (search) {
      const q = search.toLowerCase();
      const concessionNom = getConcessionName(u.concession_id).toLowerCase();
      const roleLabel = (ROLE_LABELS[u.role] || u.role).toLowerCase();
      if (!(
        `${u.nom} ${u.prenom}`.toLowerCase().includes(q) ||
        u.username?.toLowerCase().includes(q) ||
        roleLabel.includes(q) ||
        concessionNom.includes(q)
      )) return false;
    }
    return true;
  });

  const hasFilters = search || filterRole || filterConcession || filterService || filterFonction;

  return (
    <div>
      {/* Barre de filtres */}
      <div style={{ display: 'flex', gap: '10px', padding: '12px 0 16px', flexWrap: 'wrap', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Rechercher (nom, identifiant, rôle, concession)..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ flex: '1', minWidth: '220px', padding: '7px 11px', border: '1px solid var(--border-default)', borderRadius: '6px', fontSize: '13px', outline: 'none' }}
        />
        <select
          value={filterRole}
          onChange={e => setFilterRole(e.target.value)}
          style={{ padding: '7px 11px', border: '1px solid var(--border-default)', borderRadius: '6px', fontSize: '13px', background: 'var(--bg-surface)', cursor: 'pointer' }}
        >
          <option value="">Tous les rôles</option>
          {Object.entries(ROLE_LABELS).map(([val, label]) => (
            <option key={val} value={val}>{label}</option>
          ))}
        </select>
        <select
          value={filterConcession}
          onChange={e => setFilterConcession(e.target.value)}
          style={{ padding: '7px 11px', border: '1px solid var(--border-default)', borderRadius: '6px', fontSize: '13px', background: 'var(--bg-surface)', cursor: 'pointer' }}
        >
          <option value="">Toutes les concessions</option>
          {concessions.map(c => (
            <option key={c.id} value={String(c.id)}>{c.nom}</option>
          ))}
        </select>
        <select
          value={filterService}
          onChange={e => setFilterService(e.target.value)}
          style={{ padding: '7px 11px', border: '1px solid var(--border-default)', borderRadius: '6px', fontSize: '13px', background: 'var(--bg-surface)', cursor: 'pointer' }}
        >
          <option value="">Tous les services</option>
          {distinctServices.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
        <select
          value={filterFonction}
          onChange={e => setFilterFonction(e.target.value)}
          style={{ padding: '7px 11px', border: '1px solid var(--border-default)', borderRadius: '6px', fontSize: '13px', background: 'var(--bg-surface)', cursor: 'pointer' }}
        >
          <option value="">Toutes les fonctions</option>
          {distinctFonctions.map(f => (
            <option key={f} value={f}>{f}</option>
          ))}
        </select>
        {hasFilters && (
          <button
            onClick={() => { setSearch(''); setFilterRole(''); setFilterConcession(''); setFilterService(''); setFilterFonction(''); }}
            style={{ padding: '7px 12px', background: 'var(--color-error)', color: 'var(--text-inverse)', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
          >
            Effacer
          </button>
        )}
        <span style={{ fontSize: '13px', color: 'var(--text-secondary)', fontWeight: '600', whiteSpace: 'nowrap' }}>
          {filtered.length} / {users.length} utilisateur{users.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Rôle</th>
              <th>Concession</th>
              <th style={{ textAlign: 'center' }}>MDP</th>
              <th>Dernière connexion</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)', fontStyle: 'italic' }}>
                  Aucun utilisateur ne correspond à cette recherche.
                </td>
              </tr>
            ) : filtered.map(u => (
              /* Console simplifiée (31/08/2026) : la ligne ouvre la fiche ;
                 Fonction / Service / Manager / Portée / Responsable s'éditent
                 dans la modale. */
              <tr key={u.id} onClick={() => onEdit(u)} style={{ cursor: 'pointer' }}>
                <td>
                  <div style={{ fontWeight: 600 }}>{u.nom} {u.prenom} {u.bypass_ip && <span title="Accès mobile (bypass IP)" style={{ fontSize: '13px' }}>📱</span>}</div>
                  {/* E-mail sous le nom (l'identifiant se voit dans la fiche) ;
                      repli sur l'identifiant pour les comptes sans e-mail. */}
                  <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                    {u.email || <span style={{ fontFamily: 'monospace' }}>{u.username}</span>}
                  </div>
                </td>
                <td>
                  <span className={`badge role-${u.role}`}>
                    {ROLE_LABELS[u.role] || u.role}
                  </span>
                </td>
                <td onClick={e => e.stopPropagation()}>
                  <select
                    value={u.concession_id || ''}
                    onChange={e => onUpdateConcession(u.id, e.target.value ? parseInt(e.target.value) : null)}
                    style={{ padding: '4px 8px', border: '1px solid var(--border-default)', borderRadius: '6px', fontSize: '12px', background: 'var(--bg-surface)', cursor: 'pointer', maxWidth: '160px' }}
                  >
                    <option value="">— Aucune —</option>
                    {concessions.map(c => (
                      <option key={c.id} value={c.id}>{c.nom}</option>
                    ))}
                  </select>
                </td>
                <td style={{ textAlign: 'center' }}>
                  {u.must_change_password
                    ? <span title="Doit changer son mot de passe à la prochaine connexion" style={{ fontSize: '15px' }}>🔑</span>
                    : <span style={{ color: '#86efac', fontSize: '15px' }}>✓</span>
                  }
                </td>
                <td style={{ color: 'var(--text-secondary)', fontSize: '12px', whiteSpace: 'nowrap' }}>
                  {u.derniere_connexion
                    ? (
                      <>
                        {new Date(u.derniere_connexion).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        {/* Méthode du dernier login (préparation bascule Microsoft-only).
                            Renseignée depuis le 31/08/2026 — vide avant = méthode inconnue. */}
                        {u.last_login_method === 'microsoft' && (
                          <span title="Dernière connexion via Microsoft" style={{ marginLeft: '6px', padding: '1px 6px', borderRadius: '9px', fontSize: '10px', fontWeight: 700, background: 'var(--color-info-light)', color: 'light-dark(var(--color-info), var(--color-info-dark))' }}>Microsoft</span>
                        )}
                        {u.last_login_method === 'password' && (
                          <span title="Dernière connexion par mot de passe" style={{ marginLeft: '6px', padding: '1px 6px', borderRadius: '9px', fontSize: '10px', fontWeight: 700, background: 'var(--color-warning-light)', color: 'light-dark(var(--color-warning), var(--color-warning-dark))' }}>Mot de passe</span>
                        )}
                      </>
                    )
                    : <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>Jamais</span>
                  }
                </td>
                {/* La cellule d'actions coupe la propagation, sans quoi la
                    corbeille ouvrirait aussi la fiche. */}
                <td onClick={e => e.stopPropagation()}>
                  <div className="action-buttons">
                    <button onClick={() => onEdit(u)} className="btn-icon" title="Modifier">
                      ✏️
                    </button>
                    <button onClick={() => onResetPassword(u)} className="btn-icon" title="Réinitialiser le mot de passe">
                      🔒
                    </button>
                    {u.id !== currentUserId && (
                      <button onClick={() => onDelete(u.id)} className="btn-icon delete" title="Désactiver">
                        🗑️
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// Composant BaseDonneesView
function BaseDonneesView({ user, editMode = false, concessions = [] }) {
  const [activeTab, setActiveTab] = useState('stock-vo');
  // Sources Google Sheets (config en dur côté backend) → onglets dynamiques.
  const [gsheetSources, setGsheetSources] = useState([]);
  useEffect(() => {
    api.get('/gsheet-sources').then(res => setGsheetSources(res.data || [])).catch(() => {});
  }, []);

  return (
    <div className="referentiels-container">
      <div className="ref-layout">
        <div className="dash-side-tabs">
          <div className="dash-side-tabs-group-label">Données</div>
          <button className={`dash-side-tab ${activeTab === 'stock-vo' ? 'active' : ''}`} onClick={() => setActiveTab('stock-vo')}>Stock VO</button>
          <button className={`dash-side-tab ${activeTab === 'stock-vo-detail' ? 'active' : ''}`} onClick={() => setActiveTab('stock-vo-detail')}>Stock VO (détail)</button>
          <button className={`dash-side-tab ${activeTab === 'stock-vn-detail' ? 'active' : ''}`} onClick={() => setActiveTab('stock-vn-detail')}>Stock VN (détail)</button>
          <button className={`dash-side-tab ${activeTab === 'ventes-vn' ? 'active' : ''}`} onClick={() => setActiveTab('ventes-vn')}>Ventes VN</button>
          <button className={`dash-side-tab ${activeTab === 'ventes-vo' ? 'active' : ''}`} onClick={() => setActiveTab('ventes-vo')}>Ventes VO</button>
          <button className={`dash-side-tab ${activeTab === 'offres-crm360' ? 'active' : ''}`} onClick={() => setActiveTab('offres-crm360')}>Offres CRM360</button>
          <button className={`dash-side-tab ${activeTab === 'factures-services' ? 'active' : ''}`} onClick={() => setActiveTab('factures-services')}>Factures Services</button>
          <button className={`dash-side-tab ${activeTab === 'mecaplanning' ? 'active' : ''}`} onClick={() => setActiveTab('mecaplanning')}>Données Mécaplanning</button>
          <button className={`dash-side-tab ${activeTab === 'dtc-atelier' ? 'active' : ''}`} onClick={() => setActiveTab('dtc-atelier')}>DTC - Entrées Atelier</button>
          <button className={`dash-side-tab ${activeTab === 'roole-actifs' ? 'active' : ''}`} onClick={() => setActiveTab('roole-actifs')}>Roole Actifs</button>
          <button className={`dash-side-tab ${activeTab === 'clients-datacar' ? 'active' : ''}`} onClick={() => setActiveTab('clients-datacar')}>Clients Datacar</button>
          <button className={`dash-side-tab ${activeTab === 'sigar' ? 'active' : ''}`} onClick={() => setActiveTab('sigar')}>Sigar</button>
          <button className={`dash-side-tab ${activeTab === 'stock-pieces' ? 'active' : ''}`} onClick={() => setActiveTab('stock-pieces')}>Stock Pièces</button>
          <button className={`dash-side-tab ${activeTab === 'nextlane-search' ? 'active' : ''}`} onClick={() => setActiveTab('nextlane-search')}>🔍 Recherche Nextlane</button>
          <button className={`dash-side-tab ${activeTab === 'jdma-vn' ? 'active' : ''}`} onClick={() => setActiveTab('jdma-vn')}>🚗 JDMA — Avis Ventes VN</button>
          <button className={`dash-side-tab ${activeTab === 'jdma-apv' ? 'active' : ''}`} onClick={() => setActiveTab('jdma-apv')}>🔧 JDMA — Avis Atelier APV</button>
          {gsheetSources.length > 0 && (
            <>
              <div className="dash-side-tabs-group-label" style={{ marginTop: '16px' }}>Google Sheets</div>
              {gsheetSources.map(s => (
                <button key={s.slug} className={`dash-side-tab ${activeTab === s.slug ? 'active' : ''}`} onClick={() => setActiveTab(s.slug)}>📄 {s.label}</button>
              ))}
            </>
          )}
          <div className="dash-side-tabs-group-label" style={{ marginTop: '16px' }}>Configuration</div>
          <button className={`dash-side-tab ${activeTab === 'config-sftp' ? 'active' : ''}`} onClick={() => setActiveTab('config-sftp')}>⚙️ Config SFTP</button>
          <button className={`dash-side-tab ${activeTab === 'sync-auto' ? 'active' : ''}`} onClick={() => setActiveTab('sync-auto')}>🔄 Sync automatique</button>
        </div>
        <div className="ref-content">
          {activeTab === 'stock-vo' && <StockVO user={user} />}
          {activeTab === 'stock-vo-detail' && <VentesDB apiPath="/stock-vo-detail" title="Stock VO (détail)" user={user} concessions={concessions} />}
          {activeTab === 'stock-vn-detail' && <VentesDB apiPath="/stock-vn-detail" title="Stock VN (détail)" user={user} concessions={concessions} />}
          {activeTab === 'ventes-vn' && <VentesDB apiPath="/ventes-vn" title="Ventes VN" user={user} concessions={concessions} />}
          {activeTab === 'ventes-vo' && <VentesDB apiPath="/ventes-vo" title="Ventes VO" user={user} concessions={concessions} />}
          {activeTab === 'offres-crm360' && (
            <VentesDB
              apiPath="/offres-crm360"
              title="Offres CRM360"
              user={user}
              concessions={concessions}
              manualUpload={true}
              filterField="Offres - Type"
              filterOptions={['VN', 'VO', 'VD', 'Catalogue']}
              filterLabel="Type"
              banner="🔒 Les noms et prénoms des vendeurs sont retirés à la source (RGPD) — le champ « Offres - Vendeur » est un identifiant interne, pas un nom."
            />
          )}
          {gsheetSources.map(s => activeTab === s.slug && (
            <VentesDB key={s.slug} apiPath={s.apiPath} title={s.label} syncSource="Google Sheets" user={user} concessions={concessions} />
          ))}
          {activeTab === 'factures-services' && <FacturesServices user={user} />}
          {activeTab === 'mecaplanning' && (
            <>
              {user?.role === 'super-admin' && <MecaplanningImportPanel />}
              <DynamicDB
                apiPath="/mecaplanning"
                title="Données Mécaplanning"
                sftpSync={true}
                templateConfig={{
                  filename: 'modele_mecaplanning.xlsx',
                  headers: ['immat', 'or', 'date_entree', 'km', 'technicien'],
                  exampleRow: ['AB-123-CD', 'OP12345', '01/01/2025', '50000', 'DUPONT'],
                }}
              />
            </>
          )}
          {activeTab === 'dtc-atelier' && (
            <DynamicDB
              apiPath="/dtc-atelier"
              title="DTC - Entrées Atelier"
              templateConfig={{
                filename: 'modele_dtc_atelier.xlsx',
                headers: ['immat', 'code_dtc', 'description', 'km', 'date_entree'],
                exampleRow: ['AB-123-CD', 'P0300', 'Raté allumage', '50000', '01/01/2025'],
              }}
            />
          )}
          {activeTab === 'roole-actifs' && (
            <DynamicDB
              apiPath="/roole-actifs"
              title="Roole Actifs"
              sftpSync={true}
              templateConfig={{
                filename: 'modele_roole_actifs.xlsx',
                headers: ['immat'],
                exampleRow: ['AB123CD'],
              }}
            />
          )}
          {activeTab === 'clients-datacar' && (
            <DynamicDB
              apiPath="/clients-datacar"
              title="Clients Datacar"
              sftpSync={true}
              primaryKeyLabel="idCli"
              visibleColumns={['idsoc', 'Nom', 'prenom', 'telMob', 'email']}
              templateConfig={{
                filename: 'modele_clients_datacar.xlsx',
                headers: ['idCli'],
                exampleRow: ['000001'],
              }}
            />
          )}
          {activeTab === 'sigar' && (
            <DynamicDB
              apiPath="/sigar"
              title="Sigar — Suivi garantie"
              sftpSync={true}
              primaryKeyLabel="CHASSIS"
              templateConfig={{
                filename: 'modele_sigar.xlsx',
                headers: ['CHASSIS'],
                exampleRow: ['VF1XXXXXXXXXX'],
              }}
            />
          )}
          {activeTab === 'stock-pieces' && (
            <DynamicDB
              apiPath="/stock-pieces"
              title="Stock Pièces"
              sftpSync={true}
              primaryKeyLabel="codepda"
              templateConfig={{
                filename: 'modele_stock_pieces.xlsx',
                headers: ['codepda'],
                exampleRow: ['7701234567'],
              }}
            />
          )}
          {activeTab === 'nextlane-search' && <NextlaneSearch />}
          {activeTab === 'jdma-vn' && (
            <JDMAAvis type="vn" user={user} editMode={editMode} concessions={concessions} />
          )}
          {activeTab === 'jdma-apv' && (
            <JDMAAvis type="apv" user={user} editMode={editMode} concessions={concessions} />
          )}
          {activeTab === 'config-sftp' && <ConfigSFTP />}
          {activeTab === 'sync-auto' && <SyncConfig />}
        </div>
      </div>
    </div>
  );
}

// Composant ReferentielsView
function ReferentielsView({ responsables, marques, modeles, concessions, sujets, onUpdate }) {
  const [activeTab, setActiveTab] = useState('responsables');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [modalType, setModalType] = useState('');
  const [statutsLitiges, setStatutsLitiges]   = useState([]);
  const [statutsParking, setStatutsParking]   = useState([]);
  const [statutsGarantie, setStatutsGarantie] = useState([]);
  const [motifsGarantie,  setMotifsGarantie]  = useState([]);
  const [actionsParking,  setActionsParking]   = useState([]);
  const [ringoverMappings, setRingoverMappings] = useState([]);
  const [ringoverForm, setRingoverForm] = useState({ numero: '', concession_id: '', label: '', service_code: '' });
  const [ringoverEditing, setRingoverEditing] = useState(null);
  const SERVICES_RINGOVER = [
    { code: 'ATELIER', nom: 'Atelier' },
    { code: 'PIECES',  nom: 'Pièces' },
    { code: 'VN',      nom: 'VN' },
    { code: 'VO',      nom: 'VO' },
    { code: 'AUTRE',   nom: 'Autres' },
  ];
  const [statutsAtelier, setStatutsAtelier] = useState([]);
  const [newStatutAtelier, setNewStatutAtelier] = useState({ nom: '', couleur: '#E8E8E8', text_color: '#000000', ordre: 0 });
  const [editingStatutAtelier, setEditingStatutAtelier] = useState(null);
  const [statutsOrEnCours, setStatutsOrEnCours] = useState([]);
  const [newStatutOrEnCours, setNewStatutOrEnCours] = useState({ code: '', nom: '', couleur: '#6b7280', ordre: 0 });
  const [editingStatutOrEnCours, setEditingStatutOrEnCours] = useState(null);
  // Flottes courtoisie (référentiel par concession, alimente l'onglet Flotte des Véhicules Courtoisie)
  const [flottesCourtoisie, setFlottesCourtoisie] = useState([]);
  const [newFlotteCourtoisie, setNewFlotteCourtoisie] = useState({ nom: '', concession_id: '' });
  const [editingFlotteCourtoisie, setEditingFlotteCourtoisie] = useState(null);
  const [travauxTypes, setTravauxTypes] = useState([]);
  const [newTravauxType, setNewTravauxType] = useState({ libelle: '', duree_defaut: 1, ordre: 0 });
  const [editingTravauxType, setEditingTravauxType] = useState(null);
  const [fonctionsKpi, setFonctionsKpi] = useState([]);
  const [newFonction, setNewFonction] = useState({ code: '', label: '', sort_order: 0 });
  const [editingFonction, setEditingFonction] = useState(null);

  // Sources mapping
  const [sourcesMapping, setSourcesMapping] = useState([]);
  const [newSourceMapping, setNewSourceMapping] = useState({ pattern: '', label: '', ordre: 0 });
  const [editingSourceMapping, setEditingSourceMapping] = useState(null);

  // Statuts Leads Web
  const LEADS_SERVICES_CODES = ['VN', 'VO', 'ATELIER', 'PIECES', 'AUTRE'];
  const [statutsLeadsWeb, setStatutsLeadsWeb] = useState([]);
  const [newStatutLeadsWeb, setNewStatutLeadsWeb] = useState({
    code: '', nom: '', couleur: '#64748b', services: [], ordre: 0, archive: false,
  });
  const [editingStatutLeadsWeb, setEditingStatutLeadsWeb] = useState(null);

  const loadSourcesMapping = async () => {
    try {
      const res = await referentielsApi.getSourcesMapping();
      setSourcesMapping(res.data.sources_mapping || []);
    } catch (e) { console.error(e); }
  };

  const loadStatutsLitiges = async () => {
    try {
      const response = await statutsLitigesApi.getAll();
      setStatutsLitiges(response.data.statuts);
    } catch (error) {
      console.error('Erreur chargement statuts litiges:', error);
    }
  };

  const loadStatutsParking = async () => {
    try {
      const response = await statutsParkingApi.getAll();
      setStatutsParking(response.data.statuts);
    } catch (error) {
      console.error('Erreur chargement statuts parking:', error);
    }
  };

  const loadStatutsGarantie = async () => {
    try {
      const response = await statutsGarantieApi.getAll();
      setStatutsGarantie(response.data.statuts);
    } catch (error) {
      console.error('Erreur chargement statuts garantie:', error);
    }
  };

  const loadMotifsGarantie = async () => {
    try {
      const response = await motifsGarantieApi.getAll();
      setMotifsGarantie(response.data.motifs);
    } catch (error) {
      console.error('Erreur chargement motifs garantie:', error);
    }
  };

  const loadActionsParking = async () => {
    try {
      const response = await referentielsApi.getActionsParking();
      setActionsParking(response.data.actions || []);
    } catch (error) {
      console.error('Erreur chargement actions parking:', error);
    }
  };

  const loadRingoverMappings = async () => {
    try {
      const api = (await import('../services/api')).default;
      const res = await api.get('/referentiels/ringover-mappings');
      setRingoverMappings(res.data.mappings || []);
    } catch (e) {
      console.error('Erreur chargement mappings Ringover:', e);
    }
  };

  const handleRingoverSave = async () => {
    try {
      const api = (await import('../services/api')).default;
      if (ringoverEditing) {
        await api.put(`/referentiels/ringover-mappings/${ringoverEditing.id}`, ringoverForm);
      } else {
        await api.post('/referentiels/ringover-mappings', ringoverForm);
      }
      setRingoverForm({ numero: '', concession_id: '', label: '', service_code: '' });
      setRingoverEditing(null);
      loadRingoverMappings();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleRingoverDelete = async (id) => {
    if (!window.confirm('Supprimer ce mapping ?')) return;
    try {
      const api = (await import('../services/api')).default;
      await api.delete(`/referentiels/ringover-mappings/${id}`);
      loadRingoverMappings();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  const loadStatutsAtelier = async () => {
    try {
      const res = await referentielsApi.getStatutsAtelier();
      setStatutsAtelier(res.data.statuts_atelier || []);
    } catch (e) {
      console.error('Erreur chargement statuts atelier:', e);
    }
  };

  const loadTravauxTypes = async () => {
    try {
      const res = await referentielsApi.getTravauxTypes();
      setTravauxTypes(res.data.travaux_types || []);
    } catch (e) {
      console.error('Erreur chargement types de travaux:', e);
    }
  };

  const loadFonctionsKpi = async () => {
    try {
      const res = await kpisApi.getFonctions();
      setFonctionsKpi(res.data);
    } catch (e) {
      console.error('Erreur chargement fonctions:', e);
    }
  };

  const handleSaveFonction = async () => {
    try {
      if (editingFonction) {
        await kpisApi.updateFonction(editingFonction.id, newFonction);
        setEditingFonction(null);
      } else {
        await kpisApi.createFonction(newFonction);
      }
      setNewFonction({ code: '', label: '', sort_order: 0 });
      loadFonctionsKpi();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteFonction = async (id) => {
    if (!window.confirm('Supprimer cette fonction ?')) return;
    try {
      await kpisApi.deleteFonction(id);
      loadFonctionsKpi();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  const handleSaveStatutAtelier = async () => {
    try {
      if (editingStatutAtelier) {
        await referentielsApi.updateStatutAtelier(editingStatutAtelier.id, newStatutAtelier);
        setEditingStatutAtelier(null);
      } else {
        await referentielsApi.createStatutAtelier(newStatutAtelier);
      }
      setNewStatutAtelier({ nom: '', couleur: '#E8E8E8', text_color: '#000000', ordre: 0 });
      loadStatutsAtelier();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteStatutAtelier = async (id) => {
    if (!window.confirm('Supprimer ce statut ?')) return;
    try {
      await referentielsApi.deleteStatutAtelier(id);
      loadStatutsAtelier();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  const loadStatutsOrEnCours = async () => {
    try {
      const res = await referentielsApi.getStatutsOrEnCours();
      setStatutsOrEnCours(res.data.statuts_or_en_cours || []);
    } catch (e) {
      console.error('Erreur chargement statuts OR en cours:', e);
    }
  };

  const handleSaveStatutOrEnCours = async () => {
    try {
      if (editingStatutOrEnCours) {
        await referentielsApi.updateStatutOrEnCours(editingStatutOrEnCours.id, newStatutOrEnCours);
        setEditingStatutOrEnCours(null);
      } else {
        await referentielsApi.createStatutOrEnCours(newStatutOrEnCours);
      }
      setNewStatutOrEnCours({ code: '', nom: '', couleur: '#6b7280', ordre: 0 });
      loadStatutsOrEnCours();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteStatutOrEnCours = async (id) => {
    if (!window.confirm('Supprimer ce statut ?')) return;
    try {
      await referentielsApi.deleteStatutOrEnCours(id);
      loadStatutsOrEnCours();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  const loadFlottesCourtoisie = async () => {
    try {
      const res = await referentielsApi.getFlottesCourtoisie();
      setFlottesCourtoisie(res.data.flottes || []);
    } catch (e) {
      console.error('Erreur chargement flottes courtoisie:', e);
    }
  };

  const handleSaveFlotteCourtoisie = async () => {
    try {
      if (editingFlotteCourtoisie) {
        await referentielsApi.updateFlotteCourtoisie(editingFlotteCourtoisie.id, { nom: newFlotteCourtoisie.nom });
        setEditingFlotteCourtoisie(null);
      } else {
        await referentielsApi.createFlotteCourtoisie({
          nom: newFlotteCourtoisie.nom,
          concession_id: newFlotteCourtoisie.concession_id || null,
        });
      }
      setNewFlotteCourtoisie({ nom: '', concession_id: '' });
      loadFlottesCourtoisie();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteFlotteCourtoisie = async (id) => {
    if (!window.confirm('Supprimer cette flotte ? Les véhicules qui y étaient rattachés ne le seront plus.')) return;
    try {
      await referentielsApi.deleteFlotteCourtoisie(id);
      loadFlottesCourtoisie();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  const handleSaveTravauxType = async () => {
    try {
      if (editingTravauxType) {
        await referentielsApi.updateTravauxType(editingTravauxType.id, newTravauxType);
        setEditingTravauxType(null);
      } else {
        await referentielsApi.createTravauxType(newTravauxType);
      }
      setNewTravauxType({ libelle: '', duree_defaut: 1, ordre: 0 });
      loadTravauxTypes();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteTravauxType = async (id) => {
    if (!window.confirm('Supprimer ce type de travaux ?')) return;
    try {
      await referentielsApi.deleteTravauxType(id);
      loadTravauxTypes();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  // ── Statuts Leads Web ──
  const loadStatutsLeadsWeb = async () => {
    try {
      const res = await referentielsApi.getStatutsLeadsWeb();
      setStatutsLeadsWeb(res.data.statuts_leads_web || []);
    } catch (e) {
      console.error('Erreur chargement statuts leads web:', e);
    }
  };

  const resetStatutLeadsWebForm = () => {
    setEditingStatutLeadsWeb(null);
    setNewStatutLeadsWeb({ code: '', nom: '', couleur: '#64748b', services: [], ordre: 0, archive: false });
  };

  const handleSaveStatutLeadsWeb = async () => {
    try {
      if (editingStatutLeadsWeb) {
        // Pour un statut système, on n'envoie pas code / archive (non modifiables)
        const payload = { ...newStatutLeadsWeb };
        if (editingStatutLeadsWeb.systeme) {
          delete payload.code;
          delete payload.archive;
        }
        await referentielsApi.updateStatutLeadsWeb(editingStatutLeadsWeb.id, payload);
      } else {
        await referentielsApi.createStatutLeadsWeb(newStatutLeadsWeb);
      }
      resetStatutLeadsWebForm();
      loadStatutsLeadsWeb();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la sauvegarde');
    }
  };

  const handleDeleteStatutLeadsWeb = async (statut) => {
    if (statut.systeme) return;
    if (!window.confirm(`Supprimer le statut "${statut.nom}" ?`)) return;
    try {
      await referentielsApi.deleteStatutLeadsWeb(statut.id);
      loadStatutsLeadsWeb();
    } catch (e) {
      alert(e.response?.data?.error || 'Erreur lors de la suppression');
    }
  };

  const toggleServiceInForm = (service) => {
    setNewStatutLeadsWeb(s => ({
      ...s,
      services: s.services.includes(service)
        ? s.services.filter(x => x !== service)
        : [...s.services, service],
    }));
  };

  useEffect(() => {
    loadStatutsLitiges();
    loadStatutsParking();
    loadStatutsGarantie();
    loadMotifsGarantie();
    loadActionsParking();
    loadRingoverMappings();
    loadStatutsAtelier();
    loadStatutsOrEnCours();
    loadFlottesCourtoisie();
    loadTravauxTypes();
    loadFonctionsKpi();
    loadStatutsLeadsWeb();
  }, []);

  const handleAdd = (type) => {
    setModalType(type);
    setEditingItem(null);
    setShowModal(true);
  };

  const handleEdit = (item, type) => {
    setModalType(type);
    setEditingItem(item);
    setShowModal(true);
  };

  // Retire une concession liée à une marque directement depuis le tableau
  // (pill cliquable). Met à jour via PUT /referentiels/marques/:id en
  // envoyant la liste complète des concessions restantes.
  const handleRemoveConcessionFromMarque = async (marque, concession) => {
    const remaining = (marque.concessions || []).filter(c => c.id !== concession.id);
    if (!window.confirm(`Retirer « ${concession.nom} » de la marque « ${marque.nom} » ?`)) return;
    try {
      await referentielsApi.updateMarque(marque.id, {
        nom: marque.nom,
        concession_ids: remaining.map(c => c.id),
      });
      onUpdate();
    } catch (error) {
      console.error('Erreur retrait concession marque:', error);
      alert(error.response?.data?.error || 'Erreur lors du retrait de la concession');
    }
  };

  const handleSave = async (data) => {
    try {
      if (modalType === 'responsable') {
        if (editingItem) {
          await referentielsApi.updateResponsable(editingItem.id, data);
        } else {
          await referentielsApi.createResponsable(data);
        }
      } else if (modalType === 'marque') {
        if (editingItem) {
          await referentielsApi.updateMarque(editingItem.id, data);
        } else {
          await referentielsApi.createMarque(data);
        }
      } else if (modalType === 'modele') {
        if (editingItem) {
          await referentielsApi.updateModele(editingItem.id, data);
        } else {
          await referentielsApi.createModele(data);
        }
      } else if (modalType === 'sujet') {
        if (editingItem) {
          await sujetsApi.update(editingItem.id, { nom: data.nom, actif: data.actif });
        } else {
          await sujetsApi.create({ nom: data.nom, actif: data.actif, concession_ids: [] });
        }
      } else if (modalType === 'statut-litige') {
        if (editingItem) {
          await statutsLitigesApi.update(editingItem.id, data);
        } else {
          await statutsLitigesApi.create(data);
        }
        loadStatutsLitiges();
      } else if (modalType === 'statut-parking') {
        if (editingItem) {
          await statutsParkingApi.update(editingItem.id, data);
        } else {
          await statutsParkingApi.create(data);
        }
        loadStatutsParking();
      } else if (modalType === 'statut-garantie') {
        if (editingItem) {
          await statutsGarantieApi.update(editingItem.id, data);
        } else {
          await statutsGarantieApi.create(data);
        }
        loadStatutsGarantie();
      } else if (modalType === 'motif-garantie') {
        if (editingItem) {
          await motifsGarantieApi.update(editingItem.id, data);
        } else {
          await motifsGarantieApi.create(data);
        }
        loadMotifsGarantie();
      } else if (modalType === 'action-parking') {
        if (editingItem) {
          await referentielsApi.updateActionParking(editingItem.id, data);
        } else {
          await referentielsApi.createActionParking(data);
        }
        loadActionsParking();
      }

      setShowModal(false);
      setEditingItem(null);
      onUpdate();
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    }
  };

  const handleDelete = async (id, type) => {
    if (!window.confirm('Supprimer cet élément ?')) return;
    try {
      if (type === 'responsable') {
        await referentielsApi.deleteResponsable(id);
      } else if (type === 'marque') {
        await referentielsApi.deleteMarque(id);
      } else if (type === 'modele') {
        await referentielsApi.deleteModele(id);
      } else if (type === 'sujet') {
        await sujetsApi.delete(id);
      } else if (type === 'statut-litige') {
        await statutsLitigesApi.delete(id);
        loadStatutsLitiges();
      } else if (type === 'statut-parking') {
        await statutsParkingApi.delete(id);
        loadStatutsParking();
      } else if (type === 'statut-garantie') {
        await statutsGarantieApi.delete(id);
        loadStatutsGarantie();
      } else if (type === 'motif-garantie') {
        await motifsGarantieApi.delete(id);
        loadMotifsGarantie();
      } else if (type === 'action-parking') {
        await referentielsApi.deleteActionParking(id);
        loadActionsParking();
      }

      onUpdate();
    } catch (error) {
      console.error('Erreur suppression:', error);
      alert('Erreur lors de la suppression');
    }
  };

  return (
    <div className="referentiels-container">
      <div className="ref-layout">
      <div className="dash-side-tabs">
        <button
          className={`dash-side-tab ${activeTab === 'responsables' ? 'active' : ''}`}
          onClick={() => setActiveTab('responsables')}
        >
          Responsables
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'marques' ? 'active' : ''}`}
          onClick={() => setActiveTab('marques')}
        >
          Marques
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'modeles' ? 'active' : ''}`}
          onClick={() => setActiveTab('modeles')}
        >
          Modèles
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'sujets' ? 'active' : ''}`}
          onClick={() => setActiveTab('sujets')}
        >
          Sujets
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'statuts-litiges' ? 'active' : ''}`}
          onClick={() => setActiveTab('statuts-litiges')}
        >
          Statuts Litiges
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'statuts-parking' ? 'active' : ''}`}
          onClick={() => setActiveTab('statuts-parking')}
        >
          Statuts Parking
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'statuts-garantie' ? 'active' : ''}`}
          onClick={() => setActiveTab('statuts-garantie')}
        >
          Statuts Garantie
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'motifs-garantie' ? 'active' : ''}`}
          onClick={() => setActiveTab('motifs-garantie')}
        >
          Motifs Garantie
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'actions-parking' ? 'active' : ''}`}
          onClick={() => setActiveTab('actions-parking')}
        >
          🎯 Actions Parking
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'ringover' ? 'active' : ''}`}
          onClick={() => setActiveTab('ringover')}
        >
          📞 Ringover
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'statuts-atelier' ? 'active' : ''}`}
          onClick={() => setActiveTab('statuts-atelier')}
        >
          🔧 Statuts Atelier
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'statuts-or-en-cours' ? 'active' : ''}`}
          onClick={() => setActiveTab('statuts-or-en-cours')}
        >
          📋 Statuts OR en cours
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'flottes-courtoisie' ? 'active' : ''}`}
          onClick={() => setActiveTab('flottes-courtoisie')}
        >
          🚙 Flottes courtoisie
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'fonctions' ? 'active' : ''}`}
          onClick={() => setActiveTab('fonctions')}
        >
          👤 Fonctions
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'sources-mapping' ? 'active' : ''}`}
          onClick={() => setActiveTab('sources-mapping')}
        >
          🌐 Sources
        </button>
        <button
          className={`dash-side-tab ${activeTab === 'statuts-leads-web' ? 'active' : ''}`}
          onClick={() => setActiveTab('statuts-leads-web')}
        >
          📥 Statuts Leads Web
        </button>
      </div>
      <div className="ref-content">

      {activeTab !== 'statuts-litiges' && activeTab !== 'statuts-parking' && activeTab !== 'statuts-garantie' && activeTab !== 'motifs-garantie' && activeTab !== 'actions-parking' && activeTab !== 'responsables' && activeTab !== 'ringover' && activeTab !== 'statuts-atelier' && activeTab !== 'statuts-or-en-cours' && activeTab !== 'flottes-courtoisie' && activeTab !== 'travaux-types' && activeTab !== 'fonctions' && activeTab !== 'sources-mapping' && activeTab !== 'statuts-leads-web' && (
        <div style={{ marginBottom: '20px' }}>
          <button
            className="btn-primary"
            onClick={() => handleAdd(
              activeTab === 'marques' ? 'marque' :
              activeTab === 'modeles' ? 'modele' : 'sujet'
            )}
          >
            ➕ Nouveau {activeTab === 'marques' ? 'marque' : activeTab === 'modeles' ? 'modèle' : 'sujet'}
          </button>
        </div>
      )}
      {activeTab === 'responsables' && (
        <div style={{ marginBottom: '16px', padding: '10px 14px', background: 'var(--bg-muted)', borderRadius: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>
          ℹ️ Les responsables sont gérés depuis la page <strong>Utilisateurs</strong> (colonne Responsable).
        </div>
      )}

      {activeTab === 'responsables' && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Concession</th>
                <th>Fonction</th>
                <th>Service</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {responsables.map(r => (
                <tr key={r.id}>
                  <td className="font-bold">{r.nom}</td>
                  <td>{r.prenom}</td>
                  <td>
                    <span style={{
                      fontSize: '11px',
                      background: 'var(--bg-muted)',
                      color: 'var(--text-secondary)',
                      padding: '3px 8px',
                      borderRadius: '4px',
                      fontWeight: '600'
                    }}>
                      {r.concession_nom || '-'}
                    </span>
                  </td>
                  <td>{r.fonction || '-'}</td>
                  <td>{r.service || '-'}</td>
                  <td>{r.email || '-'}</td>
                  <td>{r.telephone || '-'}</td>
                  <td>
                    <span style={{ fontSize: '11px', color: 'var(--text-muted)', fontStyle: 'italic' }}>
                      via Utilisateurs
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'marques' && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Concessions</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {marques.map(m => (
                <tr key={m.id}>
                  <td className="font-bold">{m.nom}</td>
                  <td>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {(m.concessions || []).length === 0 ? (
                        <span style={{ color: 'var(--text-muted)', fontStyle: 'italic', fontSize: 12 }}>
                          Aucune
                        </span>
                      ) : m.concessions.map(c => (
                        <button
                          key={c.id}
                          onClick={() => handleRemoveConcessionFromMarque(m, c)}
                          style={{
                            padding: '3px 10px', fontSize: 12, borderRadius: 12,
                            background: 'var(--color-info-light)',
                            color: 'var(--color-info)',
                            border: '1px solid var(--color-info)',
                            fontWeight: 500, whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            display: 'inline-flex', alignItems: 'center', gap: 4,
                          }}
                          title={`Retirer « ${c.nom} » de la marque « ${m.nom} »`}
                          onMouseEnter={e => {
                            e.currentTarget.style.background = 'var(--color-error-light)';
                            e.currentTarget.style.color = 'var(--color-error)';
                            e.currentTarget.style.borderColor = 'var(--color-error)';
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.background = 'var(--color-info-light)';
                            e.currentTarget.style.color = 'var(--color-info)';
                            e.currentTarget.style.borderColor = 'var(--color-info)';
                          }}
                        >
                          {c.nom} <span style={{ fontSize: 13, fontWeight: 700 }}>✕</span>
                        </button>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(m, 'marque')} className="btn-icon" title="Modifier">
                        ✏️
                      </button>
                      <button onClick={() => handleDelete(m.id, 'marque')} className="btn-icon delete" title="Supprimer">
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'modeles' && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Marque</th>
                <th>Modèle</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {modeles.map(m => (
                <tr key={m.id}>
                  <td>{m.marque_nom}</td>
                  <td className="font-bold">{m.nom}</td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(m, 'modele')} className="btn-icon" title="Modifier">
                        ✏️
                      </button>
                      <button onClick={() => handleDelete(m.id, 'modele')} className="btn-icon delete" title="Supprimer">
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'sujets' && (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sujets.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-secondary)' }}>
                    Aucun sujet
                  </td>
                </tr>
              ) : (
                sujets.map(s => (
                  <tr key={s.id}>
                    <td className="font-bold">{s.nom}</td>
                    <td>
                      <span className={`badge ${s.actif ? '' : 'inactive'}`}>
                        {s.actif ? 'Actif' : 'Inactif'}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button onClick={() => handleEdit(s, 'sujet')} className="btn-icon" title="Modifier">
                          ✏️
                        </button>
                        <button onClick={() => handleDelete(s.id, 'sujet')} className="btn-icon delete" title="Supprimer">
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'statuts-litiges' && (
        <div className="table-container">
          <button
            className="btn-primary"
            style={{ marginBottom: '20px' }}
            onClick={() => handleAdd('statut-litige')}
          >
            ➕ Nouveau statut
          </button>

          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Couleur</th>
                <th>Ordre</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {statutsLitiges.map(s => (
                <tr key={s.id}>
                  <td className="font-bold">{s.nom}</td>
                  <td>
                    <span style={{
                      display: 'inline-block',
                      width: '30px',
                      height: '20px',
                      background: s.couleur,
                      borderRadius: '4px',
                      border: '1px solid var(--border-default)',
                      marginRight: '8px'
                    }}></span>
                    {s.couleur}
                  </td>
                  <td>{s.ordre}</td>
                  <td>
                    <span className={`badge ${s.actif ? '' : 'inactive'}`}>
                      {s.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(s, 'statut-litige')} className="btn-icon">
                        ✏️
                      </button>
                      <button onClick={() => handleDelete(s.id, 'statut-litige')} className="btn-icon delete">
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'statuts-parking' && (
        <div className="table-container">
          <button
            className="btn-primary"
            style={{ marginBottom: '20px' }}
            onClick={() => handleAdd('statut-parking')}
          >
            ➕ Nouveau statut
          </button>

          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Couleur</th>
                <th>Ordre</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {statutsParking.map(s => (
                <tr key={s.id}>
                  <td className="font-bold">
                    <span style={{
                      display: 'inline-block',
                      background: s.couleur + '22',
                      color: s.couleur,
                      border: `1px solid ${s.couleur}44`,
                      padding: '3px 10px',
                      borderRadius: '10px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {s.nom}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      display: 'inline-block',
                      width: '30px',
                      height: '20px',
                      background: s.couleur,
                      borderRadius: '4px',
                      border: '1px solid var(--border-default)',
                      marginRight: '8px',
                      verticalAlign: 'middle'
                    }}></span>
                    {s.couleur}
                  </td>
                  <td>{s.ordre}</td>
                  <td>
                    <span className={`badge ${s.actif ? '' : 'inactive'}`}>
                      {s.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(s, 'statut-parking')} className="btn-icon">✏️</button>
                      <button onClick={() => handleDelete(s.id, 'statut-parking')} className="btn-icon delete">🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'statuts-garantie' && (
        <div className="table-container">
          <button
            className="btn-primary"
            style={{ marginBottom: '20px' }}
            onClick={() => handleAdd('statut-garantie')}
          >
            ➕ Nouveau statut
          </button>

          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Couleur</th>
                <th>Ordre</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {statutsGarantie.map(s => (
                <tr key={s.id}>
                  <td className="font-bold">
                    <span style={{
                      display: 'inline-block',
                      background: s.couleur + '22',
                      color: s.couleur,
                      border: `1px solid ${s.couleur}44`,
                      padding: '3px 10px',
                      borderRadius: '10px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {s.nom}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      display: 'inline-block',
                      width: '30px',
                      height: '20px',
                      background: s.couleur,
                      borderRadius: '4px',
                      border: '1px solid var(--border-default)',
                      marginRight: '8px',
                      verticalAlign: 'middle'
                    }}></span>
                    {s.couleur}
                  </td>
                  <td>{s.ordre}</td>
                  <td>
                    <span className={`badge ${s.actif ? '' : 'inactive'}`}>
                      {s.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(s, 'statut-garantie')} className="btn-icon">✏️</button>
                      <button onClick={() => handleDelete(s.id, 'statut-garantie')} className="btn-icon delete">🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'motifs-garantie' && (
        <div className="table-container">
          <button
            className="btn-primary"
            style={{ marginBottom: '20px' }}
            onClick={() => handleAdd('motif-garantie')}
          >
            ➕ Nouveau motif
          </button>

          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Ordre</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {motifsGarantie.map(m => (
                <tr key={m.id}>
                  <td className="font-bold">{m.nom}</td>
                  <td>{m.ordre}</td>
                  <td>
                    <span className={`badge ${m.actif ? '' : 'inactive'}`}>
                      {m.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(m, 'motif-garantie')} className="btn-icon">✏️</button>
                      <button onClick={() => handleDelete(m.id, 'motif-garantie')} className="btn-icon delete">🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'actions-parking' && (
        <div className="table-container">
          <button
            className="btn-primary"
            style={{ marginBottom: '20px' }}
            onClick={() => handleAdd('action-parking')}
          >
            ➕ Nouvelle action
          </button>

          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Ordre</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {actionsParking.map(a => (
                <tr key={a.id}>
                  <td className="font-bold">{a.nom}</td>
                  <td>{a.ordre}</td>
                  <td>
                    <span className={`badge ${a.actif ? '' : 'inactive'}`}>
                      {a.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => handleEdit(a, 'action-parking')} className="btn-icon">✏️</button>
                      <button onClick={() => handleDelete(a.id, 'action-parking')} className="btn-icon delete">🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'ringover' && (
        <div>
          <div style={{ marginBottom: '24px', padding: '14px 16px', background: 'var(--bg-muted)', border: '1px solid light-dark(#bae6fd, var(--border-strong))', borderRadius: '8px', fontSize: '13px', color: 'light-dark(#0369a1, var(--color-info-dark))' }}>
            <strong>📞 Intégration Ringover</strong> — Mappez chaque numéro Ringover à une concession. Quand un appel entrant est décroché sur ce numéro, une demande client est automatiquement créée (ou le compteur d'appels est incrémenté si le client rappelle).
            <br /><br />
            <strong>Configuration Ringover Dashboard → Developer → Webhooks :</strong><br />
            URL "Calls answered" : <code style={{ background: 'var(--bg-muted)', padding: '2px 6px', borderRadius: '4px' }}>https://votre-domaine.com/api/webhooks/ringover</code><br />
            Authorization Header : <code style={{ background: 'var(--bg-muted)', padding: '2px 6px', borderRadius: '4px' }}>Bearer &lt;RINGOVER_WEBHOOK_SECRET&gt;</code> (variable d'env backend)
          </div>

          {/* Formulaire ajout / édition */}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>
                Numéro Ringover (E.164)
              </label>
              <input
                type="text"
                placeholder="+33987654321"
                value={ringoverForm.numero}
                onChange={e => setRingoverForm(f => ({ ...f, numero: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '180px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>
                Concession
              </label>
              <select
                value={ringoverForm.concession_id}
                onChange={e => setRingoverForm(f => ({ ...f, concession_id: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', minWidth: '180px' }}
              >
                <option value="">Sélectionner…</option>
                {concessions.map(c => (
                  <option key={c.id} value={c.id}>{c.nom}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>
                Service (pour le reporting)
              </label>
              <select
                value={ringoverForm.service_code || ''}
                onChange={e => setRingoverForm(f => ({ ...f, service_code: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', minWidth: '160px' }}
              >
                <option value="">Non attribué</option>
                {SERVICES_RINGOVER.map(s => (
                  <option key={s.code} value={s.code}>{s.nom}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>
                Label (optionnel)
              </label>
              <input
                type="text"
                placeholder="Ex : Standard accueil"
                value={ringoverForm.label}
                onChange={e => setRingoverForm(f => ({ ...f, label: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '200px' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className="btn-primary"
                onClick={handleRingoverSave}
                disabled={!ringoverForm.numero || !ringoverForm.concession_id}
              >
                {ringoverEditing ? '💾 Enregistrer' : '➕ Ajouter'}
              </button>
              {ringoverEditing && (
                <button
                  className="btn-secondary"
                  onClick={() => { setRingoverEditing(null); setRingoverForm({ numero: '', concession_id: '', label: '', service_code: '' }); }}
                >
                  Annuler
                </button>
              )}
            </div>
          </div>

          {/* Tableau des mappings */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Numéro Ringover</th>
                  <th>Concession</th>
                  <th>Service</th>
                  <th>Label</th>
                  <th style={{ textAlign: 'center' }}>Actif</th>
                  <th style={{ textAlign: 'center' }}>Test super-admin</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ringoverMappings.length === 0 ? (
                  <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucun mapping configuré</td></tr>
                ) : ringoverMappings.map(m => (
                  <tr key={m.id}>
                    <td><code style={{ background: 'var(--bg-muted)', padding: '2px 6px', borderRadius: '4px', fontSize: '13px' }}>{m.numero}</code></td>
                    <td>
                      <span style={{ fontSize: '12px', background: 'var(--bg-muted)', color: 'light-dark(#0369a1, var(--color-info-dark))', padding: '3px 8px', borderRadius: '4px', fontWeight: '600' }}>
                        {m.concession_nom}
                      </span>
                    </td>
                    <td>
                      {m.service_code ? (
                        <span style={{ fontSize: '12px', background: 'var(--bg-muted)', color: 'var(--text-secondary)', padding: '3px 8px', borderRadius: '4px', fontWeight: '600' }}>
                          {m.service_nom || m.service_code}
                        </span>
                      ) : (
                        <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Non attribué</span>
                      )}
                    </td>
                    <td style={{ color: 'var(--text-secondary)' }}>{m.label || '—'}</td>
                    <td style={{ textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={m.actif}
                        onChange={async () => {
                          const api = (await import('../services/api')).default;
                          await api.put(`/referentiels/ringover-mappings/${m.id}`, { actif: !m.actif });
                          loadRingoverMappings();
                        }}
                        style={{ width: '18px', height: '18px', accentColor: 'var(--color-success)', cursor: 'pointer' }}
                        title={m.actif ? 'Désactiver ce numéro' : 'Activer ce numéro'}
                      />
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={m.visible_superadmin || false}
                        onChange={async () => {
                          const api = (await import('../services/api')).default;
                          await api.put(`/referentiels/ringover-mappings/${m.id}`, { visible_superadmin: !m.visible_superadmin });
                          loadRingoverMappings();
                        }}
                        style={{ width: '18px', height: '18px', accentColor: 'var(--color-info)', cursor: 'pointer' }}
                        title={m.visible_superadmin ? 'Désactiver la visibilité super-admin' : 'Activer la visibilité super-admin'}
                      />
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-icon"
                          title="Modifier"
                          onClick={() => {
                            setRingoverEditing(m);
                            setRingoverForm({ numero: m.numero, concession_id: String(m.concession_id), label: m.label || '', service_code: m.service_code || '' });
                          }}
                        >✏️</button>
                        <button
                          className="btn-icon delete"
                          title="Supprimer"
                          onClick={() => handleRingoverDelete(m.id)}
                        >🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'statuts-atelier' && (
        <div>
          {/* Formulaire ajout / édition */}
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Libellé *</label>
              <input
                type="text"
                placeholder="Ex : En cours d'intervention"
                value={newStatutAtelier.nom}
                onChange={e => setNewStatutAtelier(s => ({ ...s, nom: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '220px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Couleur carte *</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="color"
                  value={newStatutAtelier.couleur}
                  onChange={e => setNewStatutAtelier(s => ({ ...s, couleur: e.target.value }))}
                  style={{ width: '40px', height: '36px', padding: '2px', border: '1px solid var(--border-strong)', borderRadius: '6px', cursor: 'pointer' }}
                />
                <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>{newStatutAtelier.couleur}</span>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Couleur texte</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="color"
                  value={newStatutAtelier.text_color || '#000000'}
                  onChange={e => setNewStatutAtelier(s => ({ ...s, text_color: e.target.value }))}
                  style={{ width: '40px', height: '36px', padding: '2px', border: '1px solid var(--border-strong)', borderRadius: '6px', cursor: 'pointer' }}
                />
                <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>{newStatutAtelier.text_color || '#000000'}</span>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Aperçu</label>
              <div
                style={{
                  height: '36px',
                  minWidth: '140px',
                  padding: '0 12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: newStatutAtelier.couleur,
                  color: newStatutAtelier.text_color || '#000000',
                  border: '1px solid var(--border-strong)',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: 600,
                }}
              >
                {newStatutAtelier.nom || 'Aperçu'}
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Ordre</label>
              <input
                type="number"
                value={newStatutAtelier.ordre}
                onChange={e => setNewStatutAtelier(s => ({ ...s, ordre: parseInt(e.target.value) || 0 }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '80px' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className="btn-primary"
                onClick={handleSaveStatutAtelier}
                disabled={!newStatutAtelier.nom}
              >
                {editingStatutAtelier ? '💾 Enregistrer' : '➕ Ajouter'}
              </button>
              {editingStatutAtelier && (
                <button
                  className="btn-secondary"
                  onClick={() => { setEditingStatutAtelier(null); setNewStatutAtelier({ nom: '', couleur: '#E8E8E8', text_color: '#000000', ordre: 0 }); }}
                >
                  Annuler
                </button>
              )}
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Ordre</th>
                  <th>Couleur carte</th>
                  <th>Couleur texte</th>
                  <th>Aperçu</th>
                  <th>Libellé</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {statutsAtelier.map(s => (
                  <tr key={s.id}>
                    <td>{s.ordre}</td>
                    <td>
                      <span style={{ display: 'inline-block', width: 20, height: 20, background: s.couleur, borderRadius: 4, border: '1px solid var(--border-strong)', verticalAlign: 'middle' }} />
                      <span style={{ fontSize: '12px', color: 'var(--text-secondary)', marginLeft: '6px' }}>{s.couleur}</span>
                    </td>
                    <td>
                      <span style={{ display: 'inline-block', width: 20, height: 20, background: s.text_color || '#000000', borderRadius: 4, border: '1px solid var(--border-strong)', verticalAlign: 'middle' }} />
                      <span style={{ fontSize: '12px', color: 'var(--text-secondary)', marginLeft: '6px' }}>{s.text_color || '#000000'}</span>
                    </td>
                    <td>
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '4px 10px',
                          background: s.couleur,
                          color: s.text_color || '#000000',
                          borderRadius: 4,
                          border: '1px solid var(--border-strong)',
                          fontSize: '12px',
                          fontWeight: 600,
                        }}
                      >
                        {s.nom}
                      </span>
                    </td>
                    <td className="font-bold">{s.nom}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => { setEditingStatutAtelier(s); setNewStatutAtelier({ nom: s.nom, couleur: s.couleur, text_color: s.text_color || '#000000', ordre: s.ordre }); }}
                          className="btn-icon"
                        >✏️</button>
                        <button onClick={() => handleDeleteStatutAtelier(s.id)} className="btn-icon delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {statutsAtelier.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucun statut configuré</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'statuts-or-en-cours' && (
        <div>
          <div style={{ marginBottom: '16px', padding: '10px 14px', background: 'var(--bg-muted)', borderRadius: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>
            ℹ️ Statuts affichés dans la liste déroulante de chaque OR en cours. Le <strong>code</strong> est la valeur technique stockée en base (minuscules, underscores).
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Code *</label>
              <input
                type="text"
                placeholder="Ex : en_cours"
                value={newStatutOrEnCours.code}
                onChange={e => setNewStatutOrEnCours(s => ({ ...s, code: e.target.value.toLowerCase().replace(/\s+/g, '_') }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '160px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Libellé *</label>
              <input
                type="text"
                placeholder="Ex : En cours"
                value={newStatutOrEnCours.nom}
                onChange={e => setNewStatutOrEnCours(s => ({ ...s, nom: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '200px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Couleur *</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="color"
                  value={newStatutOrEnCours.couleur}
                  onChange={e => setNewStatutOrEnCours(s => ({ ...s, couleur: e.target.value }))}
                  style={{ width: '40px', height: '36px', padding: '2px', border: '1px solid var(--border-strong)', borderRadius: '6px', cursor: 'pointer' }}
                />
                <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>{newStatutOrEnCours.couleur}</span>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Aperçu</label>
              <div
                style={{
                  height: '36px',
                  minWidth: '120px',
                  padding: '0 12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: newStatutOrEnCours.couleur,
                  color: '#fff',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: 600,
                }}
              >
                {newStatutOrEnCours.nom || 'Aperçu'}
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Ordre</label>
              <input
                type="number"
                value={newStatutOrEnCours.ordre}
                onChange={e => setNewStatutOrEnCours(s => ({ ...s, ordre: parseInt(e.target.value) || 0 }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '80px' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className="btn-primary"
                onClick={handleSaveStatutOrEnCours}
                disabled={!newStatutOrEnCours.code || !newStatutOrEnCours.nom}
              >
                {editingStatutOrEnCours ? '💾 Enregistrer' : '➕ Ajouter'}
              </button>
              {editingStatutOrEnCours && (
                <button
                  className="btn-secondary"
                  onClick={() => { setEditingStatutOrEnCours(null); setNewStatutOrEnCours({ code: '', nom: '', couleur: '#6b7280', ordre: 0 }); }}
                >
                  Annuler
                </button>
              )}
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Ordre</th>
                  <th>Code</th>
                  <th>Couleur</th>
                  <th>Aperçu</th>
                  <th>Libellé</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {statutsOrEnCours.map(s => (
                  <tr key={s.id}>
                    <td>{s.ordre}</td>
                    <td><code style={{ fontSize: '12px', background: 'var(--bg-muted)', padding: '2px 6px', borderRadius: '4px' }}>{s.code}</code></td>
                    <td>
                      <span style={{ display: 'inline-block', width: 20, height: 20, background: s.couleur, borderRadius: 4, border: '1px solid var(--border-strong)', verticalAlign: 'middle' }} />
                      <span style={{ fontSize: '12px', color: 'var(--text-secondary)', marginLeft: '6px' }}>{s.couleur}</span>
                    </td>
                    <td>
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '4px 10px',
                          background: s.couleur,
                          color: '#fff',
                          borderRadius: 4,
                          fontSize: '12px',
                          fontWeight: 600,
                        }}
                      >
                        {s.nom}
                      </span>
                    </td>
                    <td className="font-bold">{s.nom}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => { setEditingStatutOrEnCours(s); setNewStatutOrEnCours({ code: s.code, nom: s.nom, couleur: s.couleur, ordre: s.ordre }); }}
                          className="btn-icon"
                        >✏️</button>
                        <button onClick={() => handleDeleteStatutOrEnCours(s.id)} className="btn-icon delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {statutsOrEnCours.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucun statut configuré</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'flottes-courtoisie' && (
        <div>
          <div style={{ marginBottom: '16px', padding: '10px 14px', background: 'var(--bg-muted)', borderRadius: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>
            ℹ️ Flottes de véhicules de courtoisie, définies <strong>par concession</strong>. Elles alimentent la colonne <strong>Flotte</strong> de l'onglet Flotte des Véhicules Courtoisie (ex. « Entreprise » pour les contrats d'entretien).
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Nom de la flotte *</label>
              <input
                type="text"
                placeholder="Ex : Entreprise"
                value={newFlotteCourtoisie.nom}
                onChange={e => setNewFlotteCourtoisie(s => ({ ...s, nom: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '220px' }}
              />
            </div>
            {!editingFlotteCourtoisie && concessions.length > 1 && (
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Concession</label>
                <select
                  value={newFlotteCourtoisie.concession_id}
                  onChange={e => setNewFlotteCourtoisie(s => ({ ...s, concession_id: e.target.value }))}
                  style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', height: '36px' }}
                >
                  <option value="">— Ma concession</option>
                  {concessions.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
                </select>
              </div>
            )}
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className="btn-primary"
                onClick={handleSaveFlotteCourtoisie}
                disabled={!newFlotteCourtoisie.nom.trim()}
              >
                {editingFlotteCourtoisie ? '💾 Enregistrer' : '➕ Ajouter'}
              </button>
              {editingFlotteCourtoisie && (
                <button
                  className="btn-secondary"
                  onClick={() => { setEditingFlotteCourtoisie(null); setNewFlotteCourtoisie({ nom: '', concession_id: '' }); }}
                >
                  Annuler
                </button>
              )}
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Flotte</th>
                  <th>Concession</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {flottesCourtoisie.map(f => (
                  <tr key={f.id}>
                    <td className="font-bold">{f.nom}</td>
                    <td>{f.concession_nom || '—'}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => { setEditingFlotteCourtoisie(f); setNewFlotteCourtoisie({ nom: f.nom, concession_id: f.concession_id || '' }); }}
                          className="btn-icon"
                        >✏️</button>
                        <button onClick={() => handleDeleteFlotteCourtoisie(f.id)} className="btn-icon delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {flottesCourtoisie.length === 0 && (
                  <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucune flotte configurée</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'statuts-leads-web' && (
        <div>
          <div style={{ marginBottom: '16px', padding: '10px 14px', background: 'var(--bg-muted)', borderRadius: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>
            ℹ️ Statuts affichés dans la liste déroulante de chaque lead, filtrés par type de service (VN, VO, Atelier, Pièces, Autres).<br/>
            🗂️ <strong>Archive</strong> : un statut marqué « archive » retire automatiquement le lead de la liste active quand il est choisi.<br/>
            🔒 Les statuts <strong>système</strong> (À contacter, CRM360, Traité) ont une logique métier attachée — leur code et leur comportement d'archivage ne peuvent pas être modifiés.
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
            {!editingStatutLeadsWeb?.systeme && (
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Code *</label>
                <input
                  type="text"
                  placeholder="ex: traite_bis"
                  value={newStatutLeadsWeb.code}
                  onChange={e => setNewStatutLeadsWeb(s => ({ ...s, code: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '') }))}
                  disabled={!!editingStatutLeadsWeb}
                  style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '160px' }}
                />
              </div>
            )}
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Libellé *</label>
              <input
                type="text"
                placeholder="Ex : À rappeler"
                value={newStatutLeadsWeb.nom}
                onChange={e => setNewStatutLeadsWeb(s => ({ ...s, nom: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '200px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Couleur *</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="color"
                  value={newStatutLeadsWeb.couleur}
                  onChange={e => setNewStatutLeadsWeb(s => ({ ...s, couleur: e.target.value }))}
                  style={{ width: '40px', height: '36px', padding: '2px', border: '1px solid var(--border-strong)', borderRadius: '6px', cursor: 'pointer' }}
                />
                <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>{newStatutLeadsWeb.couleur}</span>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Ordre</label>
              <input
                type="number"
                value={newStatutLeadsWeb.ordre}
                onChange={e => setNewStatutLeadsWeb(s => ({ ...s, ordre: parseInt(e.target.value) || 0 }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '80px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Services *</label>
              <div style={{ display: 'flex', gap: '8px', padding: '6px 4px' }}>
                {LEADS_SERVICES_CODES.map(code => (
                  <label key={code} style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={newStatutLeadsWeb.services.includes(code)}
                      onChange={() => toggleServiceInForm(code)}
                    />
                    {code}
                  </label>
                ))}
              </div>
            </div>
            {!editingStatutLeadsWeb?.systeme && (
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Archive</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', padding: '8px 0', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={newStatutLeadsWeb.archive}
                    onChange={e => setNewStatutLeadsWeb(s => ({ ...s, archive: e.target.checked }))}
                  />
                  Archive le lead
                </label>
              </div>
            )}
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className="btn-primary"
                onClick={handleSaveStatutLeadsWeb}
                disabled={!newStatutLeadsWeb.nom || !newStatutLeadsWeb.code || newStatutLeadsWeb.services.length === 0}
              >
                {editingStatutLeadsWeb ? '💾 Enregistrer' : '➕ Ajouter'}
              </button>
              {editingStatutLeadsWeb && (
                <button className="btn-secondary" onClick={resetStatutLeadsWebForm}>Annuler</button>
              )}
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Ordre</th>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Couleur</th>
                  <th>Services</th>
                  <th>Flags</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {statutsLeadsWeb.map(s => (
                  <tr key={s.id}>
                    <td>{s.ordre}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: '12px', color: 'var(--text-secondary)' }}>{s.code}</td>
                    <td className="font-bold">{s.nom}</td>
                    <td>
                      <span style={{ display: 'inline-block', width: 20, height: 20, background: s.couleur, borderRadius: 4, border: '1px solid var(--border-strong)', verticalAlign: 'middle' }} />
                      <span style={{ fontSize: '12px', color: 'var(--text-secondary)', marginLeft: '6px' }}>{s.couleur}</span>
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      {(s.services || []).map(sv => (
                        <span key={sv} style={{ display: 'inline-block', background: 'var(--bg-muted)', color: 'var(--text-secondary)', padding: '2px 6px', borderRadius: '4px', fontWeight: '600', marginRight: '4px' }}>{sv}</span>
                      ))}
                    </td>
                    <td style={{ fontSize: '11px' }}>
                      {s.systeme && <span style={{ background: 'var(--color-info-light)', color: 'light-dark(var(--color-info), var(--color-info-dark))', padding: '2px 6px', borderRadius: '4px', fontWeight: '600', marginRight: '4px' }}>🔒 système</span>}
                      {s.archive && <span style={{ background: 'var(--color-warning-light)', color: 'light-dark(var(--color-warning), var(--color-warning-dark))', padding: '2px 6px', borderRadius: '4px', fontWeight: '600' }}>🗂 archive</span>}
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => {
                            setEditingStatutLeadsWeb(s);
                            setNewStatutLeadsWeb({
                              code: s.code, nom: s.nom, couleur: s.couleur,
                              services: [...(s.services || [])], ordre: s.ordre, archive: !!s.archive,
                            });
                          }}
                          className="btn-icon"
                          title="Modifier"
                        >✏️</button>
                        <button
                          onClick={() => handleDeleteStatutLeadsWeb(s)}
                          className="btn-icon delete"
                          disabled={s.systeme}
                          title={s.systeme ? 'Statut système — non supprimable' : 'Supprimer'}
                          style={s.systeme ? { opacity: 0.35, cursor: 'not-allowed' } : {}}
                        >🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {statutsLeadsWeb.length === 0 && (
                  <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucun statut configuré</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'fonctions' && (
        <div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
            {!editingFonction && (
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Code *</label>
                <input
                  type="text"
                  placeholder="Ex : carrossier"
                  value={newFonction.code}
                  onChange={e => setNewFonction(f => ({ ...f, code: e.target.value.toLowerCase().replace(/[^a-z0-9_-]/g, '') }))}
                  style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '180px' }}
                />
              </div>
            )}
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Libellé *</label>
              <input
                type="text"
                placeholder="Ex : Carrossier"
                value={newFonction.label}
                onChange={e => setNewFonction(f => ({ ...f, label: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '220px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Ordre</label>
              <input
                type="number"
                value={newFonction.sort_order}
                onChange={e => setNewFonction(f => ({ ...f, sort_order: parseInt(e.target.value) || 0 }))}
                style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '80px' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className="btn-primary"
                onClick={handleSaveFonction}
                disabled={!newFonction.label || (!editingFonction && !newFonction.code)}
              >
                {editingFonction ? '💾 Enregistrer' : '➕ Ajouter'}
              </button>
              {editingFonction && (
                <button
                  className="btn-secondary"
                  onClick={() => { setEditingFonction(null); setNewFonction({ code: '', label: '', sort_order: 0 }); }}
                >
                  Annuler
                </button>
              )}
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Ordre</th>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {fonctionsKpi.map(f => (
                  <tr key={f.id}>
                    <td>{f.sort_order}</td>
                    <td><code style={{ fontSize: '12px', background: 'var(--bg-muted)', padding: '2px 6px', borderRadius: 4 }}>{f.code}</code></td>
                    <td className="font-bold">{f.label}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => { setEditingFonction(f); setNewFonction({ code: f.code, label: f.label, sort_order: f.sort_order || 0 }); }}
                          className="btn-icon"
                        >✏️</button>
                        <button onClick={() => handleDeleteFonction(f.id)} className="btn-icon delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {fonctionsKpi.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucune fonction configurée</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'sources-mapping' && (() => {
        if (sourcesMapping.length === 0 && !editingSourceMapping) loadSourcesMapping();
        return (
          <div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', marginBottom: '20px', flexWrap: 'wrap' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Pattern *</label>
                <input
                  type="text"
                  placeholder="blue-automobiles.com"
                  value={newSourceMapping.pattern}
                  onChange={e => setNewSourceMapping(f => ({ ...f, pattern: e.target.value }))}
                  style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '250px' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Label affiché *</label>
                <input
                  type="text"
                  placeholder="Site Blue Automobiles"
                  value={newSourceMapping.label}
                  onChange={e => setNewSourceMapping(f => ({ ...f, label: e.target.value }))}
                  style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '220px' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '4px' }}>Ordre</label>
                <input
                  type="number"
                  value={newSourceMapping.ordre}
                  onChange={e => setNewSourceMapping(f => ({ ...f, ordre: parseInt(e.target.value) || 0 }))}
                  style={{ padding: '8px 10px', border: '1px solid var(--border-strong)', borderRadius: '6px', fontSize: '13px', width: '70px' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  className="btn-primary"
                  disabled={!newSourceMapping.pattern.trim() || !newSourceMapping.label.trim()}
                  onClick={async () => {
                    try {
                      if (editingSourceMapping) {
                        await referentielsApi.updateSourceMapping(editingSourceMapping.id, newSourceMapping);
                        setEditingSourceMapping(null);
                      } else {
                        await referentielsApi.createSourceMapping(newSourceMapping);
                      }
                      setNewSourceMapping({ pattern: '', label: '', ordre: 0 });
                      loadSourcesMapping();
                    } catch (e) { alert(e.response?.data?.error || 'Erreur'); }
                  }}
                >
                  {editingSourceMapping ? '💾 Enregistrer' : '➕ Ajouter'}
                </button>
                {editingSourceMapping && (
                  <button className="btn-secondary" onClick={() => { setEditingSourceMapping(null); setNewSourceMapping({ pattern: '', label: '', ordre: 0 }); }}>Annuler</button>
                )}
              </div>
            </div>
            <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '12px' }}>
              Si la source d'un lead <strong>contient</strong> le pattern, elle sera regroupée sous le label dans le tableau de bord.
            </p>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Ordre</th>
                    <th>Pattern</th>
                    <th>Label affiché</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sourcesMapping.map(sm => (
                    <tr key={sm.id}>
                      <td>{sm.ordre}</td>
                      <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{sm.pattern}</td>
                      <td className="font-bold">{sm.label}</td>
                      <td>
                        <div className="action-buttons">
                          <button className="btn-icon" onClick={() => { setEditingSourceMapping(sm); setNewSourceMapping({ pattern: sm.pattern, label: sm.label, ordre: sm.ordre }); }}>✏️</button>
                          <button className="btn-icon delete" onClick={async () => { if (!window.confirm('Supprimer ce mapping ?')) return; await referentielsApi.deleteSourceMapping(sm.id); loadSourcesMapping(); }}>🗑️</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {sourcesMapping.length === 0 && (
                    <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>Aucun mapping configuré</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      })()}

      </div>
      </div>

      {showModal && modalType === 'responsable' && (
        <ResponsableModal
          responsable={editingItem}
          concessions={concessions}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'marque' && (
        <MarqueModal
          marque={editingItem}
          concessions={concessions}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'modele' && (
        <ModeleModal
          modele={editingItem}
          marques={marques}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'sujet' && (
        <SujetModal
          sujet={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'statut-litige' && (
        <StatutLitigeModal
          statut={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'statut-parking' && (
        <StatutParkingModal
          statut={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'statut-garantie' && (
        <StatutGarantieModal
          statut={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'motif-garantie' && (
        <MotifGarantieModal
          motif={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}

      {showModal && modalType === 'action-parking' && (
        <ActionParkingModal
          action={editingItem}
          onSave={handleSave}
          onClose={() => {
            setShowModal(false);
            setEditingItem(null);
          }}
        />
      )}
    </div>
  );
}

// Modal Responsable
function ResponsableModal({ responsable, concessions, onSave, onClose }) {
  const [formData, setFormData] = useState(responsable || {
    nom: '',
    prenom: '',
    fonction: '',
    service: '',
    email: '',
    telephone: '',
    concession_id: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{responsable ? 'Modifier le responsable' : 'Nouveau responsable'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-grid">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value.toUpperCase() })}
                required
              />
            </div>

            <div className="form-group">
              <label>Prénom</label>
              <input
                type="text"
                value={formData.prenom}
                onChange={(e) => {
                  const value = e.target.value;
                  const formatted = value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';
                  setFormData({ ...formData, prenom: formatted });
                }}
              />
            </div>

            <div className="form-group">
              <label>Fonction</label>
              <input
                type="text"
                value={formData.fonction}
                onChange={(e) => setFormData({ ...formData, fonction: e.target.value })}
                placeholder="Chef d'atelier, Mécanicien..."
              />
            </div>

            <div className="form-group">
              <label>Service</label>
              <input
                type="text"
                value={formData.service}
                onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                placeholder="Mécanique, Carrosserie..."
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Téléphone</label>
              <input
                type="tel"
                value={formData.telephone}
                onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
              />
            </div>

            <div className="form-group full">
              <label>Concession</label>
              <select
                value={formData.concession_id}
                onChange={(e) => setFormData({ ...formData, concession_id: parseInt(e.target.value) || '' })}
              >
                <option value="">Toutes les concessions</option>
                {concessions.map(c => (
                  <option key={c.id} value={c.id}>{c.nom}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {responsable ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Modal Marque
function MarqueModal({ marque, concessions = [], onSave, onClose }) {
  const [formData, setFormData] = useState({
    nom: marque?.nom || '',
    concession_ids: marque?.concessions?.map(c => c.id) || marque?.concession_ids || concessions.map(c => c.id),
    logo_url: marque?.logo_url || '',
    couleur: marque?.couleur || '',
  });

  const toggleConcession = (id) => {
    setFormData(f => ({
      ...f,
      concession_ids: f.concession_ids.includes(id)
        ? f.concession_ids.filter(cid => cid !== id)
        : [...f.concession_ids, id],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.concession_ids.length === 0) {
      alert('Veuillez sélectionner au moins une concession.');
      return;
    }
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{marque ? 'Modifier la marque' : 'Nouvelle marque'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-group">
            <label>Nom de la marque *</label>
            <input
              type="text"
              value={formData.nom}
              onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
              required
              placeholder="Ex: Peugeot, Renault..."
            />
          </div>

          <div className="form-group">
            <label>Concessions *</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
              {concessions.map(c => (
                <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.9rem', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={formData.concession_ids.includes(c.id)}
                    onChange={() => toggleConcession(c.id)}
                  />
                  {c.nom}
                </label>
              ))}
            </div>
          </div>

          {/* Identité visuelle : utilisée par la borne d'accueil et par la file
              de réception, uniquement pour les concessions ayant activé
              « Marque du véhicule dans la file de réception ». */}
          <div className="form-group">
            <label>Logo (URL)</label>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <input
                type="url"
                value={formData.logo_url}
                onChange={(e) => setFormData({ ...formData, logo_url: e.target.value })}
                placeholder="https://…/ford.png"
                style={{ flex: 1 }}
              />
              <div style={{
                width: 40, height: 40, borderRadius: 8, flexShrink: 0,
                border: '1px solid var(--border-default)', background: 'var(--bg-surface)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
              }}>
                {formData.logo_url ? (
                  <img src={formData.logo_url} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }}
                       onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                ) : (
                  <span style={{
                    fontWeight: 800, fontSize: 15,
                    color: formData.couleur || 'var(--text-muted)',
                  }}>{(formData.nom || '?').charAt(0).toUpperCase()}</span>
                )}
              </div>
            </div>
            <small style={{ color: 'var(--text-muted)', marginTop: 4, display: 'block', fontSize: 12 }}>
              Affiché sur la borne d'accueil et sur les cartes de la file de réception. Vide = pastille à initiale : aucun écran ne casse si le logo manque.
            </small>
          </div>

          <div className="form-group">
            <label>Couleur de la marque</label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input
                type="color"
                value={formData.couleur || '#64748b'}
                onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                style={{ width: 46, height: 34, padding: 2 }}
              />
              <input
                type="text"
                value={formData.couleur}
                onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                placeholder="#1560BD"
                style={{ width: 110 }}
              />
              {formData.couleur && (
                <button type="button" className="btn-secondary" style={{ height: 34, padding: '0 12px' }}
                        onClick={() => setFormData({ ...formData, couleur: '' })}>
                  Réinitialiser
                </button>
              )}
            </div>
            <small style={{ color: 'var(--text-muted)', marginTop: 4, display: 'block', fontSize: 12 }}>
              Sert uniquement à la pastille à initiale, quand aucun logo n'est renseigné.
            </small>
          </div>
        </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {marque ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Modal Modele
function ModeleModal({ modele, marques, onSave, onClose }) {
  const [formData, setFormData] = useState(modele || {
    marque_id: '',
    nom: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{modele ? 'Modifier le modèle' : 'Nouveau modèle'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-grid">
            <div className="form-group full">
              <label>Marque *</label>
              <select
                value={formData.marque_id}
                onChange={(e) => setFormData({ ...formData, marque_id: parseInt(e.target.value) })}
                required
              >
                <option value="">Sélectionner...</option>
                {marques.map(m => (
                  <option key={m.id} value={m.id}>{m.nom}</option>
                ))}
              </select>
            </div>

            <div className="form-group full">
              <label>Nom du modèle *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                placeholder="Ex: 308, Clio..."
              />
            </div>
          </div>
        </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {modele ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Modal Sujet
function SujetModal({ sujet, onSave, onClose }) {
  const [formData, setFormData] = useState(sujet || {
    nom: '',
    actif: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{sujet ? 'Modifier le sujet' : 'Nouveau sujet'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nom du sujet *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                placeholder="Ex: Avancement, Rappel..."
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={formData.actif}
                  onChange={(e) => setFormData({ ...formData, actif: e.target.checked })}
                />
                Actif
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {sujet ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Modal Statut Litige
function StatutLitigeModal({ statut, onSave, onClose }) {
  const [formData, setFormData] = useState(statut || {
    nom: '',
    couleur: '#64748b',
    ordre: 0,
    actif: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{statut ? 'Modifier le statut' : 'Nouveau statut'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>Couleur (hex) *</label>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="color"
                  value={formData.couleur}
                  onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                />
                <input
                  type="text"
                  value={formData.couleur}
                  onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                  pattern="^#[0-9A-Fa-f]{6}$"
                  placeholder="#64748b"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Ordre</label>
              <input
                type="number"
                value={formData.ordre}
                onChange={(e) => setFormData({ ...formData, ordre: parseInt(e.target.value) })}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={formData.actif}
                  onChange={(e) => setFormData({ ...formData, actif: e.target.checked })}
                />
                Actif
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {statut ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Teintes proposées pour la borne d'accueil. Ce sont des points de départ :
// la charte exacte d'un constructeur se colle dans le champ hexadécimal.
const COULEURS_BORNE = [
  { hex: '#1d4ed8', nom: 'Bleu (défaut)' },
  { hex: '#00285a', nom: 'Bleu nuit' },
  { hex: '#0891b2', nom: 'Cyan CRM' },
  { hex: '#0f766e', nom: 'Vert profond' },
  { hex: '#b91c1c', nom: 'Rouge' },
  { hex: '#c2410c', nom: 'Orange' },
  { hex: '#4c1d95', nom: 'Violet' },
  { hex: '#1f2937', nom: 'Anthracite' },
];

// Composant ConcessionModal
function ConcessionModal({ concession, plaques = [], onSave, onClose }) {
  const [formData, setFormData] = useState(concession ? {
    ...concession,
    codes_externes: Array.isArray(concession.codes_externes) ? concession.codes_externes : [],
  } : {
    nom: '',
    code: '',
    adresse: '',
    telephone: '',
    email: '',
    slug: '',
    codes_externes: [],
  });
  const [codeInput, setCodeInput] = useState('');

  // Fiches Google de la concession, pour choisir celle qui alimente la note de
  // la pastille Planning (ex. la fiche APV). Chargées seulement quand la note
  // est activée sur une concession existante : la liste ne sert à rien avant.
  const [gmbFiches, setGmbFiches] = useState(null); // null = pas chargées
  useEffect(() => {
    if (!concession?.id || !formData.jdma_note_planning_enabled || gmbFiches !== null) return;
    api.get('/gmb/locations')
      .then(r => setGmbFiches((r.data?.locations || []).filter(l => l.concession_id === concession.id)))
      .catch(() => setGmbFiches([]));   // sans accès GMB : le select est simplement absent
  }, [concession?.id, formData.jdma_note_planning_enabled, gmbFiches]);

  const generateSlug = (nom) => nom.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const addCodeExterne = (raw) => {
    const trimmed = (raw || '').trim();
    if (!trimmed) return;
    if ((formData.codes_externes || []).includes(trimmed)) { setCodeInput(''); return; }
    setFormData(prev => ({ ...prev, codes_externes: [...(prev.codes_externes || []), trimmed] }));
    setCodeInput('');
  };
  const removeCodeExterne = (code) => {
    setFormData(prev => ({ ...prev, codes_externes: (prev.codes_externes || []).filter(c => c !== code) }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Si l'utilisateur a tap\u00e9 un code sans appuyer Entr\u00e9e, on l'inclut.
    let payload = formData;
    const pending = codeInput.trim();
    if (pending && !(formData.codes_externes || []).includes(pending)) {
      payload = { ...formData, codes_externes: [...(formData.codes_externes || []), pending] };
    }
    onSave(payload);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{concession ? 'Modifier la concession' : 'Nouvelle concession'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-grid">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>Code *</label>
              <input
                type="text"
                value={formData.code}
                onChange={(e) => setFormData({ ...formData, code: e.target.value.toUpperCase() })}
                required
                maxLength="10"
              />
            </div>

            <div className="form-group full">
              <label>Codes externes (import DMS / CSV pièces)</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '6px 8px', minHeight: 38, border: '1px solid var(--border-default)', borderRadius: 8, background: 'var(--bg-input)', alignItems: 'center' }}>
                {(formData.codes_externes || []).map(code => (
                  <span key={code} className="filter-chip" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                    {code}
                    <button
                      type="button"
                      onClick={() => removeCodeExterne(code)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', padding: 0, fontSize: 12 }}
                      title="Retirer ce code"
                    >✕</button>
                  </span>
                ))}
                <input
                  type="text"
                  value={codeInput}
                  onChange={(e) => setCodeInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ',') {
                      e.preventDefault();
                      addCodeExterne(codeInput);
                    } else if (e.key === 'Backspace' && !codeInput && (formData.codes_externes || []).length > 0) {
                      // Backspace sur input vide : retire le dernier code
                      const last = formData.codes_externes[formData.codes_externes.length - 1];
                      removeCodeExterne(last);
                    }
                  }}
                  onBlur={() => addCodeExterne(codeInput)}
                  placeholder="Tapez un code et Entrée…"
                  style={{ flex: 1, minWidth: 120, border: 'none', outline: 'none', background: 'transparent', fontSize: 14 }}
                />
              </div>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Codes utilisés par les imports externes pour identifier cette concession (ex : 06, 10 pour Centrautodis ; 60, 66 pour Soguava Sorek).
              </small>
            </div>

            <div className="form-group full">
              <label>Adresse</label>
              <input
                type="text"
                value={formData.adresse}
                onChange={(e) => setFormData({ ...formData, adresse: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Téléphone</label>
              <input
                type="tel"
                value={formData.telephone}
                onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>

            <div className="form-group full">
              <label>Slug URL (prise de RDV en ligne)</label>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <input
                  type="text"
                  value={formData.slug || ''}
                  onChange={(e) => setFormData({ ...formData, slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') })}
                  placeholder={formData.nom ? generateSlug(formData.nom) : 'ex: opel-reunion'}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn-secondary"
                  style={{ whiteSpace: 'nowrap', fontSize: '12px', padding: '6px 10px' }}
                  onClick={() => setFormData({ ...formData, slug: generateSlug(formData.nom || '') })}
                  disabled={!formData.nom}
                >
                  Générer
                </button>
              </div>
              {formData.slug && (
                <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                  URL : /prise-rdv/<strong>{formData.slug}</strong>
                </small>
              )}
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.carre_receptionnaire_enabled}
                  onChange={(e) => setFormData({ ...formData, carre_receptionnaire_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🎨 Carré de couleur du réceptionnaire sur les cartes
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Ajoute un petit carré en haut à droite de chaque carte du Planning, à la
                couleur configurée pour le réceptionnaire dans <strong>Configuration ▸ Équipe</strong>.
                Chacun repère ainsi ses dossiers d'un coup d'œil. Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.atelier_onglet_enabled}
                  onChange={(e) => setFormData({ ...formData, atelier_onglet_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🔧 Onglet « Atelier » dans la modale d'intervention
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Ouvre un onglet où le compagnon consigne ce qu'il a fait sur le véhicule (champ
                libre). Le réglage suit la concession <strong>du dossier</strong> : un dossier
                d'une autre concession garde le comportement de la sienne. Désactivé par défaut.
              </small>
            </div>

            {/* Rappel de RDV J-1 par SMS. Trois états et non une case à cocher :
                « simulation » journalise ce qui PARTIRAIT sans rien envoyer,
                et c'est par là qu'on met en service — on lit une vraie journée
                avant qu'elle ne parte chez les clients. */}
            <div className="form-group full">
              <label htmlFor="cc-rappel-rdv">📱 Rappel de RDV la veille (SMS)</label>
              <select
                id="cc-rappel-rdv"
                value={formData.rappel_rdv_mode || 'off'}
                onChange={(e) => setFormData({ ...formData, rappel_rdv_mode: e.target.value })}
              >
                <option value="off">Désactivé</option>
                <option value="simulation">Simulation — journalise sans envoyer</option>
                <option value="actif">Actif — envoie réellement</option>
              </select>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Envoi automatique à <strong>17h00</strong> du modèle « Rappel RDV J+1 » aux clients dont le
                rendez-vous est le lendemain. Uniquement les rendez-vous <strong>saisis dans le CRM</strong>
                (ceux importés de Mécaplanning sont exclus), avec un numéro de mobile valide, et une seule fois
                par dossier. Nécessite l'envoi de SMS activé et un modèle « Rappel » pour cette concession.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.rdv_online_enabled}
                  onChange={(e) => setFormData({ ...formData, rdv_online_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🗓️ Prise de rendez-vous en ligne
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, le module public de prise de RDV atelier est accessible pour cette concession (via son slug). Nécessite un slug et des prestations configurées. Désactivé par défaut.
              </small>
            </div>

            {/* Amplitude d'ouverture retenue pour CALCULER les créneaux proposés
                en ligne. Affichée seulement quand la prise de RDV est active :
                sans elle, ces trois champs ne pilotent rien. */}
            {formData.rdv_online_enabled && (
              <div className="form-group full">
                <label>🕐 Horaires proposés en ligne</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <input
                    type="time"
                    aria-label="Heure d'ouverture"
                    value={(formData.rdv_heure_ouverture || '07:30').substring(0, 5)}
                    onChange={(e) => setFormData({ ...formData, rdv_heure_ouverture: e.target.value })}
                    style={{ width: 'auto' }}
                  />
                  <span style={{ color: 'var(--text-muted)' }}>→</span>
                  <input
                    type="time"
                    aria-label="Heure de fermeture"
                    value={(formData.rdv_heure_fermeture || '17:30').substring(0, 5)}
                    onChange={(e) => setFormData({ ...formData, rdv_heure_fermeture: e.target.value })}
                    style={{ width: 'auto' }}
                  />
                </div>

                <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                  {[[1, 'Lun'], [2, 'Mar'], [3, 'Mer'], [4, 'Jeu'], [5, 'Ven'], [6, 'Sam'], [7, 'Dim']].map(([iso, court]) => {
                    // Défaut lundi-samedi : c'est la valeur posée par la migration.
                    const jours = formData.rdv_jours_ouvres || [1, 2, 3, 4, 5, 6];
                    const actif = jours.includes(iso);
                    return (
                      <button
                        key={iso}
                        type="button"
                        onClick={() => setFormData({
                          ...formData,
                          rdv_jours_ouvres: actif ? jours.filter(j => j !== iso) : [...jours, iso].sort()
                        })}
                        style={{
                          padding: '6px 12px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                          fontWeight: actif ? 600 : 400,
                          border: `1px solid ${actif ? 'var(--color-accent)' : 'var(--border-default)'}`,
                          background: actif ? 'var(--color-info-light)' : 'var(--bg-surface)',
                          color: actif ? 'var(--color-info)' : 'var(--text-secondary)'
                        }}
                      >
                        {court}
                      </button>
                    );
                  })}
                </div>

                <small style={{ color: 'var(--text-muted)', marginTop: '6px', display: 'block', fontSize: '12px' }}>
                  Amplitude et jours dans lesquels les créneaux sont proposés au client.
                  Le calcul en retire les absences, les pauses, les interventions déjà posées et les
                  jours fériés du territoire. Aucun créneau n'est proposé <strong>le jour même</strong> :
                  une demande en ligne attend qu'un réceptionnaire la confirme.
                </small>
              </div>
            )}

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.nextlane_or_backfill}
                  onChange={(e) => setFormData({ ...formData, nextlane_or_backfill: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🔩 N° d'OR Datacar → Planning (redescente automatique)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, les numéros d'OR ouverts dans Datacar depuis un rendez-vous redescendent automatiquement
                sur les dossiers du Planning Atelier (rapprochement par immatriculation + jour, ne remplit que les
                dossiers sans OR, n'écrase jamais). La fréquence se règle dans Synchronisation
                (« Nextlane — N° d'OR → Planning »). Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.magasin_enabled}
                  onChange={(e) => setFormData({ ...formData, magasin_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🛎️ File Virtuelle Magasin (borne d'accueil Pièces)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, la borne d'accueil publique du comptoir Pièces est accessible pour cette concession (via son slug), uniquement depuis les IP autorisées. Les motifs et vendeurs se configurent dans l'onglet « File Virtuelle Magasin ». Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label>🛎️ Borne d'accueil Atelier — titre affiché</label>
              <input
                type="text"
                value={formData.borne_titre || ''}
                onChange={(e) => setFormData({ ...formData, borne_titre: e.target.value })}
                placeholder={formData.nom ? `Bienvenue chez ${formData.nom} !` : 'Bienvenue !'}
              />
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Affiché en grand sur la tablette du comptoir. Vide = « Bienvenue chez {formData.nom || '…'} ! »
              </small>
            </div>

            <div className="form-group full">
              <label>Logo de la borne (URL)</label>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="url"
                  value={formData.borne_logo_url || ''}
                  onChange={(e) => setFormData({ ...formData, borne_logo_url: e.target.value })}
                  placeholder="https://…/logo.png"
                  style={{ flex: 1 }}
                />
                {formData.borne_logo_url && (
                  <img
                    src={formData.borne_logo_url}
                    alt=""
                    style={{ maxHeight: 38, maxWidth: 110, background: 'var(--bg-surface)', borderRadius: 6, padding: 4, border: '1px solid var(--border-default)' }}
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                )}
              </div>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Posé sur une plaque blanche : un logo sombre ou transparent reste lisible. Vide = initiales de la concession.
              </small>
            </div>

            <div className="form-group full">
              <label>Couleur de marque de la borne</label>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                <input
                  type="color"
                  value={formData.borne_couleur || '#1d4ed8'}
                  onChange={(e) => setFormData({ ...formData, borne_couleur: e.target.value })}
                  style={{ width: 46, height: 36, padding: 2, cursor: 'pointer' }}
                  aria-label="Choisir la couleur de marque"
                />
                <input
                  type="text"
                  value={formData.borne_couleur || ''}
                  onChange={(e) => setFormData({ ...formData, borne_couleur: e.target.value })}
                  placeholder="#1d4ed8"
                  style={{ width: 110, fontFamily: 'monospace' }}
                />
                {COULEURS_BORNE.map(c => (
                  <button
                    key={c.hex}
                    type="button"
                    title={c.nom}
                    onClick={() => setFormData({ ...formData, borne_couleur: c.hex })}
                    style={{
                      width: 28, height: 28, borderRadius: '50%', background: c.hex, cursor: 'pointer',
                      border: (formData.borne_couleur || '').toLowerCase() === c.hex ? '3px solid var(--text-primary)' : '1px solid var(--border-default)',
                    }}
                  />
                ))}
                <button
                  type="button"
                  className="btn-secondary"
                  style={{ fontSize: '12px', padding: '6px 10px' }}
                  onClick={() => setFormData({ ...formData, borne_couleur: '' })}
                >
                  Réinitialiser
                </button>
              </div>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Une seule couleur suffit : le bandeau, les boutons et les fonds de la borne en sont dérivés automatiquement. Pour respecter la charte d'un constructeur, collez son code hexadécimal.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.borne_depannage_enabled}
                  onChange={(e) => setFormData({ ...formData, borne_depannage_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🪝 Borne : entrée dépanneur (véhicule sans RDV)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, la borne d'accueil affiche un bouton « Je suis un dépanneur » : le véhicule remorqué est enregistré et remonte dans le bloc « À planifier » du planning. Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.affichage_nom_enabled}
                  onChange={(e) => setFormData({ ...formData, affichage_nom_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                📺 Écran de salle d'attente : afficher le nom (Prénom + Initiale)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, l'écran d'affichage montre « <strong>RDV1 · Géraldine G.</strong> » (code d'appel + prénom et initiale du nom) au lieu du code seul. Compromis RGPD : plus parlant qu'un code, bien moins identifiant que le nom complet, sur un écran visible de toute la salle. Désactivé par défaut (code d'appel seul).
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.relance_rdv_sms_enabled}
                  onChange={(e) => setFormData({ ...formData, relance_rdv_sms_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                📅 Relances Atelier : proposer un RDV par SMS (lien de prise de RDV)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Autorise, depuis Relances Atelier, l'envoi d'un SMS avec un lien de prise de RDV en ligne pré-rempli (token de suivi) : quand le client réserve, la relance passe automatiquement en « RDV pris ». Nécessite la <strong>prise de RDV en ligne activée</strong>. Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.consentement_enabled}
                  onChange={(e) => setFormData({ ...formData, consentement_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🛡️ Consentements : contrôler la prospection avec la brique A97 RGPD
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, tout SMS de <strong>prospection</strong> (relance commerciale) est soumis à la brique rgpd.a97.fr avant envoi : sans consentement établi, l'envoi est refusé et tracé ; Relances Atelier affiche l'état du consentement téléphonique (loi du 11 août 2026) et permet de le demander par SMS ; le statut « Ne pas contacter » y est remonté comme opposition. Les SMS de <strong>service</strong> (rappel de RDV, véhicule prêt, Takata…) ne sont jamais bloqués. Si la brique est injoignable, la prospection est refusée (sécurité). Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.marque_file_enabled}
                  onChange={(e) => setFormData({ ...formData, marque_file_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                🚗 Marque du véhicule dans la file de réception
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Pour les concessions <strong>multimarques</strong> dont les réceptionnaires s'organisent par marque. Affiche la marque sur chaque carte de la file de réception et ajoute un filtre par marque. La borne d'accueil demande alors sa marque au client sans rendez-vous — un écran de plus, un seul geste. Sans intérêt pour une concession mono-marque : désactivé par défaut. Les logos se chargent dans Référentiels ▸ Marques.
              </small>
            </div>

            <div className="form-group">
              <label>🗺️ Plaque *</label>
              <select
                value={formData.plaque_id ?? ''}
                onChange={(e) => setFormData({ ...formData, plaque_id: e.target.value ? parseInt(e.target.value, 10) : '' })}
                required
              >
                <option value="">Sélectionner...</option>
                {plaques.map(p => (
                  <option key={p.id} value={p.id}>{p.nom} ({p.code})</option>
                ))}
              </select>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                <strong>Périmètre régional</strong> de la concession : un téléopérateur de cette plaque la voit, ceux des autres plaques non. La plaque ne porte aucun réglage métier — tout se règle ici, sur la concession.
              </small>
            </div>

            <div className="form-group">
              <label>🗓️ Territoire</label>
              <select
                value={formData.territoire || ''}
                onChange={(e) => setFormData({ ...formData, territoire: e.target.value })}
              >
                <option value="">— Non renseigné —</option>
                <option value="Guadeloupe">Guadeloupe</option>
                <option value="Martinique">Martinique</option>
              </select>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Détermine les <strong>jours fériés</strong> qui ferment le Planning Atelier. Le calendrier est celui de <em>Budget → Jours ouvrés</em>, partagé avec le Reporting Financier. <strong>Sans territoire, aucun jour n'est fermé</strong> — mieux vaut un planning ouvert un férié qu'un planning fermé le mauvais jour.
              </small>
            </div>

            <div className="form-group">
              <label>🏷️ Activité</label>
              <select
                value={formData.activite || 'auto'}
                onChange={(e) => setFormData({ ...formData, activite: e.target.value })}
              >
                <option value="auto">Automobile</option>
                <option value="boulangerie">Boulangerie</option>
                <option value="agriculture">Agriculture</option>
                <option value="autre">Autre</option>
              </select>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Métier de la concession. Sert à la portée « <strong>mon activité</strong> » du Fil : une publication pour l'activité Automobile est vue par toutes les concessions automobiles du groupe.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.jdma_note_planning_enabled}
                  onChange={(e) => setFormData({ ...formData, jdma_note_planning_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                ⭐ Note JDMA de l'atelier sur le Planning
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Affiche dans la barre du Planning Atelier la <strong>note d'entretien JDMA des 30 derniers jours</strong> (avis APV uniquement) et la <strong>note Google des 30 derniers jours</strong>, avec le détail au survol. <strong>Visible par toute l'équipe du planning, techniciens compris</strong> — exposer en permanence un score de qualité est une décision de management : désactivé par défaut. En dessous de 10 avis notés sur la période, la note n'est pas affichée (une seule mauvaise note ferait chuter la moyenne d'un demi-point).
              </small>
              {formData.jdma_note_planning_enabled && concession?.id && Array.isArray(gmbFiches) && gmbFiches.length > 0 && (
                <div style={{ marginTop: 8 }}>
                  <label style={{ fontSize: 13 }}>Fiche Google pour la note</label>
                  <select
                    value={formData.jdma_note_gmb_location_id ?? ''}
                    onChange={(e) => setFormData({ ...formData, jdma_note_gmb_location_id: e.target.value ? parseInt(e.target.value, 10) : '' })}
                  >
                    <option value="">— Toutes les fiches de la concession —</option>
                    {gmbFiches.map(l => (
                      <option key={l.id} value={l.id}>{l.alias || l.title}</option>
                    ))}
                  </select>
                  <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                    Quand la concession a plusieurs fiches Google (vente, APV, occasions…), choisissez celle dont la note est pertinente pour l'atelier — typiquement la fiche APV.
                  </small>
                </div>
              )}
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.affectation_auto_leads_web}
                  onChange={(e) => setFormData({ ...formData, affectation_auto_leads_web: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                Affectation automatique des leads web (VN / VO)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, les leads VN et VO entrants sont attribués automatiquement aux vendeurs autorisés (round-robin). Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.suivi_lead_interne}
                  onChange={(e) => setFormData({ ...formData, suivi_lead_interne: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                Suivi complet des leads dans le CRM (sans CRM360)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, les leads VN / VO de cette concession se pilotent de bout en bout via un jeu de statuts étendu (À traiter, Affaire chaude, Devis, Bon de commande, Livré…) à la place de la bascule CRM360 + numéro de lead. Les autres concessions ne sont pas affectées. Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.gmb_enabled}
                  onChange={(e) => setFormData({ ...formData, gmb_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                Google My Business (Avis)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, les avis Google des fiches rattachées à cette concession sont synchronisés dans le CRM. Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={!!formData.retours_prospects_enabled}
                  onChange={(e) => setFormData({ ...formData, retours_prospects_enabled: e.target.checked })}
                  style={{ width: 'auto', margin: 0 }}
                />
                Satisfaction clients (questionnaire NPS)
              </label>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Quand activé, un collaborateur de cette concession peut envoyer par SMS/email un questionnaire de satisfaction aux prospects après leur passage. Désactivé par défaut.
              </small>
            </div>

            <div className="form-group full">
              <label>✉️ Nom d'expéditeur e-mail (mails client)</label>
              <input
                type="text"
                placeholder="ex. Soguava"
                value={formData.email_expediteur_nom || ''}
                onChange={(e) => setFormData({ ...formData, email_expediteur_nom: e.target.value })}
              />
              <label style={{ marginTop: 8 }}>Adresse de réponse (reply-to)</label>
              <input
                type="email"
                placeholder="ex. contact@soguava.fr"
                value={formData.email_reply_to || ''}
                onChange={(e) => setFormData({ ...formData, email_reply_to: e.target.value })}
              />
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Les mails client (confirmations RDV, satisfaction…) partent de « <b>{formData.email_expediteur_nom || formData.nom || 'Nom'}</b> &lt;no-reply@a97.fr&gt; » avec cette adresse de réponse. Laissez vide pour l'expéditeur générique « CRM A97 ».
              </small>
            </div>

            <div className="form-group full">
              <label>📨 Questionnaire de satisfaction — canal d'envoi</label>
              <select
                value={formData.satisfaction_canaux || 'sms'}
                onChange={(e) => setFormData({ ...formData, satisfaction_canaux: e.target.value })}
              >
                <option value="sms">SMS uniquement</option>
                <option value="email">E-mail uniquement</option>
                <option value="sms_email">SMS et e-mail</option>
              </select>
              <small style={{ color: 'var(--text-muted)', marginTop: '4px', display: 'block', fontSize: '12px' }}>
                Canal utilisé pour les campagnes de satisfaction de cette concession (client joignable par SMS et/ou e-mail selon le fichier).
              </small>
            </div>
          </div>
        </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-primary">
              {concession ? 'Modifier' : 'Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Composant ConcessionsView
function ConcessionsView({ concessions, plaques = [], onEdit, onDelete }) {
  const plaqueDe = (id) => plaques.find(p => p.id === id);
  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Nom</th>
            <th>Code</th>
            <th>Plaque</th>
            <th>Codes externes</th>
            <th>Adresse</th>
            <th>Téléphone</th>
            <th>Email</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {concessions.map(c => (
            <tr key={c.id}>
              <td className="font-bold">{c.nom}</td>
              <td>{c.code}</td>
              <td>{plaqueDe(c.plaque_id)?.code || <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
              <td>
                {(c.codes_externes || []).length > 0 ? (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {c.codes_externes.map(code => (
                      <span key={code} className="filter-chip">{code}</span>
                    ))}
                  </div>
                ) : <span style={{ color: 'var(--text-muted)' }}>—</span>}
              </td>
              <td>{c.adresse || '-'}</td>
              <td>{c.telephone || '-'}</td>
              <td>{c.email || '-'}</td>
              <td>
                <span className={`badge ${c.actif ? '' : 'inactive'}`}>
                  {c.actif ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td>
                <div className="action-buttons">
                  <button onClick={() => onEdit(c)} className="btn-icon" title="Modifier">
                    ✏️
                  </button>
                  <button onClick={() => onDelete(c.id)} className="btn-icon delete" title="Désactiver">
                    🗑️
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Composant PasswordModal - Changement de mot de passe personnel
function PasswordModal({ onSave, onClose, strict }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const hasMinLength = newPassword.length >= (strict ? 8 : 6);
  const hasUppercase = !strict || /[A-Z]/.test(newPassword);
  const hasSpecial = !strict || /[^a-zA-Z0-9]/.test(newPassword);
  const passwordValid = hasMinLength && hasUppercase && hasSpecial;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!passwordValid) {
      setError('Le mot de passe ne respecte pas les critères de sécurité');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    try {
      setLoading(true);
      await onSave(currentPassword, newPassword);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors du changement');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Modifier mon mot de passe</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
          <div className="form-grid">
            <div className="form-group full">
              <label>Mot de passe actuel</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="form-group full">
              <label>Nouveau mot de passe</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={strict ? '8' : '6'}
              />
              {newPassword && strict && (
                <div style={{ marginTop: '6px', fontSize: '12px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  <span style={{ color: hasMinLength ? 'var(--color-success)' : 'var(--text-muted)' }}>{hasMinLength ? '✓' : '○'} 8 caractères minimum</span>
                  <span style={{ color: hasUppercase ? 'var(--color-success)' : 'var(--text-muted)' }}>{hasUppercase ? '✓' : '○'} Une majuscule</span>
                  <span style={{ color: hasSpecial ? 'var(--color-success)' : 'var(--text-muted)' }}>{hasSpecial ? '✓' : '○'} Un caractère spécial</span>
                </div>
              )}
            </div>
            <div className="form-group full">
              <label>Confirmer le nouveau mot de passe</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={strict ? '8' : '6'}
              />
              {newPassword && confirmPassword && newPassword === confirmPassword && (
                <small style={{ color: 'light-dark(var(--color-success), var(--color-success-dark))', fontWeight: '600' }}>Les mots de passe correspondent</small>
              )}
              {newPassword && confirmPassword && newPassword !== confirmPassword && (
                <small style={{ color: 'light-dark(var(--color-error), var(--color-error-dark))', fontWeight: '600' }}>Les mots de passe ne correspondent pas</small>
              )}
            </div>
          </div>

          {error && (
            <div style={{ padding: '10px', background: 'var(--color-error-light)', border: '1px solid var(--color-error)', borderRadius: '6px', color: 'light-dark(var(--color-error), var(--color-error-dark))', fontSize: '13px', fontWeight: '600' }}>
              {error}
            </div>
          )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn-primary" disabled={loading || !passwordValid || newPassword !== confirmPassword}>
              {loading ? 'Modification...' : 'Valider'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Composant ResetPasswordModal - Réinitialisation admin
function ResetPasswordModal({ targetUser, onSave, onClose }) {
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const strict = !!targetUser.bypass_ip;
  const hasMinLength = newPassword.length >= (strict ? 8 : 6);
  const hasUppercase = !strict || /[A-Z]/.test(newPassword);
  const hasSpecial = !strict || /[^a-zA-Z0-9]/.test(newPassword);
  const passwordValid = hasMinLength && hasUppercase && hasSpecial;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!passwordValid) {
      setError('Le mot de passe ne respecte pas les critères de sécurité');
      return;
    }

    try {
      setLoading(true);
      await onSave(newPassword);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Réinitialiser le mot de passe</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
          <div className="form-grid">
            <div className="form-group full">
              <p style={{ margin: '0 0 12px', color: 'var(--text-secondary)', fontSize: '14px' }}>
                Définir un mot de passe provisoire pour <strong>{targetUser.prenom} {targetUser.nom}</strong>.
                L'utilisateur devra le changer à sa prochaine connexion.
              </p>
            </div>
            <div className="form-group full">
              <label>Nouveau mot de passe provisoire</label>
              <input
                type="text"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={strict ? '8' : '6'}
                autoFocus
                placeholder={strict ? '8 car. min, 1 majuscule, 1 spécial' : 'Minimum 6 caractères'}
              />
              {newPassword && strict && (
                <div style={{ marginTop: '6px', fontSize: '12px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  <span style={{ color: hasMinLength ? 'var(--color-success)' : 'var(--text-muted)' }}>{hasMinLength ? '✓' : '○'} 8 caractères minimum</span>
                  <span style={{ color: hasUppercase ? 'var(--color-success)' : 'var(--text-muted)' }}>{hasUppercase ? '✓' : '○'} Une majuscule</span>
                  <span style={{ color: hasSpecial ? 'var(--color-success)' : 'var(--text-muted)' }}>{hasSpecial ? '✓' : '○'} Un caractère spécial</span>
                </div>
              )}
            </div>
          </div>

          {error && (
            <div style={{ padding: '10px', background: 'var(--color-error-light)', border: '1px solid var(--color-error)', borderRadius: '6px', color: 'light-dark(var(--color-error), var(--color-error-dark))', fontSize: '13px', fontWeight: '600' }}>
              {error}
            </div>
          )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn-primary" disabled={loading || !passwordValid}>
              {loading ? 'Réinitialisation...' : 'Réinitialiser'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Modal Statut Parking
function StatutParkingModal({ statut, onSave, onClose }) {
  const [formData, setFormData] = useState(statut || {
    nom: '',
    couleur: '#94a3b8',
    ordre: 0,
    actif: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{statut ? 'Modifier le statut' : 'Nouveau statut parking'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>Couleur</label>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="color"
                  value={formData.couleur}
                  onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                />
                <input
                  type="text"
                  value={formData.couleur}
                  onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                  pattern="^#[0-9A-Fa-f]{6}$"
                  placeholder="#94a3b8"
                  style={{ width: '90px' }}
                />
                <span style={{
                  display: 'inline-block',
                  background: formData.couleur + '22',
                  color: formData.couleur,
                  border: `1px solid ${formData.couleur}66`,
                  padding: '3px 10px',
                  borderRadius: '10px',
                  fontSize: '12px',
                  fontWeight: '600'
                }}>
                  {formData.nom || 'Aperçu'}
                </span>
              </div>
            </div>

            <div className="form-group">
              <label>Ordre</label>
              <input
                type="number"
                value={formData.ordre}
                onChange={(e) => setFormData({ ...formData, ordre: parseInt(e.target.value) || 0 })}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={formData.actif}
                  onChange={(e) => setFormData({ ...formData, actif: e.target.checked })}
                />
                Actif
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn-primary">{statut ? 'Modifier' : 'Créer'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function StatutGarantieModal({ statut, onSave, onClose }) {
  const [formData, setFormData] = useState(statut || {
    nom: '',
    couleur: '#64748b',
    ordre: 0,
    actif: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{statut ? 'Modifier le statut garantie' : 'Nouveau statut garantie'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>Couleur</label>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="color"
                  value={formData.couleur}
                  onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                />
                <input
                  type="text"
                  value={formData.couleur}
                  onChange={(e) => setFormData({ ...formData, couleur: e.target.value })}
                  pattern="^#[0-9A-Fa-f]{6}$"
                  placeholder="#64748b"
                  style={{ width: '90px' }}
                />
                <span style={{
                  display: 'inline-block',
                  background: formData.couleur + '22',
                  color: formData.couleur,
                  border: `1px solid ${formData.couleur}66`,
                  padding: '3px 10px',
                  borderRadius: '10px',
                  fontSize: '12px',
                  fontWeight: '600'
                }}>
                  {formData.nom || 'Aperçu'}
                </span>
              </div>
            </div>

            <div className="form-group">
              <label>Ordre</label>
              <input
                type="number"
                value={formData.ordre}
                onChange={(e) => setFormData({ ...formData, ordre: parseInt(e.target.value) || 0 })}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={formData.actif}
                  onChange={(e) => setFormData({ ...formData, actif: e.target.checked })}
                />
                Actif
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn-primary">{statut ? 'Modifier' : 'Créer'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function MotifGarantieModal({ motif, onSave, onClose }) {
  const [formData, setFormData] = useState(motif || {
    nom: '',
    ordre: 0,
    actif: true
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{motif ? 'Modifier le motif garantie' : 'Nouveau motif garantie'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>Ordre</label>
              <input
                type="number"
                value={formData.ordre}
                onChange={(e) => setFormData({ ...formData, ordre: parseInt(e.target.value) || 0 })}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={formData.actif}
                  onChange={(e) => setFormData({ ...formData, actif: e.target.checked })}
                />
                Actif
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn-primary">{motif ? 'Modifier' : 'Créer'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Modal Action Parking
function ActionParkingModal({ action, onSave, onClose }) {
  const [formData, setFormData] = useState(action || {
    nom: '',
    ordre: 0,
    actif: true,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{action ? 'Modifier l\'action parking' : 'Nouvelle action parking'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nom *</label>
              <input
                type="text"
                value={formData.nom}
                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                required
                autoFocus
                placeholder="Ex : Client à relancer"
              />
            </div>

            <div className="form-group">
              <label>Ordre</label>
              <input
                type="number"
                value={formData.ordre}
                onChange={(e) => setFormData({ ...formData, ordre: parseInt(e.target.value) || 0 })}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  checked={formData.actif}
                  onChange={(e) => setFormData({ ...formData, actif: e.target.checked })}
                />
                Actif
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn-primary">{action ? 'Modifier' : 'Créer'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Dashboard;